import { Component, OnInit, AfterViewInit, HostListener} from '@angular/core';
import {ApiService} from '../api.service';
import {CommonService} from '../common.service';
import {ActivatedRoute, Router} from '@angular/router';
import {trigger, state, style, animate, transition, query, keyframes, group} from '@angular/animations';

declare var $: any;

@Component({
  selector: 'app-case-practice-influence-main',
    animations: [
        trigger('informationAnimation', [
          state('showInformation', style({opacity: 1, transform: 'scale(1)'})),
          state('hideInformation', style({opacity: 0, transform: 'scale(0)'})),
          transition('hideInformation => showInformation', animate('200ms', keyframes([
              style({opacity: 0, transform: 'scale(0)'}),
              style({opacity: 0.2, transform: 'scale(0.2)'}),
              style({opacity: 0.4, transform: 'scale(0.4)'}),
              style({opacity: 0.6, transform: 'scale(0.6)'}),
              style({opacity: 0.8, transform: 'scale(0.8)'}),
              style({opacity: 1, transform: 'scale(1)'}),
          ]))),
          transition('showInformation => hideInformation', animate('200ms', style({opacity: 0})))
        ]),
        trigger('peopleAnimation', [
            state('showPeople', style({opacity: 1})),
            state('hidePeople', style({opacity: 0})),
            transition('hidePeople => showPeople', animate('200ms', style({opacity: 1}))),
            transition('showPeople => hidePeople', animate('200ms', style({opacity: 0})))
        ]),
        trigger('telephoneAnimation', [
            state('showBox', style({opacity: 1})),
            state('hideBox', style({opacity: 0})),
            transition('hideBox => showBox', animate('200ms', keyframes([
              style({opacity: 1, transform: 'translate(-100%) rotate(-60deg)'}),
              style({opacity: 1, transform: 'translate(-75%) rotate(-45deg)'}),
              style({opacity: 1, transform: 'translate(-50%) rotate(-30deg)'}),
              style({opacity: 1, transform: 'translate(-25%) rotate(-15deg)'}),
              style({opacity: 1, transform: 'translate(0%) rotate(00deg)'}),
            ]))),
            transition('showBox => hideBox', animate('200ms', style({opacity: 0})))
        ]),
        trigger('boxAnimation', [
            state('showBox', style({opacity: 1})),
            state('hideBox', style({opacity: 0})),
            transition('hideBox => showBox', animate('300ms', style({opacity: 1}))),
            transition('showBox => hideBox', animate('200ms', style({opacity: 0})))
        ]),
        trigger('hintAnimation', [
            state('showHint', style({opacity: 1})),
            state('hideHint', style({opacity: 0})),
            transition('hideHint => showHint', animate('200ms', style({opacity: 1}))),
            transition('showHint => hideHint', animate('200ms', style({opacity: 0})))
        ]),
        trigger('optionWrapAnimation', [
            state('hideOptionWrap', style({transform: 'translate(-200%)', opacity: 0})),
            state('showOptionWrap', style({transform: 'translate(0%)', opacity: 1})),
            transition('hideOptionWrap => showOptionWrap', animate('600ms', keyframes([
                    style({transform: 'translate(-100%)', opacity: 0.1}),
                    style({transform: 'translate(-80%)', opacity: 0.1}),
                    style({transform: 'translate(-60%)', opacity: 0.3}),
                    style({transform: 'translate(-50%)', opacity: 0.4}),
                    style({transform: 'translate(-40%)', opacity: 0.5}),
                    style({transform: 'translate(-30%)', opacity: 0.55}),
                    style({transform: 'translate(-20%)', opacity: 0.6}),
                    style({transform: 'translate(-10%)', opacity: 0.8}),
                    style({transform: 'translate(0%)', opacity: 1})
                ])
            ))
        ]),
        trigger('soldAnimation', [
          state('showSold', style({opacity: 1})),
          state('hideSold', style({opacity: 0})),
          transition('hideSold => showSold', [
            query('#finger', style({transform: 'translate(300%)', opacity: 1})),
            query('#soldout1', style({opacity: 0})),
            query('#soldout2', style({transform: 'translate(100%)', opacity: 0})),
            style({opacity: 1}),
            group([
              query('#soldout1', animate('1s', keyframes([
                style({opacity: 0}),
                style({opacity: 1}),
                style({opacity: 1}),
                style({opacity: 1}),
                style({opacity: 1}),
                style({transform: 'translate(-20%)'}),
                style({transform: 'translate(-40%)'}),
                style({transform: 'translate(-60%)'}),
                style({transform: 'translate(-80%)'}),
                style({transform: 'translate(-100%)'}),
              ]))),
              query('#soldout2', animate('1s', keyframes([
                style({transform: 'translate(100%)', opacity: 0}),
                style({transform: 'translate(100%)', opacity: 0}),
                style({transform: 'translate(100%)', opacity: 0}),
                style({transform: 'translate(100%)', opacity: 0}),
                style({transform: 'translate(100%)', opacity: 0}),
                style({transform: 'translate(80%)', opacity: 1}),
                style({transform: 'translate(60%)', opacity: 1}),
                style({transform: 'translate(40%)', opacity: 1}),
                style({transform: 'translate(20%)', opacity: 1}),
                style({transform: 'translate(0%)', opacity: 1}),
              ]))),
              query('#finger', animate('1s', keyframes([
                style({transform: 'translate(300%)', opacity: 1}),
                style({transform: 'translate(300%)', opacity: 1}),
                style({transform: 'translate(300%)', opacity: 1}),
                style({transform: 'translate(0%)', opacity: 1}),
                style({transform: 'translate(-20%)', opacity: 1}),
                style({transform: 'translate(-40%)', opacity: 1}),
                style({transform: 'translate(-60%, 5%) rotate(-5deg)', opacity: 1}),
                style({transform: 'translate(-90%, 20%) rotate(-15deg)', opacity: 1}),
                style({transform: 'translate(-120%, 30%) rotate(-25deg)', opacity: 1}),
                style({transform: 'translate(-150%, 40%) rotate(-40deg)', opacity: 1}),
              ]))),
            ])
          ]),
          transition('showSold => hideSold', animate('200ms', style({opacity: 0})))
      ]),
    ],
  templateUrl: './case-practice-influence-main.component.html',
  styleUrls: ['./case-practice-influence-main.component.css', ]
})
export class CasePracticeInfluenceMainComponent implements OnInit, AfterViewInit {

  @HostListener('window:popstate', ['$event']) onPopState(){
    if (this.audio){
      this.audio.pause();
    }
  }

  questions: any;
  step= 1;
  userType: string;

  currentWord: string;
  currentHint: string;
  currentItem: any;
  currentRole: string;
  currentExpression: string;
  oldExpression: string;
  currentOptions: any;

  nextQuestionId: number;
  currentCaseId: number;

  clickable: boolean;

  conversationHistory: any;

  practiceId: number;
  practiceMetaId: number;
  exerciseId: number;
  learningPathId: number;
  itemTemp: any;
  informationStatus: string;
  normalStatus: string;
  acceptStatus: string;
  awkwardStatus: string;
  indifferentStatus: string;
  resistStatus: string;
  womanStatus: string;
  womanMessage: string;
  boxOneStatus: string;
  boxTwoStatus: string;
  optionWrapStatus: string;
  hintStatus: string;
  buttonStatus: string;
  reviewBtnStatus: string;
  telephoneStatus: string;
  soldShow: boolean;
  optionsTemp: any;
  optionIndexTemp: any;
  nextQuestionIdTemp: any;
  oldItemTemp: any;
  oldOptionIndexTemp: any;

  additionType: number;

  audioPlayed: boolean;

  msgCharacter: number;
  msgTimeout: any;

  optionClick: boolean; // 监听长按选项行为
  optionOnClick: boolean; // 监听用户是否按键
  optionClickTimeout: any; // 长按选项timeout
  currentFakeWord: string;
  letterClick: boolean;
  currentContainer: any;
  audio: any;
  assetsRoute = '../../assets';
  exerciseMetaId: number;
  theme= 'influence-one';
  progress= 0;
  currentProgress= 0;
  flag= false;
  type: string;
  constructor(
    private commonService: CommonService,
    private apiService: ApiService,
    private route: ActivatedRoute,
    private router: Router
  ) { }

  ngOnInit() {
    this.assetsRoute = this.commonService.setAssetsRoute(this.assetsRoute);
    const that = this;
    this.userType = window.sessionStorage.getItem('userType');
    this.informationStatus = 'hideInformation';
    this.normalStatus = 'hidePeople';
    this.acceptStatus = 'hidePeople';
    this.awkwardStatus = 'hidePeople';
    this.indifferentStatus = 'hidePeople';
    this.womanStatus = 'hidePeople';
    this.womanMessage = 'hideBox';
    this.resistStatus = 'hidePeople';
    this.boxOneStatus = 'hideBox';
    this.boxTwoStatus = 'hideBox';
    this.optionWrapStatus = 'hideOptionWrap';
    this.hintStatus = 'hideHint';
    this.buttonStatus = 'hideBox';
    this.reviewBtnStatus = 'hideBox';
    this.telephoneStatus = 'hideBox';
    this.soldShow = false;
    this.clickable = false;
    this.currentFakeWord = '';
    this.msgCharacter = 0;
    this.optionClick = false;
    this.optionOnClick = false;
    this.optionClickTimeout = null;
    this.letterClick = false;
    this.currentContainer = null;
    this.audio = null;
    this.practiceMetaId = Number(window.sessionStorage.getItem('visitorPracticeMetaId'));
    this.route.queryParams.subscribe(queryParams => {
        this.type = queryParams['type'];
    });
    this.route.params.subscribe(params => {
      this.practiceId = params['practiceId'];
      this.exerciseId = params['exerciseId'];
      console.log(this.exerciseId);
      this.learningPathId = params['learningPathId'];
      this.exerciseMetaId = $('#exerciseMetaId').val();
      this.apiService.ajax({
        'type': 'get',
        'url': '/api/exercises/' + this.exerciseId
      }).subscribe(result => {
        this.questions = result.questions;
        this.conversationHistory = [];
        this.currentCaseId = result.id;
        //全局变量初始化为 null
   			window['exercises' + this.currentCaseId] = null;
        this.exerciseInit();
      });
      /*this.questions = this.getMockData().questions;
      this.conversationHistory = [];
      this.currentCaseId = this.getMockData().id;
      this.exerciseInit();
      console.log(this.questions);
      */
     //判断传过去的主题
     if (this.exerciseMetaId == 71){
        this.theme = 'influence-one';
      }

     this.apiService.getLearningPathMetaIdByPathId(this.learningPathId.toString()).subscribe(res => {
       const that = this;
       if (res.data) {
         that.getLearningPathSubItems(res.data).then(result => {
           that.practiceMetaId = result.subItems[2].practiceMetaId;
         });
       }
     });
    });
  }
    //查询能力模块信息
    getLearningPathSubItems(learningPathMetaId){
        return this.apiService.ajax({
          'type': 'GET',
          'url': 'ddilearner/v2/learningpathes/' + learningPathMetaId,
        }).toPromise();
      }
  ngAfterViewInit(){
    this.commonService.initPage({
        'backgroundColor': 'white'
    });
    document.oncontextmenu = function (e) {
        e.preventDefault();
    };
  }

  //获取进度
  getProgress(){
    this.apiService.getProgress(this.exerciseId).subscribe(result => {
      console.log(result);
      this.currentProgress = result.progress;
      this.progress = result.progress;
      console.log(this.progress);
    });
}

    /*  逻辑F
    step 0: 初始化, 用户再次点击屏幕, => step 2
    step 1: 显示我说的话, 再次点击 => step 2
    step 2: 显示当前节点秦飞说的话再次点击，如果有导师提示语 => step 3 如果没有导师提示语并有选项 => step 4 如果没有导师提示语并没有选项 => step 5
    step 3: 显示导师提示语, 再次点击 如果有选项 => step 4 如果没有选项 => step 5
    step 4: 显示选项, 点击选项后 => step 1
    step 5; 决策树终止，显示生成报告按钮
  */
  screenClick(){
    let that = this,
      /*  判断逻辑
        *  当用户为访客进行情景模拟到特定断点时，
        *  将当前点评文字和breakWordArr里的元素进行匹配，
        *  如果匹配成功breakTarget为数组下标，弹出注册提示框
        *  如果匹配失败breakTarget为-1，继续进行模拟
        */
      breakTarget = -1, //访客情景模拟中断标签
      breakWordArr = [
        '老秦很忙，客套时间不要太长，赶快说明来访目的吧！',
        '终于进入正题！想想该如何跟对方沟通你的难题。',
        '一味给对方戴高帽并不可取，赶紧探讨具体问题吧。',
        '在对方看来，你的问题优先级不高，怎么破？',
        '你急得焦头烂额，对方却并不重视。该怎么让对方意识到问题的严重性呢？'
      ];

    if (this.letterClick){
      this.showFullText(this.currentContainer);
      return;
    }

    //季经理头像特殊处理
    if (this.boxOneStatus == 'showBox' && this.womanStatus == 'showPeople'){
    	this.boxOneStatus = 'hideBox';
    	this.womanMessage = 'showBox';
    	return false;
    }else{
    	this.womanMessage = 'hideBox';
    }

    if (!this.clickable){
      console.log('clickable');
      return;
    }

    // console.log('2:'+this.step);
    // console.log(that.currentWord);

    if (this.step == 0){
      this.clickable = false;
      this.informationStatus = 'hideInformation';
      setTimeout(function () {
        that.peopleConversion(that.currentExpression, 1);
        that.boxTwoStatus = 'showBox';
        setTimeout(function(){
          that.msgCharacter = 0;
          that.getLetterByLetter($('#talkBoxContent2'));
        }, 200);
        that.conversationHistory.push({
          'role': '秦飞',
          'comment': that.currentWord
        });
        setTimeout(function () {
          that.step = 2;
          that.clickable = true;
        }, 1700);
      }, 500);
    }else if (this.step == 1){
      this.clickable = false;
      this.oldExpression = this.currentExpression;
      this.currentExpression = this.currentItem.expression;
      if (this.additionType == 0){
        this.boxOneStatus = 'hideBox';
        setTimeout(function(){
          $('#talkBoxContent1').html('');
        }, 200);
        if (this.oldExpression != this.currentExpression){
          this.peopleConversion(this.oldExpression, 0);
        }
      }else if (this.additionType == 1){
        this.telephoneStatus = 'hideBox';
        $('#play').fadeOut(200);
        $('#playWrap').fadeOut(200);
      }else if (this.additionType == 2){
        this.boxOneStatus = 'hideBox';
        $('#talkBoxContent1').html('');
        this.peopleConversion('季宁', 0);
      }else if (this.additionType == 3){
        this.telephoneStatus = 'hideBox';
        this.soldShow = false;
      }
      setTimeout(function () {
        that.currentWord = that.currentItem.description;
        that.currentRole = '秦飞';
        that.conversationHistory.push({
          'role': that.currentRole,
          'comment': that.currentWord
        });
        that.currentFakeWord = that.currentWord;
        that.boxTwoStatus = 'showBox';
        setTimeout(function(){
          that.msgCharacter = 0;
          that.getLetterByLetter($('#talkBoxContent2'));
        }, 200);
        if (that.oldExpression != that.currentExpression && that.additionType == 0 || that.additionType == 1 || that.additionType == 2 || that.additionType == 3){
          that.peopleConversion(that.currentExpression, 1);
        }
        setTimeout(function () {
          that.step = 2;
          that.clickable = true;
        }, 1700);
      }, 500);
    }else if (this.step == 2){
      this.clickable = false;
      // console.log(this.userType+';'+that.currentWord);
        this.boxTwoStatus = 'hideBox';
        setTimeout(function(){
          $('#talkBoxContent2').html('');
        }, 200);
        this.currentHint = this.currentItem.directorComment;
        if (this.currentHint != ''){
          this.currentRole = '导师';
          setTimeout(function(){
            that.currentWord = that.currentHint;
            that.currentFakeWord = that.currentWord;
            that.hintStatus = 'showHint';
            setTimeout(function(){
              setTimeout(function(){
                that.step = 3;
                that.clickable = true;
              }, 1000);
              that.conversationHistory.push({
                'role': '导师点评',
                'comment': that.currentWord
              });
            }, 250);
          }, 500);
        }else{
          this.currentOptions = this.currentItem.options.sort(function(){
            return 0.5 - Math.random();
          });
          if (this.currentOptions.length > 0){
            this.peopleConversion(this.currentExpression, 0);
            setTimeout(function (){
              that.optionWrapStatus = 'showOptionWrap';
              setTimeout(function(){
                that.step = 4;
              }, 200);
            }, 500);
          }else{
            this.buttonStatus = 'showBox';
            setTimeout(function () {
              that.step = 5;
              that.clickable = false;
            }, 200);
            console.log('end1');

          }
      }
    }else if (this.step == 3){
      this.clickable = false;
      breakTarget = $.inArray(that.currentWord, breakWordArr);
      // console.log(breakTarget);
      if (this.userType  && breakTarget !== -1){
        $('#shade2').fadeIn();
        $('#tip2').fadeIn();
      }else{
        this.currentOptions = this.currentItem.options.sort(function(){
          return 0.5 - Math.random();
        });
        if (this.currentOptions.length > 0){
          this.hintStatus = 'hideHint';
          setTimeout(function () {
            that.optionWrapStatus = 'showOptionWrap';
            that.peopleConversion(that.currentExpression, 0);
            setTimeout(function () {
              that.step = 4;
            }, 500);
          }, 500);
        }else{
          setTimeout(function () {
            that.buttonStatus = 'showBox';
            that.currentProgress = 100;
            setTimeout(function () {
              that.step = 5;
              that.clickable = false;
            }, 500);
            console.log('end2');
            console.log(that.exerciseId);
            // this.currentProgress=100
            // that.currentProgress=100
            console.log(this.currentProgress);
            that.apiService.saveProgress({exerciseId: that.exerciseId, progress: 100}).subscribe(result => {
                console.log(result);
            });
          }, 500);
        }
      }
    }else if (this.step == 11){
      this.clickable = false;
      this.boxOneStatus = 'showBox';
      setTimeout(function(){
        that.msgCharacter = 0;
        that.getLetterByLetter($('#talkBoxContent1'));
      }, 200);
      setTimeout(function () {
        that.step = 12;
        that.clickable = true;
      }, 1700);
    }else if (this.step == 12){
      this.clickable = false;
      this.boxOneStatus = 'hideBox';
      setTimeout(function(){
        $('#talkBoxContent1').html('');
      }, 200);
      $('#play').fadeIn(200);
      $('#playWrap').fadeIn(200);
    }else if (this.step == 21){
      this.clickable = false;
      this.boxOneStatus = 'showBox';
      setTimeout(function(){
        that.msgCharacter = 0;
        that.getLetterByLetter($('#talkBoxContent1'));
      }, 200);
      setTimeout(function () {
        that.step = 22;
        that.clickable = true;
      }, 1700);
    }else if (this.step == 22){
      this.clickable = false;
      this.boxOneStatus = 'hideBox';
      $('#talkBoxContent1').html('');
      this.soldShow = true;
      setTimeout(function () {
        that.clickable = true;
        that.step = 1;
        that.additionType = 3;
      }, 1500);
    }
  }

  exerciseInit(){
    this.getProgress(); //获取进度
    const that = this;
    this.currentFakeWord = '';
    this.msgCharacter = 0;
    this.itemTemp = this.questions[0];

    do{
      this.optionsTemp = this.itemTemp.options;
      this.optionIndexTemp = this.getSelectedOptionIndex(this.optionsTemp);
      if (this.optionIndexTemp != -1){
        this.nextQuestionIdTemp = this.optionsTemp[this.optionIndexTemp].nextQuestionId;
        this.conversationHistory.push({
          'role': '秦飞',
          'comment': this.itemTemp.description
        });
        if (this.itemTemp.directorComment != ''){
          this.conversationHistory.push({
            'role': '导师点评',
            'comment': this.itemTemp.directorComment
          });
        }
        this.conversationHistory.push({
          'role': '我',
          'comment': this.optionsTemp[this.optionIndexTemp].description
        });
        this.setItemTemp(this.nextQuestionIdTemp);
      }else{
        break;
      }
    }while (true);

    if (this.userType){
      this.conversationHistory.length = 0;
    }

    if (this.conversationHistory.length != 0){
      this.step = 1;
      const addition = this.oldItemTemp.options[this.oldOptionIndexTemp].addition;
      if (addition == ''){
          this.additionType = 0;
      }else if (addition == '语音播放'){
          this.additionType = 1;
      }else if (addition == '季宁人像'){
          this.additionType = 2;
      }else if (addition == '手持手机展示照片'){
          this.additionType = 3;
      }
      this.currentItem = this.itemTemp;
      this.currentRole = '我';
      this.currentWord = this.oldItemTemp.options[this.oldOptionIndexTemp].description;
      this.currentFakeWord = this.currentWord;
      this.currentExpression = this.oldItemTemp.expression;
      if (addition == ''){
          that.peopleConversion(that.currentExpression, 1);
          that.boxOneStatus = 'showBox';
          setTimeout(function(){
              that.msgCharacter = 0;
              that.getLetterByLetter($('#talkBoxContent1'));
          }, 200);
          setTimeout(function () {
              that.clickable = true;
              that.optionClick = false;
          }, 1700);
      }else if (addition == '语音播放'){
              that.telephoneStatus = 'showBox';
              setTimeout(function () {
                  that.step = 11;
                  that.clickable = true;
                  that.optionClick = false;
              }, 1000);
      }else if (addition == '季宁人像'){
              that.peopleConversion('季宁', 1);
              that.boxOneStatus = 'showBox';
              setTimeout(function(){
                  that.msgCharacter = 0;
                  that.getLetterByLetter($('#talkBoxContent1'));
              }, 200);
              setTimeout(function () {
                  that.step = 1;
                  that.additionType = 2;
                  that.clickable = true;
                  that.optionClick = false;
              }, 1700);
      }else if (addition == '手持手机展示照片'){
              that.telephoneStatus = 'showBox';
              setTimeout(function () {
                  that.step = 21;
                  that.clickable = true;
                  that.optionClick = false;
              }, 1000);
      }
      that.reviewBtnStatus = 'showBox';
    }else{
      this.step = 0;
      this.currentItem = this.questions[0];
      this.currentRole = '秦飞';
      this.currentExpression = this.currentItem.expression;
      this.currentWord = this.currentItem.description;
      this.currentFakeWord = this.currentWord;
      this.currentOptions = this.currentItem.options.sort(function(){
										            return 0.5 - Math.random();
										        });
      that.informationStatus = 'showInformation';
      that.reviewBtnStatus = 'showBox';
      setTimeout(function () {
        that.clickable = true;
      }, 200);
    }
    this.conversationHistory.unshift({
        'role': '店长笔记',
        'comment': '实体店的经营状况面临不少问题，包括物流配送、营销、客户服务等等。<br/>当务之急是要解决影响最严重的问题。<br/><br/>我要两周内解决物流问题：<br/>1.热门产品补给慢<br/>2.“送到家“延误严重<br/><br/>Sticky Note:<br/>约时间和物流主管秦飞见面！',
        'type': 9,
        'mode': 0
    }, {
      'role': '人物介绍',
      'comment': '秦飞：物流部主管<br/><br/>&nbsp;-&nbsp;在公司物流部门已工作八、九年，一手创建了现在的物流体系。<br/>&nbsp;-&nbsp;做事稳扎稳打，循序渐进，不喜欢太激进的做法。<br/>&nbsp;-&nbsp;擅长抓大放小，喜欢说：“做事情要看大局嘛！最重要的资源当然要放在最能产生价值的事情上”。<br/>&nbsp;-&nbsp;电商经验丰富，但是实体门店？很抱歉，没做过。<br/>&nbsp;-&nbsp;善交际、口碑好。特别是在线部门，一直称赞秦飞团队配合度很高。<br/>&nbsp;-&nbsp;最近是线上旺季，物流部门很忙。你约了秦飞两星期，他才和同意你见面。',
      'type': 9,
      'mode': 0
    });
  }

  onOptionMouseDown(i, event){
    if (this.optionClick == true || this.optionOnClick == true){
      return false;
    }
    const that = this,
        pressing = $(event.target).children('.pressing'),  // 选项背景进度div
        pressingOption = pressing.children('.pressingOption'), // 选项背景进度div中的文字
        pressingWidth = $(event.target).width(), // 选项宽度
        pressingHeight = $(event.target).height(), // 选项高度
        pressingOuterHeight = $(event.target).outerHeight(),  // 选项真实高度, 包括margin, padding
        pressingOffset = $(event.target).offset(); // 选项在屏幕的位置
    // 按选项少于0.45s, 则不响应
    this.optionClick = false;
    this.optionOnClick = true;
    // 设置选项动画参数
    pressingOption.width(pressingWidth);
    pressingOption.height(pressingHeight);
    pressing.width(0);
    pressing.height(pressingOuterHeight),
    pressing.show();
    pressing.offset({top: pressingOffset.top, left: pressingOffset.left});
    // 选项背景动画
    pressing.animate({
      width: $(event.target)[0].clientWidth
    }, this.type ? 300 : 500, 'linear');
    // 按中选项到达0.45s, 响应出现动画,  跳入下一个页面
    this.optionClickTimeout = setTimeout(function(){
    // 长按响应
    that.optionClick = true;
    // 设置下一页面参数
    // that.currentRole = '我';
    // that.currentComment = that.currentNode.option[i].multi_option_comment;
    // 隐藏背景色
    pressing.animate({width: 0}, 1);
    pressing.hide();
    // 进入选中按钮动画
    that.currentWord = that.currentOptions[i].description;
    that.currentOptions[i].description = '';
    $(event.target).addClass('optionLongPress');
    // 按键之后的动画
    $(event.target).find('.loading').fadeIn(200);
    // 隐藏文字
    // 其他按钮的消失时间, 设置比选中按钮timeout时间长500ms, 维持按钮相对位置
    that.apiService.answerExerciseQuestion('' + that.currentCaseId + '', that.currentItem.id, that.currentOptions[i].id).subscribe(practice => {
         //全局缓存最后提交数据
        const exerciseConfig = {
          questionId: that.currentItem.id,
          optionId: that.currentOptions[i].id,
          exercisesId: that.currentCaseId
        };
        window['exercises' +  that.currentCaseId] = exerciseConfig;
        that.currentFakeWord = that.currentWord;
        that.conversationHistory.push({
            'role': '我',
            'comment': that.currentWord
        });
        $('.optionItem').not($(event.target)).fadeOut(2500);
        // 保持选中按钮动画2s, 跳转动画
        setTimeout(function (){
            // 移出按钮动画
            $(event.target).removeClass('optionLongPress');
            // that.step = 2.5;
            // that.apiService.answerExerciseQuestion("" + that.currentCaseId + "", that.currentItem.id, that.currentOptions[i].id).subscribe(practice => {
            that.clickable = false;
            that.nextQuestionId = that.currentOptions[i].nextQuestionId;
            that.setCurrentItem(that.nextQuestionId);
            that.optionWrapStatus = 'hideOptionWrap';
            if (that.currentOptions[i].addition == ''){
                setTimeout(function () {
                    that.peopleConversion(that.currentExpression, 1);
                    that.boxOneStatus = 'showBox';
                    setTimeout(function(){
                        that.msgCharacter = 0;
                        that.getLetterByLetter($('#talkBoxContent1'));
                    }, 200);
                    setTimeout(function () {
                        that.step = 1;
                        that.additionType = 0;
                        that.clickable = true;
                        that.optionClick = false;
                    }, 1700);
                }, 500);
            }else if (that.currentOptions[i].addition == '语音播放'){
                console.log('语音播放');
                setTimeout(function () {
                    that.telephoneStatus = 'showBox';
                    setTimeout(function () {
                        that.step = 11;
                        that.clickable = true;
                        that.optionClick = false;
                    }, 1000);
                }, 500);
            }else if (that.currentOptions[i].addition == '季宁人像'){
                console.log('季宁人像');
                setTimeout(function () {
                    that.peopleConversion('季宁', 1);
                    that.boxOneStatus = 'showBox';
                    setTimeout(function(){
                        that.msgCharacter = 0;
                        that.getLetterByLetter($('#talkBoxContent1'));
                    }, 200);
                    setTimeout(function () {
                        that.step = 1;
                        that.additionType = 2;
                        that.clickable = true;
                        that.optionClick = false;
                    }, 1700);
                }, 500);
            }else if (that.currentOptions[i].addition == '手持手机展示照片'){
                console.log('手持手机展示照片');
                setTimeout(function () {
                    that.telephoneStatus = 'showBox';
                    setTimeout(function () {
                        that.step = 21;
                        that.clickable = true;
                        that.optionClick = false;
                    }, 1000);
                }, 500);
            }
            // });
        }, 2000); // end of second setTimeout
    });
    }, 450); // end of first setTimeout
  } //end of onOptionMouseDown

  onOptionMouseUp(event){
    this.optionOnClick = true;
    setTimeout(() => {
      this.optionOnClick = false;
    }, 300);
    // 如果已经触发按钮事件, 忽略放松按钮行为
    if (this.optionClick == true){
      return true;
    }
    const pressing = $(event.target).children('.pressing');
    // 调整宽度为0
    setTimeout(() => {
      clearTimeout(this.optionClickTimeout);
      pressing.stop().animate({
        width: 0
      }, 300, 'linear');
    }, this.type ? 300 : 0);
  }


  getSelectedOptionIndex(options){
    let temp = -1;
    options.forEach(function (item, index) {
      if (item.selected){
        temp = index;
      }
    });
    return temp;
  }

  setCurrentItem(questionId){
    const that = this;
    this.questions.forEach(function (item, index) {
      if (item.id == questionId){
        that.currentItem = item;
        that.setCurrentProgress(that.currentItem);
        return;
      }
    });
  }

  setCurrentProgress(currentItem){
    const percent = Math.floor(100 / 29 * 100) / 100; //3.44
      this.progress += percent;
      console.log(this.progress);
      this.currentProgress = Math.round(this.progress);
      this.apiService.saveProgress({exerciseId: this.exerciseId, progress: this.currentProgress}).subscribe();

	}

    close($event){
        this.practiceMetaId = 9;
		$event.stopPropagation();
        const link = [ this.learningPathId,  this.practiceMetaId, 'case-practice-influence', ];
        if (this.type){
            this.router.navigate(link, {queryParams: {type: 'huatek'}});
        }else{
            this.router.navigate(link);
        }
        const exerciseMetaId = $('#exerciseMetaId').val();
        this.apiService.learingTime({learningPathMetaId: localStorage.getItem('learningPathMetaId'), module: '情景模拟', courseUnit: '', type: 2, btnName: exerciseMetaId, userId: localStorage.getItem('userId')}).subscribe(result => {
            console.log(result);
          });
          console.log(exerciseMetaId);
          this.commonService.sendPostMessage(1, 'isPractice' + 'Complete');
	}

  setItemTemp(questionId){
    const that = this;
    this.questions.forEach(function (item, index) {
      if (item.id == questionId){
        that.oldItemTemp = that.itemTemp;
        that.oldOptionIndexTemp = that.optionIndexTemp;
        that.itemTemp = item;
        return;
      }
    });
  }

  reviewTableClick($event, i){
    $event.stopPropagation();
    this.conversationHistory[i].mode = (this.conversationHistory[i].mode + 1) % 2;
  }

  peopleConversion(expression, type){
    let status;
    if (type == 0){
      status = 'hidePeople';
    }else if (type == 1){
      status = 'showPeople';
    }
    if (expression == '正常'){
      this.normalStatus = status;
    }else if (expression == '抗拒'){
      this.resistStatus = status;
    }else if (expression == '接受'){
      this.acceptStatus = status;
    }else if (expression == '冷漠'){
      this.indifferentStatus = status;
    }else if (expression == '为难'){
      this.awkwardStatus = status;
    }else if (expression == '季宁'){
      this.womanStatus = status;
    }
  }

  reviewConversation($event){
    $event.stopPropagation();
    if (this.reviewBtnStatus == 'hideBox'){
      return;
    }
    $('#shade').fadeIn(50);
    $('#reviewBox').fadeIn();
    $('#closeBtn').fadeIn();
    this.clickable = false;
  }

  playAudio($event){
  	//阻止冒泡,音频二次播放
    $event.stopPropagation();
  	if (this.audioPlayed){
      return;
    }
  	const playObj = $('#play');
  	const playProcess = $('#playBarInner');
  	//进度每次从 0 开始
  	playProcess.stop().css('width', '0%');

    const that = this;
    this.audio = new Audio();
    this.audioPlayed = true;
    this.audio.src = 'assets/audio/complain.wav';
    this.audio.play();

    //播放过程不允许跳过
    that.clickable = false;
    playObj.attr('src', '../../assets/picture/casepracticeinfluence/pause.png');

    this.audio.addEventListener('playing', function(){
      playProcess.animate({width: '100%'}, 19000);
    });

    this.audio.addEventListener('ended', function () {
      that.clickable = true;
      that.step = 1;
      that.additionType = 1;
      //播放结束后可以继续播放
    	that.audioPlayed = false;
    	playObj.attr('src', '../../assets/picture/casepracticeinfluence/play.png');
    });

  }

  closeTip($event){
    $event.stopPropagation();
    $('#shade').fadeOut();
    $('#reviewBox').fadeOut();
    $('#closeBtn').fadeOut();
    this.clickable = true;
  }

  linkToReport(){
    if (this.buttonStatus == 'hideBox'){
      return;
    }
    this.apiService.finishExercise('' + this.currentCaseId + '').subscribe(practice => {
        this.apiService.getKasInfos(this.exerciseId, this.practiceId).subscribe((result) => {
            console.log(111111, result);
            if (result){
              this.apiService.getLevelInfo(result.reports[0]);
            }
          });
      // this.commonService.learningPortEventLogByCandy({'learningPathMetaId':localStorage.getItem('learningPathMetaId'),'module':'退出情景模拟1'}).then();
    const link = ['case-practice-report-new', this.practiceId, this.exerciseId, this.learningPathId];
    if (this.type){
        this.router.navigate(link, {queryParams: {type: 'huatek'}});
    }else{
        this.router.navigate(link);
    }
      const exerciseMetaId = $('#exerciseMetaId').val();
      this.apiService.learingTime({learningPathMetaId: localStorage.getItem('learningPathMetaId'), module: '情景模拟', courseUnit: '', type: 2, btnName: exerciseMetaId, userId: localStorage.getItem('userId')}).subscribe(result => {
        console.log(result);
      });
      console.log(exerciseMetaId);
      this.commonService.sendPostMessage(2, 'isPractice' + 'Complete');
    });

  }

  getLetterByLetter(container){
  	//container.html(this.currentWord);
  	//return false;
    const that = this;
    this.letterClick = true;
    this.currentContainer = container;
    this.msgTimeout = setTimeout(function(){
      that.msgCharacter++;
      const type = that.currentWord.substring(0, that.msgCharacter);
      container.html(type);
      that.getLetterByLetter(container);
      if (that.msgCharacter == that.currentWord.length){
        that.letterClick = false;
        clearTimeout(that.msgTimeout);
      }
    }, 30);
    // end of setTimeout
  } // end of getLetterByLetter

  showFullText(container){
    const that = this;
    setTimeout(function(){
      that.letterClick = false;
    }, 750);
    clearTimeout(this.msgTimeout);
    container.html(this.currentWord);
  } // end of showFullText

  hideTip2(){
    $('#shade2').fadeOut();
    $('#tip2').fadeOut();
  }

  try(){
    $('body').css('height', '100%');
    const link = ['form', '3'];
    this.router.navigate(link);
  }

  returnList(){
    if (!this.practiceMetaId){
      this.practiceMetaId = 9;
    }
    const link = [this.learningPathId, this.practiceMetaId, 'case-practice-influence'];
    this.router.navigate(link);
  }

  /*getMockData(){
      return {
          "id": 2757,
          "name": "\u5f71\u54cd\u529b",
          "description": "",
          "status": 1,
          "startTime": "2018-07-11 13:37:58",
          "questions": [{
              "id": 3301,
              "description": "\u5feb\u8bf7\u8fdb\uff01\u54ce\u5440\u5b9e\u5728\u62b1\u6b49\uff0c\u65e9\u5c31\u6536\u5230\u4f60\u7684\u90ae\u4ef6\u4e86\uff0c\u4f46\u6700\u8fd1\u5b9e\u5728\u592a\u5fd9\uff0c\u9700\u6c42\u591a\u5f97\u4e0d\u5f97\u4e86\u3002\u7ed3\u679c\u4e00\u76f4\u62d6\u5230\u4eca\u5929\uff0c\u6020\u6162\u4e86\u3001\u6020\u6162\u4e86\u3002",
              "options": [{
                  "id": 3,
                  "point": 1,
                  "description": "\u6ca1\u5173\u7cfb\u3002\u4f60\u4eec\u786e\u5b9e\u8f9b\u82e6\uff01\u6700\u8fd1\u53c8\u6709\u5927\u9879\u76ee\u4e86\u5417\uff1f",
                  "short_description": null,
                  "addition": "",
                  "selected": false,
                  "ka": 4,
                  "nextQuestionId": 3304
              }, {
                  "id": 2,
                  "point": 9,
                  "description": "\u8001\u79e6\u4f60\u5ba2\u6c14\u4e86\u3002\u4f60\u4eec\u4e00\u4e2a\u56e2\u961f\uff0c\u8981\u652f\u6301\u8fd9\u4e48\u591a\u7ebf\u4e0a\u7ebf\u4e0b\u6e20\u9053\u7684\u7269\u6d41\u5de5\u4f5c\uff0c\u771f\u7684\u5f88\u4e0d\u5bb9\u6613\u3002",
                  "short_description": null,
                  "addition": "",
                  "selected": false,
                  "ka": 4,
                  "nextQuestionId": 3303
              }, {
                  "id": 1,
                  "point": -1,
                  "description": "\u8001\u79e6\u4f60\u8fd9\u4e48\u5fd9\uff0c\u90a3\u6211\u4e5f\u957f\u8bdd\u77ed\u8bf4\u3002\u6700\u8fd1\u5b9e\u4f53\u5e97\u7684\u7269\u6d41\u51fa\u4e86\u4e00\u4e9b\u95ee\u9898\uff0c\u6211\u60f3\u548c\u4f60\u6c9f\u901a\u4e00\u4e0b\u3002",
                  "short_description": null,
                  "addition": "",
                  "selected": true,
                  "ka": -1,
                  "nextQuestionId": 3302
              }],
              "directorComment": "",
              "expression": "\u6b63\u5e38",
              "description_length": 1
          }, {
              "id": 3302,
              "description": "\u55ef\uff0c\u4f60\u8bf4\u3002",
              "options": [{
                  "id": 3,
                  "point": 4,
                  "description": "\u6211\u77e5\u9053\u7269\u6d41\u90e8\u7684\u540c\u4e8b\u90fd\u5f88\u8f9b\u82e6\uff0c\u4e00\u4e2a\u56e2\u961f\u8981\u540c\u65f6\u652f\u6301\u8fd9\u4e48\u591a\u7ebf\u4e0a\u7ebf\u4e0b\u6e20\u9053\u7684\u7269\u6d41\u5de5\u4f5c\uff0c\u771f\u7684\u5f88\u4e0d\u5bb9\u6613\u3002",
                  "short_description": null,
                  "addition": "",
                  "selected": false,
                  "ka": 4,
                  "nextQuestionId": 3303
              }, {
                  "id": 2,
                  "point": 1,
                  "description": "\u662f\u8fd9\u6837\uff0c\u6211\u4eec\u53d1\u73b0\u6700\u8fd1\u7269\u6d41\u54cd\u5e94\u7ecf\u5e38\u4e0d\u592a\u53ca\u65f6\u3002\u8001\u79e6\u4f60\u529e\u4e8b\u4e00\u5411\u9760\u8c31\uff0c\u51fa\u73b0\u8fd9\u79cd\u60c5\u51b5\uff0c\u6709\u4ec0\u4e48\u539f\u56e0\u5417\uff1f",
                  "short_description": null,
                  "addition": "",
                  "selected": false,
                  "ka": 3,
                  "nextQuestionId": 3306
              }, {
                  "id": 1,
                  "point": -1,
                  "description": "\u5546\u54c1\u8865\u7ed9\u6162\uff0c\u201c\u9650\u65f6\u9001\u201d\u5e38\u5e38\u5ef6\u8bef\uff0c\u987e\u5ba2\u975e\u5e38\u4e0d\u6ee1\u3002",
                  "short_description": null,
                  "addition": "",
                  "selected": true,
                  "ka": -1,
                  "nextQuestionId": 3305
              }],
              "directorComment": "\u4e00\u5f00\u573a\u5c31\u63d0\u8981\u6c42\uff0c\u5bf9\u65b9\u7684\u53cd\u5e94\u6709\u4e9b\u51b7\u6de1\u54e6\u3002\u5e94\u8be5\u600e\u4e48\u6253\u5f00\u5c40\u9762\uff0c\u8ba9\u5bbe\u4e3b\u5c3d\u6b22\u5462\uff1f",
              "expression": "\u51b7\u6f20",
              "description_length": 1
          }, {
              "id": 3303,
              "description": "\u5e94\u8be5\u7684\uff0c\u5e94\u8be5\u7684\u3002\u4f60\u4eec\u51b2\u950b\u9677\u9635\u62fc\u4e1a\u7ee9\uff0c\u6211\u4eec\u5f53\u7136\u8981\u505a\u597d\u652f\u6301\u5de5\u4f5c\u561b\u3002",
              "options": [{
                  "id": 3,
                  "point": -1,
                  "description": "\u6709\u4f60\u8fd9\u53e5\u8bdd\uff0c\u6211\u5c31\u653e\u5fc3\u4e86\u3002\u4eca\u5929\u8fc7\u6765\uff0c\u5c31\u662f\u60f3\u8c08\u7269\u6d41\u652f\u6301\u7684\u95ee\u9898\u3002",
                  "short_description": null,
                  "addition": "",
                  "selected": false,
                  "ka": -1,
                  "nextQuestionId": 3309
              }, {
                  "id": 1,
                  "point": -1,
                  "description": "\u7269\u6d41\u56e2\u961f\u5bf9\u6211\u4eec\u65b0\u4e1a\u52a1\u6a21\u5f0f\u4e00\u76f4\u5f88\u652f\u6301\uff0c\u5927\u5bb6\u90fd\u7279\u522b\u611f\u6fc0\u3002",
                  "short_description": null,
                  "addition": "",
                  "selected": false,
                  "ka": -1,
                  "nextQuestionId": 3307
              }, {
                  "id": 2,
                  "point": 9,
                  "description": "\u6211\u60f3\u804a\u804a\u5b9e\u4f53\u5e97\u7684\u7269\u6d41\u60c5\u51b5\u3002\u65b0\u5e97\u70ed\u95e8\u4ea7\u54c1\u8865\u7ed9\u5f88\u6162\uff0c\u201c\u9650\u65f6\u9001\u5230\u5bb6\u201d\u4e5f\u6709\u5ef6\u8bef\uff0c\u5bfc\u81f4\u987e\u5ba2\u4e0d\u592a\u6ee1\u610f\u3002",
                  "short_description": null,
                  "addition": "",
                  "selected": false,
                  "ka": 3,
                  "nextQuestionId": 3308
              }],
              "directorComment": "\u6c1b\u56f4\u5f88\u878d\u6d3d\uff0c\u8bf7\u7ee7\u7eed\u4f60\u7684\u5bf9\u8bdd\u3002",
              "expression": "\u6b63\u5e38",
              "description_length": 1
          }, {
              "id": 3304,
              "description": "\u662f\u554a\uff0c\u4ed3\u50a8\u4e2d\u5fc3\u8981\u5347\u7ea7\uff0c\u7ebf\u4e0a\u9500\u552e\u53c8\u5230\u4e86\u65fa\u5b63\u3002\u6068\u4e0d\u5f97\u957f\u4e2a\u4e09\u5934\u516d\u81c2\u51fa\u6765\u2026\u2026\u3010\u5410\u82e6\u6c34\u5341\u4e94\u5206\u949f\u3011",
              "options": [{
                  "id": 3,
                  "point": -1,
                  "description": "\u3010\u9644\u548c\u79e6\u98de\u3011\u4f60\u4eec\u8981\u652f\u6301\u8fd9\u4e48\u591a\u6e20\u9053\u7684\u7269\u6d41\u5de5\u4f5c\uff0c\u771f\u7684\u662f\u592a\u8f9b\u82e6\u4e86\u3002",
                  "short_description": null,
                  "addition": "",
                  "selected": false,
                  "ka": -1,
                  "nextQuestionId": 3311
              }, {
                  "id": 2,
                  "point": -1,
                  "description": "\u3010\u5f15\u51fa\u8bdd\u9898\u3011\u6211\u4eec\u4e5f\u662f\uff0c\u7b80\u76f4\u5fd9\u5230\u4e0d\u884c\u3002\u54e6\u5bf9\u4e86\uff0c\u8bf4\u5230\u7269\u6d41\uff0c\u6211\u6b63\u60f3\u8ddf\u4f60\u8c08\u8c08\u3002",
                  "short_description": null,
                  "addition": "",
                  "selected": false,
                  "ka": -1,
                  "nextQuestionId": 3310
              }, {
                  "id": 1,
                  "point": -1,
                  "description": "\u3010\u786c\u7740\u5934\u76ae\u6253\u65ad\u3011\u5176\u5b9e\uff0c\u4eca\u5929\u6765\u662f\u60f3\u548c\u4f60\u804a\u804a\u5b9e\u4f53\u5e97\u7684\u7269\u6d41\u95ee\u9898\u3002",
                  "short_description": null,
                  "addition": "",
                  "selected": false,
                  "ka": -1,
                  "nextQuestionId": 3310
              }],
              "directorComment": "\u5f00\u573a\u5bd2\u6684\u4e0d\u53ef\u5c11\uff0c\u6765\u8bbf\u76ee\u7684\u4e5f\u4e0d\u80fd\u5fd8\u54e6\u3002",
              "expression": "\u6b63\u5e38",
              "description_length": 1
          }, {
              "id": 3305,
              "description": "\u8fd9\u6837\u554a\u2026\u2026\u4f46\u6700\u8fd1\u6211\u4eec\u4eba\u624b\u7d27\uff0c\u4e24\u4e2a\u5927\u9879\u76ee\u540c\u65f6\u5728\u8dd1\uff0c\u800c\u4e14\u5927\u8001\u677f\u5929\u5929\u76ef\u7740\u5462\u3002\u5b9e\u4f53\u5e97\u786e\u5b9e\u987e\u4e0d\u8fc7\u6765\u3002",
              "options": [{
                  "id": 3,
                  "point": 6,
                  "description": "\u4f60\u4eec\u56e2\u961f\u4e0a\u4e0b\u90fd\u5728\u8d85\u8d1f\u8377\u5de5\u4f5c\uff0c\u771f\u7684\u5f88\u8f9b\u82e6\u3002\u4f46\u6211\u4eec\u78b0\u5230\u7684\u60c5\u51b5\u4e5f\u5f88\u5934\u75bc\u3002\u558f\uff0c\u4f60\u6765\u542c\u542c\u8fd9\u6bb5\u5f55\u97f3\u3002",
                  "short_description": null,
                  "addition": "\u8bed\u97f3\u64ad\u653e",
                  "selected": true,
                  "ka": 1,
                  "nextQuestionId": 3313
              }, {
                  "id": 2,
                  "point": 2,
                  "description": "\u4f46\u5b9e\u4f53\u5e97\u7684\u95ee\u9898\u8fd8\u771f\u5f97\u8bf7\u4f60\u5e2e\u5fd9\u60f3\u60f3\u529e\u6cd5\u3002\u5426\u5219\uff0c\u987e\u5ba2\u62b1\u6028\u8d8a\u6765\u8d8a\u591a\uff0c\u5bf9\u516c\u53f8\u5f71\u54cd\u4e5f\u5f88\u5927\u3002",
                  "short_description": null,
                  "addition": "",
                  "selected": false,
                  "ka": 1,
                  "nextQuestionId": 3313
              }, {
                  "id": 1,
                  "point": -1,
                  "description": "\u8fd9\u8bdd\u4ec0\u4e48\u610f\u601d\uff01\u5927\u8001\u677f\u5173\u6ce8\u7684\u4f60\u4eec\u624d\u505a\uff1f\u6211\u4eec\u5b9e\u4f53\u5e97\u4e5f\u662f\u516c\u53f8\u7684\u6218\u7565\u91cd\u70b9\u554a\u3002\u8fd9\u4e5f\u592a\u539a\u6b64\u8584\u5f7c\u4e86\u5427\uff01",
                  "short_description": null,
                  "addition": "",
                  "selected": false,
                  "ka": -1,
                  "nextQuestionId": 3312
              }],
              "directorComment": "\u5728\u5bf9\u65b9\u770b\u6765\uff0c\u4f60\u7684\u95ee\u9898\u4f18\u5148\u7ea7\u4e0d\u9ad8\uff0c\u600e\u4e48\u7834\uff1f",
              "expression": "\u6b63\u5e38",
              "description_length": 1
          }, {
              "id": 3306,
              "description": "\u201c\u7ecf\u5e38\u201d\uff1f\u4e0d\u81f3\u4e8e\u5427\u3002\u65b0\u4e1a\u52a1\u561b\uff0c\u4e0d\u7a33\u5b9a\u5728\u6240\u96be\u514d\u3002\u522b\u62c5\u5fc3\uff0c\u56de\u5934\u6211\u5e2e\u4f60\u95ee\u95ee\u4ec0\u4e48\u60c5\u51b5\u3002",
              "options": [{
                  "id": 3,
                  "point": -1,
                  "description": "\u592a\u8c22\u8c22\u4e86\uff01\u4e3a\u4e86\u8fd9\u4e8b\uff0c\u6211\u4eec\u90fd\u5feb\u6101\u6b7b\u4e86\uff01\u987e\u5ba2\u5230\u5e97\u91cc\u4e70\u4e0d\u5230\u4e1c\u897f\uff0c\u53c8\u4e0d\u80fd\u53ca\u65f6\u6536\u5230\u5feb\u9012\uff0c\u52a8\u4e0d\u52a8\u5c31\u7ed9\u5dee\u8bc4\u3002",
                  "short_description": null,
                  "addition": "",
                  "selected": false,
                  "ka": -1,
                  "nextQuestionId": 3321
              }, {
                  "id": 2,
                  "point": 1,
                  "description": "\u90a3\u591a\u8c22\u4f60\u4e86\u3002\u5b9e\u4f53\u5e97\u7684\u7269\u6d41\u95ee\u9898\uff0c\u8981\u8bf7\u4f60\u60f3\u60f3\u529e\u6cd5\u89e3\u51b3\u3002\u5426\u5219\uff0c\u987e\u5ba2\u62b1\u6028\u8d8a\u6765\u8d8a\u591a\uff0c\u5bf9\u516c\u53f8\u5f71\u54cd\u4e5f\u5f88\u5927\u3002",
                  "short_description": null,
                  "addition": "",
                  "selected": false,
                  "ka": 1,
                  "nextQuestionId": 3314
              }, {
                  "id": 1,
                  "point": 3,
                  "description": "\u95e8\u5e97\u7b79\u5907\u65f6\u7269\u6d41\u90e8\u5e2e\u4e86\u5f88\u5927\u7684\u5fd9,\u6211\u4eec\u5f88\u611f\u6fc0\u3002\u6211\u77e5\u9053\u4f60\u4eec\u7279\u522b\u5fd9\uff0c\u4f46\u73b0\u5728\u7684\u72b6\u51b5\u8ba9\u4eba\u5934\u75bc\uff0c\u4f60\u6765\u542c\u542c\u8fd9\u6bb5\u5f55\u97f3\u3002",
                  "short_description": null,
                  "addition": "\u8bed\u97f3\u64ad\u653e",
                  "selected": false,
                  "ka": 1,
                  "nextQuestionId": 3314
              }],
              "directorComment": "\u4f60\u6025\u5f97\u7126\u5934\u70c2\u989d\uff0c\u5bf9\u65b9\u5374\u5e76\u4e0d\u91cd\u89c6\u3002\u8be5\u600e\u4e48\u8ba9\u5bf9\u65b9\u610f\u8bc6\u5230\u95ee\u9898\u7684\u4e25\u91cd\u6027\u5462\uff1f",
              "expression": "\u6297\u62d2",
              "description_length": 1
          }, {
              "id": 3307,
              "description": "\u54ea\u91cc\u54ea\u91cc\uff0c\u8fc7\u5956\u4e86\u2026\u2026\u3010\u5185\u5fc3\u56f0\u60d1\uff1a\u8fd9\u4eba\u5230\u5e95\u6765\u5e72\u561b\u7684\uff1f\u3011",
              "options": [{
                  "id": 2,
                  "point": -1,
                  "description": "\u6700\u8fd1\u5b9e\u4f53\u5e97\u7684\u8d27\u54c1\u8865\u7ed9\u6162\uff0c\u9001\u8d27\u5230\u5bb6\u7684\u670d\u52a1\u4e5f\u5e38\u5e38\u5ef6\u8bef\uff0c\u8fd9\u5bf9\u6211\u4eec\u7684\u4e1a\u52a1\u5f71\u54cd\u5f88\u5927\u3002\u6240\u4ee5\u4eca\u5929\u60f3\u6765\u548c\u4f60\u804a\u804a\u3002",
                  "short_description": null,
                  "addition": "",
                  "selected": false,
                  "ka": -1,
                  "nextQuestionId": 3316
              }, {
                  "id": 1,
                  "point": 2,
                  "description": "\u662f\u8fd9\u6837\uff0c\u6211\u4eec\u53d1\u73b0\u6700\u8fd1\u7269\u6d41\u54cd\u5e94\u7ecf\u5e38\u4e0d\u592a\u53ca\u65f6\u3002\u8001\u79e6\u4f60\u529e\u4e8b\u4e00\u5411\u9760\u8c31\uff0c\u51fa\u73b0\u8fd9\u79cd\u60c5\u51b5\uff0c\u6709\u4ec0\u4e48\u539f\u56e0\u5417\uff1f",
                  "short_description": null,
                  "addition": "",
                  "selected": false,
                  "ka": 3,
                  "nextQuestionId": 3315
              }],
              "directorComment": "\u8001\u79e6\u5f88\u5fd9\uff0c\u5ba2\u5957\u65f6\u95f4\u4e0d\u8981\u592a\u957f\uff0c\u8d76\u5feb\u8bf4\u660e\u6765\u8bbf\u76ee\u7684\u5427\uff01",
              "expression": "\u4e3a\u96be",
              "description_length": 1
          }, {
              "id": 3308,
              "description": "\u660e\u767d\u3001\u660e\u767d\uff0c\u4f60\u90ae\u4ef6\u91cc\u90fd\u8bf4\u4e86\u3002\u6211\u4eec\u6700\u8fd1\u771f\u7684\u662f\u6ca1\u4eba\u624b\uff0c\u53c8\u662f\u7535\u5546\u65fa\u5b63\uff0c\u53c8\u662f\u4ed3\u50a8\u4e2d\u5fc3\u5347\u7ea7\uff0c\u5927\u8001\u677f\u90fd\u4eb2\u81ea\u76ef\u7740\u5462\u3002\u5b9e\u4f53\u5e97\u90a3\u5757\u662f\u6709\u70b9\u987e\u4e0d\u8fc7\u6765\uff0c\u62b1\u6b49\u62b1\u6b49\u3002",
              "options": [{
                  "id": 2,
                  "point": 9,
                  "description": "\u95e8\u5e97\u7b79\u5907\u65f6\u7269\u6d41\u90e8\u5e2e\u4e86\u5f88\u5927\u7684\u5fd9,\u6211\u4eec\u5f88\u611f\u6fc0\u3002\u6211\u77e5\u9053\u4f60\u4eec\u7279\u522b\u5fd9\uff0c\u4f46\u73b0\u5728\u7684\u72b6\u51b5\u8ba9\u4eba\u5934\u75bc\uff0c\u4f60\u6765\u542c\u542c\u8fd9\u6bb5\u5f55\u97f3\u3002",
                  "short_description": null,
                  "addition": "\u8bed\u97f3\u64ad\u653e",
                  "selected": false,
                  "ka": 1,
                  "nextQuestionId": 3317
              }, {
                  "id": 1,
                  "point": 1,
                  "description": "\u4f60\u4eec\u7684\u96be\u5904\uff0c\u6211\u5f88\u7406\u89e3\u3002\u4f46\u5b9e\u4f53\u5e97\u7684\u95ee\u9898\u8fd8\u771f\u5f97\u8bf7\u4f60\u5e2e\u5fd9\u60f3\u60f3\u529e\u6cd5\u3002\u5426\u5219\uff0c\u987e\u5ba2\u62b1\u6028\u8d8a\u6765\u8d8a\u591a\uff0c\u5bf9\u516c\u53f8\u5f71\u54cd\u4e5f\u5f88\u5927\u3002",
                  "short_description": null,
                  "addition": "",
                  "selected": false,
                  "ka": 2,
                  "nextQuestionId": 3317
              }],
              "directorComment": "\u5728\u5bf9\u65b9\u770b\u6765\uff0c\u4f60\u7684\u95ee\u9898\u4f18\u5148\u7ea7\u4e0d\u9ad8\uff0c\u600e\u4e48\u7834\uff1f",
              "expression": "\u6b63\u5e38",
              "description_length": 1
          }, {
              "id": 3309,
              "description": "\u4f60\u8fd9\u4e48\u4e00\u8bf4\uff0c\u6211\u53ef\u4e0d\u6562\u653e\u5fc3\u4e86\u3002\u5177\u4f53\u4ec0\u4e48\u95ee\u9898\uff1f",
              "options": [{
                  "id": 3,
                  "point": -1,
                  "description": "\u95e8\u5e97\u4ea7\u54c1\u914d\u9001\u3001\u201c\u9650\u65f6\u9001\u5230\u5bb6\u201d\u670d\u52a1\uff0c\u51c6\u65f6\u7387\u90fd\u5f88\u4f4e\uff0c\u8fd9\u5bf9\u6211\u4eec\u4e1a\u7ee9\u7684\u5f71\u54cd\u633a\u5927\u7684\u3002",
                  "short_description": null,
                  "addition": "",
                  "selected": false,
                  "ka": -1,
                  "nextQuestionId": 3320
              }, {
                  "id": 2,
                  "point": 3,
                  "description": "\u662f\u8fd9\u6837\uff0c\u6211\u4eec\u53d1\u73b0\u6700\u8fd1\u7269\u6d41\u54cd\u5e94\u7ecf\u5e38\u4e0d\u592a\u53ca\u65f6\u3002\u8001\u79e6\u4f60\u529e\u4e8b\u4e00\u5411\u9760\u8c31\uff0c\u51fa\u73b0\u8fd9\u79cd\u60c5\u51b5\uff0c\u6709\u4ec0\u4e48\u539f\u56e0\u5417\uff1f",
                  "short_description": null,
                  "addition": "",
                  "selected": false,
                  "ka": 3,
                  "nextQuestionId": 3319
              }, {
                  "id": 1,
                  "point": 3,
                  "description": "\u6211\u4eec\u5e97\u70ed\u95e8\u4ea7\u54c1\u7684\u8865\u7ed9\u5f88\u6162\uff0c\u201c\u9650\u65f6\u9001\u5230\u5bb6\u201d\u4e5f\u6709\u5ef6\u8bef\u7684\u60c5\u51b5\uff0c\u5bfc\u81f4\u987e\u5ba2\u4e0d\u592a\u6ee1\u610f\u3002",
                  "short_description": null,
                  "addition": "",
                  "selected": false,
                  "ka": 3,
                  "nextQuestionId": 3318
              }],
              "directorComment": "\u4e00\u5473\u7ed9\u5bf9\u65b9\u6234\u9ad8\u5e3d\u5e76\u4e0d\u53ef\u53d6\uff0c\u8d76\u7d27\u63a2\u8ba8\u5177\u4f53\u95ee\u9898\u5427\u3002",
              "expression": "\u51b7\u6f20",
              "description_length": 1
          }, {
              "id": 3310,
              "description": "\u54e6\uff1f\u600e\u4e48\u4e86\uff1f",
              "options": [{
                  "id": 3,
                  "point": -1,
                  "description": "\u95e8\u5e97\u4ea7\u54c1\u914d\u9001\u3001\u201c\u9650\u65f6\u9001\u5230\u5bb6\u201d\u670d\u52a1\uff0c\u51c6\u65f6\u7387\u90fd\u5f88\u4f4e\uff0c\u8fd9\u5bf9\u6211\u4eec\u4e1a\u7ee9\u7684\u5f71\u54cd\u633a\u5927\u7684\u3002",
                  "short_description": null,
                  "addition": "",
                  "selected": false,
                  "ka": -1,
                  "nextQuestionId": 3320
              }, {
                  "id": 2,
                  "point": 3,
                  "description": "\u662f\u8fd9\u6837\uff0c\u6211\u4eec\u53d1\u73b0\u6700\u8fd1\u7269\u6d41\u54cd\u5e94\u7ecf\u5e38\u4e0d\u592a\u53ca\u65f6\u3002\u8001\u79e6\u4f60\u529e\u4e8b\u4e00\u5411\u9760\u8c31\uff0c\u51fa\u73b0\u8fd9\u79cd\u60c5\u51b5\uff0c\u6709\u4ec0\u4e48\u539f\u56e0\u5417\uff1f",
                  "short_description": null,
                  "addition": "",
                  "selected": false,
                  "ka": 3,
                  "nextQuestionId": 3319
              }, {
                  "id": 1,
                  "point": 3,
                  "description": "\u6211\u4eec\u5e97\u70ed\u95e8\u4ea7\u54c1\u7684\u8865\u7ed9\u5f88\u6162\uff0c\u201c\u9650\u65f6\u9001\u5230\u5bb6\u201d\u4e5f\u6709\u5ef6\u8bef\u7684\u60c5\u51b5\uff0c\u5bfc\u81f4\u987e\u5ba2\u4e0d\u592a\u6ee1\u610f\u3002",
                  "short_description": null,
                  "addition": "",
                  "selected": false,
                  "ka": 3,
                  "nextQuestionId": 3318
              }],
              "directorComment": "\u7ec8\u4e8e\u8fdb\u5165\u6b63\u9898\uff01\u60f3\u60f3\u8be5\u5982\u4f55\u8ddf\u5bf9\u65b9\u6c9f\u901a\u4f60\u7684\u96be\u9898\u3002",
              "expression": "\u6b63\u5e38",
              "description_length": 1
          }, {
              "id": 3311,
              "description": "\u54ea\u91cc\uff0c\u8fd9\u662f\u5e94\u8be5\u7684\u3002\u3010\u5fc3\u91cc\u56f0\u60d1\uff1a\u8fd9\u4eba\u5230\u5e95\u6765\u5e72\u561b\uff1f\u3011",
              "options": [{
                  "id": 2,
                  "point": -1,
                  "description": "\u6700\u8fd1\u5b9e\u4f53\u5e97\u7684\u8d27\u54c1\u8865\u7ed9\u6162\uff0c\u9001\u8d27\u5230\u5bb6\u7684\u670d\u52a1\u4e5f\u5e38\u5e38\u5ef6\u8bef\uff0c\u8fd9\u5bf9\u6211\u4eec\u7684\u4e1a\u52a1\u5f71\u54cd\u5f88\u5927\u3002\u6240\u4ee5\u4eca\u5929\u60f3\u6765\u548c\u4f60\u804a\u804a\u3002",
                  "short_description": null,
                  "addition": "",
                  "selected": false,
                  "ka": -1,
                  "nextQuestionId": 3316
              }, {
                  "id": 1,
                  "point": 2,
                  "description": "\u662f\u8fd9\u6837\uff0c\u6211\u4eec\u53d1\u73b0\u6700\u8fd1\u7269\u6d41\u54cd\u5e94\u7ecf\u5e38\u4e0d\u592a\u53ca\u65f6\u3002\u8001\u79e6\u4f60\u529e\u4e8b\u4e00\u5411\u9760\u8c31\uff0c\u51fa\u73b0\u8fd9\u79cd\u60c5\u51b5\uff0c\u6709\u4ec0\u4e48\u539f\u56e0\u5417\uff1f",
                  "short_description": null,
                  "addition": "",
                  "selected": false,
                  "ka": 3,
                  "nextQuestionId": 3315
              }],
              "directorComment": "\u8001\u79e6\u5f88\u5fd9\uff0c\u5ba2\u5957\u65f6\u95f4\u4e0d\u8981\u592a\u957f\uff0c\u8d76\u5feb\u8bf4\u660e\u6765\u8bbf\u76ee\u7684\u5427\uff01",
              "expression": "\u4e3a\u96be",
              "description_length": 1
          }, {
              "id": 3312,
              "description": "\u54ce\u5440\u8fd9\u8bef\u4f1a\u5927\u4e86\u3002\u6211\u4eec\u7edd\u5bf9\u5168\u529b\u652f\u6301\u5b9e\u4f53\u5e97\u7684\u4e1a\u52a1\u3002\u5f53\u65f6\u8fd8\u6ca1\u5f00\u4e1a\u7684\u65f6\u5019\uff0c\u56e2\u961f\u4e0a\u4e0b\u4e3a\u4e86\u4f60\u4eec\u52a0\u73ed\u52a0\u70b9\uff0c\u534a\u70b9\u6028\u8a00\u90fd\u6ca1\u6709\u3002",
              "options": [{
                  "id": 2,
                  "point": 3,
                  "description": "\u5f53\u7136\u5f53\u7136\uff0c\u6211\u4eec\u90fd\u8bb0\u5f97\u7269\u6d41\u56e2\u961f\u5bf9\u6211\u4eec\u7684\u652f\u6301\u3002\u4f46\u73b0\u5728\u7684\u60c5\u51b5\u4e5f\u5f88\u4e25\u91cd\uff0c\u558f\uff0c\u8fd9\u662f\u4e00\u4e2a\u7528\u6237\u7684\u53cd\u9988\u3002",
                  "short_description": null,
                  "addition": "\u8bed\u97f3\u64ad\u653e",
                  "selected": false,
                  "ka": 1,
                  "nextQuestionId": 3403
              }, {
                  "id": 1,
                  "point": 1,
                  "description": "\u521a\u624d\u6211\u6709\u70b9\u6025\u4e86\uff0c\u62b1\u6b49\u3002\u4f60\u4eec\u7684\u5e2e\u5fd9\u6211\u4eec\u771f\u7684\u5f88\u611f\u6fc0\u3002\u5e2e\u4eba\u5e2e\u5230\u5e95\uff0c\u8fd9\u6b21\u7684\u95ee\u9898\u6ca1\u4f60\u4eec\u771f\u4e0d\u884c\uff01",
                  "short_description": null,
                  "addition": "",
                  "selected": false,
                  "ka": 4,
                  "nextQuestionId": 3402
              }],
              "directorComment": "\u5174\u5e08\u95ee\u7f6a\u906d\u53cd\u5f39\uff0c\u60f3\u60f3\u8fd9\u4e8b\u5230\u5e95\u8be5\u600e\u4e48\u8c08\uff1f",
              "expression": "\u6297\u62d2",
              "description_length": 1
          }, {
              "id": 3313,
              "description": "\u5514\uff0c\u662f\u633a\u5934\u75bc\u7684\u3002\u4f46\u6211\u4e5f\u8ddf\u4f60\u638f\u5fc3\u638f\u80ba\u8bf4\u4e00\u53e5\uff0c\u867d\u7136\u4f60\u4eec\u7684\u6f5c\u529b\u5f88\u5927\uff0c\u4f46\u662f\u76ee\u524d\u91cd\u70b9\u4e1a\u52a1\u8fd8\u662f\u5728\u7ebf\u4e0a\u3002\u6211\u4eec\u603b\u4e0d\u80fd\u4e3a\u4e86\u89e3\u51b3\u5b9e\u4f53\u5e97\u7684\u4e2a\u522b\u95ee\u9898\uff0c\u5f71\u54cd\u516c\u53f8\u6574\u4f53\u7684\u7269\u6d41\u89c4\u5212\u5427\uff1f\u4f60\u653e\u4e00\u767e\u4e8c\u5341\u4e2a\u5fc3\uff0c\u7b49\u6211\u5fd9\u5b8c\u8fd9\u4e00\u9635\uff0c\u4e00\u5b9a\u60f3\u529e\u6cd5\u5e2e\u4f60\u4eec\u89e3\u51b3\uff0c\u597d\u4e0d\u597d\uff1f ",
              "options": [{
                  "id": 3,
                  "point": -1,
                  "description": "\u4e2a\u522b\u95ee\u9898\u4e5f\u4e0d\u80fd\u5ffd\u89c6\u554a\uff01\u201c\u5ba2\u8bc9\u65e0\u5c0f\u4e8b\u201d\uff0c\u4e00\u4e2a\u987e\u5ba2\u7684\u62b1\u6028\u5f88\u6709\u53ef\u80fd\u5bf9\u54c1\u724c\u9020\u6210\u5f71\u54cd\u3002",
                  "short_description": null,
                  "addition": "",
                  "selected": false,
                  "ka": -1,
                  "nextQuestionId": 3324
              }, {
                  "id": 2,
                  "point": 9,
                  "description": "\u8001\u79e6\uff0c\u4f60\u770b\u4e00\u4e0b\u8fd9\u5f20\u8868\uff0c\u5f53\u7f3a\u8d27\u91cf\u8d70\u9ad8\u65f6\uff0c\u5ba2\u6237\u5dee\u8bc4\u660e\u663e\u6301\u7eed\u589e\u591a\u3002\u8fd9\u5df2\u7ecf\u4e0d\u662f\u4e2a\u6848\u4e86\u3002",
                  "short_description": null,
                  "addition": "",
                  "selected": false,
                  "ka": 2,
                  "nextQuestionId": 3323
              }, {
                  "id": 1,
                  "point": -1,
                  "description": "\u5b9e\u4f53\u5e97\u7684\u6307\u6807\u538b\u529b\u4e5f\u5f88\u5927\u3002\u518d\u8fd9\u4e48\u62d6\u4e0b\u53bb\uff0c\u4e0b\u534a\u5e74\u7684\u4e1a\u7ee9\u5c31\u6ca1\u6307\u671b\u4e86\u3002\u8001\u79e6\uff0c\u5356\u6211\u4e2a\u9762\u5b50\uff0c\u5e2e\u5e2e\u6211\u4eec\u5427\u3002",
                  "short_description": null,
                  "addition": "",
                  "selected": false,
                  "ka": -1,
                  "nextQuestionId": 3322
              }],
              "directorComment": "\u4eb2\u8eab\u611f\u53d7\u4e86\u6765\u81ea\u987e\u5ba2\u7684\u53cd\u9988\uff0c\u5bf9\u65b9\u7ec8\u4e8e\u5f00\u59cb\u91cd\u89c6\u4f60\u7684\u95ee\u9898\u4e86\u3002\u4e0d\u8fc7\u4ed6\u4f3c\u4e4e\u4ecd\u6ca1\u6709\u610f\u8bc6\u5230\u95ee\u9898\u7684\u7d27\u8feb\u6027\uff0c\u8bf7\u7ee7\u7eed\u52aa\u529b\uff01",
              "expression": "\u6b63\u5e38",
              "description_length": 1
          }, {
              "id": 3314,
              "description": "\u5514\uff0c\u662f\u633a\u5934\u75bc\u7684\u3002\u4f46\u6211\u4e5f\u8ddf\u4f60\u638f\u5fc3\u638f\u80ba\u8bf4\u4e00\u53e5\uff0c\u867d\u7136\u4f60\u4eec\u7684\u6f5c\u529b\u5f88\u5927\uff0c\u4f46\u662f\u76ee\u524d\u91cd\u70b9\u4e1a\u52a1\u8fd8\u662f\u5728\u7ebf\u4e0a\u3002\u6211\u4eec\u603b\u4e0d\u80fd\u4e3a\u4e86\u89e3\u51b3\u5b9e\u4f53\u5e97\u7684\u4e2a\u522b\u95ee\u9898\uff0c\u5f71\u54cd\u516c\u53f8\u6574\u4f53\u7684\u7269\u6d41\u89c4\u5212\u5427\uff1f\u4f60\u653e\u4e00\u767e\u4e8c\u5341\u4e2a\u5fc3\uff0c\u7b49\u6211\u5fd9\u5b8c\u8fd9\u4e00\u9635\uff0c\u4e00\u5b9a\u60f3\u529e\u6cd5\u5e2e\u4f60\u4eec\u89e3\u51b3\uff0c\u597d\u4e0d\u597d\uff1f ",
              "options": [{
                  "id": 3,
                  "point": -1,
                  "description": "\u4e2a\u522b\u95ee\u9898\u4e5f\u4e0d\u80fd\u5ffd\u89c6\u554a\uff01\u201c\u5ba2\u8bc9\u65e0\u5c0f\u4e8b\u201d\uff0c\u4e00\u4e2a\u987e\u5ba2\u7684\u62b1\u6028\u5f88\u6709\u53ef\u80fd\u5bf9\u54c1\u724c\u9020\u6210\u5f71\u54cd\u3002",
                  "short_description": null,
                  "addition": "",
                  "selected": false,
                  "ka": -1,
                  "nextQuestionId": 3324
              }, {
                  "id": 2,
                  "point": 9,
                  "description": "\u8001\u79e6\uff0c\u4f60\u770b\u4e00\u4e0b\u8fd9\u5f20\u8868\uff0c\u5f53\u7f3a\u8d27\u91cf\u8d70\u9ad8\u65f6\uff0c\u5ba2\u6237\u5dee\u8bc4\u660e\u663e\u6301\u7eed\u589e\u591a\u3002\u8fd9\u5df2\u7ecf\u4e0d\u662f\u4e2a\u6848\u4e86\u3002",
                  "short_description": null,
                  "addition": "",
                  "selected": false,
                  "ka": 2,
                  "nextQuestionId": 3323
              }, {
                  "id": 1,
                  "point": -1,
                  "description": "\u5b9e\u4f53\u5e97\u7684\u6307\u6807\u538b\u529b\u4e5f\u5f88\u5927\u3002\u518d\u8fd9\u4e48\u62d6\u4e0b\u53bb\uff0c\u4e0b\u534a\u5e74\u7684\u4e1a\u7ee9\u5c31\u6ca1\u6307\u671b\u4e86\u3002\u8001\u79e6\uff0c\u5356\u6211\u4e2a\u9762\u5b50\uff0c\u5e2e\u5e2e\u6211\u4eec\u5427\u3002",
                  "short_description": null,
                  "addition": "",
                  "selected": false,
                  "ka": -1,
                  "nextQuestionId": 3322
              }],
              "directorComment": "\u4eb2\u8eab\u611f\u53d7\u4e86\u6765\u81ea\u987e\u5ba2\u7684\u53cd\u9988\uff0c\u5bf9\u65b9\u7ec8\u4e8e\u5f00\u59cb\u91cd\u89c6\u4f60\u7684\u95ee\u9898\u4e86\u3002\u4e0d\u8fc7\u4ed6\u4f3c\u4e4e\u4ecd\u6ca1\u6709\u610f\u8bc6\u5230\u95ee\u9898\u7684\u7d27\u8feb\u6027\uff0c\u8bf7\u7ee7\u7eed\u52aa\u529b\uff01",
              "expression": "\u6b63\u5e38",
              "description_length": 1
          }, {
              "id": 3315,
              "description": "\u201c\u7ecf\u5e38\u201d\uff1f\u4e0d\u81f3\u4e8e\u5427\u3002\u65b0\u4e1a\u52a1\u561b\uff0c\u4e0d\u7a33\u5b9a\u5728\u6240\u96be\u514d\u3002\u522b\u62c5\u5fc3\uff0c\u56de\u5934\u6211\u5e2e\u4f60\u95ee\u95ee\u4ec0\u4e48\u60c5\u51b5\u3002",
              "options": [{
                  "id": 3,
                  "point": -1,
                  "description": "\u592a\u8c22\u8c22\u4e86\uff01\u4e3a\u4e86\u8fd9\u4e8b\uff0c\u6211\u4eec\u90fd\u5feb\u6101\u6b7b\u4e86\uff01\u987e\u5ba2\u5230\u5e97\u91cc\u4e70\u4e0d\u5230\u4e1c\u897f\uff0c\u53c8\u4e0d\u80fd\u53ca\u65f6\u6536\u5230\u5feb\u9012\uff0c\u52a8\u4e0d\u52a8\u5c31\u7ed9\u5dee\u8bc4\u3002",
                  "short_description": null,
                  "addition": "",
                  "selected": false,
                  "ka": -1,
                  "nextQuestionId": 3321
              }, {
                  "id": 2,
                  "point": 1,
                  "description": "\u90a3\u591a\u8c22\u4f60\u4e86\u3002\u5b9e\u4f53\u5e97\u7684\u7269\u6d41\u95ee\u9898\uff0c\u8981\u8bf7\u4f60\u60f3\u60f3\u529e\u6cd5\u89e3\u51b3\u3002\u5426\u5219\uff0c\u987e\u5ba2\u62b1\u6028\u8d8a\u6765\u8d8a\u591a\uff0c\u5bf9\u516c\u53f8\u5f71\u54cd\u4e5f\u5f88\u5927\u3002",
                  "short_description": null,
                  "addition": "",
                  "selected": false,
                  "ka": 1,
                  "nextQuestionId": 3314
              }, {
                  "id": 1,
                  "point": 3,
                  "description": "\u95e8\u5e97\u7b79\u5907\u65f6\u7269\u6d41\u90e8\u5e2e\u4e86\u5f88\u5927\u7684\u5fd9,\u6211\u4eec\u5f88\u611f\u6fc0\u3002\u6211\u77e5\u9053\u4f60\u4eec\u7279\u522b\u5fd9\uff0c\u4f46\u73b0\u5728\u7684\u72b6\u51b5\u8ba9\u4eba\u5934\u75bc\uff0c\u4f60\u6765\u542c\u542c\u8fd9\u6bb5\u5f55\u97f3\u3002",
                  "short_description": null,
                  "addition": "\u8bed\u97f3\u64ad\u653e",
                  "selected": false,
                  "ka": 1,
                  "nextQuestionId": 3314
              }],
              "directorComment": "\u4f60\u6025\u5f97\u7126\u5934\u70c2\u989d\uff0c\u5bf9\u65b9\u5374\u5e76\u4e0d\u91cd\u89c6\u3002\u8be5\u600e\u4e48\u8ba9\u5bf9\u65b9\u610f\u8bc6\u5230\u95ee\u9898\u7684\u4e25\u91cd\u6027\u5462\uff1f",
              "expression": "\u51b7\u6f20",
              "description_length": 1
          }, {
              "id": 3316,
              "description": "\u8fd9\u6837\u554a\u2026\u2026\u4f46\u6700\u8fd1\u6211\u4eec\u4eba\u624b\u7d27\uff0c\u4e24\u4e2a\u5927\u9879\u76ee\u540c\u65f6\u5728\u8dd1\uff0c\u800c\u4e14\u5927\u8001\u677f\u5929\u5929\u76ef\u7740\u5462\u3002\u5b9e\u4f53\u5e97\u786e\u5b9e\u987e\u4e0d\u8fc7\u6765\u3002",
              "options": [{
                  "id": 3,
                  "point": 6,
                  "description": "\u4f60\u4eec\u56e2\u961f\u4e0a\u4e0b\u90fd\u5728\u8d85\u8d1f\u8377\u5de5\u4f5c\uff0c\u771f\u7684\u5f88\u8f9b\u82e6\u3002\u4f46\u6211\u4eec\u78b0\u5230\u7684\u60c5\u51b5\u4e5f\u5f88\u5934\u75bc\u3002\u558f\uff0c\u4f60\u6765\u542c\u542c\u8fd9\u6bb5\u5f55\u97f3\u3002",
                  "short_description": null,
                  "addition": "\u8bed\u97f3\u64ad\u653e",
                  "selected": false,
                  "ka": 1,
                  "nextQuestionId": 3313
              }, {
                  "id": 2,
                  "point": 2,
                  "description": "\u4f46\u5b9e\u4f53\u5e97\u7684\u95ee\u9898\u8fd8\u771f\u5f97\u8bf7\u4f60\u5e2e\u5fd9\u60f3\u60f3\u529e\u6cd5\u3002\u5426\u5219\uff0c\u987e\u5ba2\u62b1\u6028\u8d8a\u6765\u8d8a\u591a\uff0c\u5bf9\u516c\u53f8\u5f71\u54cd\u4e5f\u5f88\u5927\u3002",
                  "short_description": null,
                  "addition": "",
                  "selected": false,
                  "ka": 1,
                  "nextQuestionId": 3313
              }, {
                  "id": 1,
                  "point": -1,
                  "description": "\u8fd9\u8bdd\u4ec0\u4e48\u610f\u601d\uff01\u5927\u8001\u677f\u5173\u6ce8\u7684\u4f60\u4eec\u624d\u505a\uff1f\u6211\u4eec\u5b9e\u4f53\u5e97\u4e5f\u662f\u516c\u53f8\u7684\u6218\u7565\u91cd\u70b9\u554a\u3002\u8fd9\u4e5f\u592a\u539a\u6b64\u8584\u5f7c\u4e86\u5427\uff01",
                  "short_description": null,
                  "addition": "",
                  "selected": false,
                  "ka": -1,
                  "nextQuestionId": 3312
              }],
              "directorComment": "\u5728\u5bf9\u65b9\u770b\u6765\uff0c\u4f60\u7684\u95ee\u9898\u4f18\u5148\u7ea7\u4e0d\u9ad8\uff0c\u600e\u4e48\u7834\uff1f",
              "expression": "\u6b63\u5e38",
              "description_length": 1
          }, {
              "id": 3317,
              "description": "\u5514\uff0c\u8fd9\u662f\u633a\u5934\u75bc\u7684\u3002\u4f46\u6211\u4e5f\u8ddf\u4f60\u638f\u5fc3\u638f\u80ba\u8bf4\u4e00\u53e5\uff0c\u867d\u7136\u4f60\u4eec\u7684\u6f5c\u529b\u5f88\u5927\uff0c\u4f46\u662f\u76ee\u524d\u91cd\u70b9\u4e1a\u52a1\u8fd8\u662f\u5728\u7ebf\u4e0a\u3002\u6211\u4eec\u603b\u4e0d\u80fd\u4e3a\u4e86\u89e3\u51b3\u5b9e\u4f53\u5e97\u7684\u4e2a\u522b\u95ee\u9898\uff0c\u5f71\u54cd\u516c\u53f8\u6574\u4f53\u7684\u7269\u6d41\u89c4\u5212\u5427\uff1f\u4f60\u653e\u4e00\u767e\u4e8c\u5341\u4e2a\u5fc3\uff0c\u7b49\u6211\u5fd9\u5b8c\u8fd9\u4e00\u9635\uff0c\u4e00\u5b9a\u60f3\u529e\u6cd5\u5e2e\u4f60\u4eec\u89e3\u51b3\uff0c\u597d\u4e0d\u597d\uff1f ",
              "options": [{
                  "id": 3,
                  "point": -1,
                  "description": "\u4e2a\u522b\u95ee\u9898\u4e5f\u4e0d\u80fd\u5ffd\u89c6\u554a\uff01\u201c\u5ba2\u8bc9\u65e0\u5c0f\u4e8b\u201d\uff0c\u4e00\u4e2a\u987e\u5ba2\u7684\u62b1\u6028\u5f88\u6709\u53ef\u80fd\u5bf9\u54c1\u724c\u9020\u6210\u5f71\u54cd\u3002",
                  "short_description": null,
                  "addition": "",
                  "selected": false,
                  "ka": -1,
                  "nextQuestionId": 3324
              }, {
                  "id": 2,
                  "point": 9,
                  "description": "\u8001\u79e6\uff0c\u4f60\u770b\u4e00\u4e0b\u8fd9\u5f20\u8868\uff0c\u5f53\u7f3a\u8d27\u91cf\u8d70\u9ad8\u65f6\uff0c\u5ba2\u6237\u5dee\u8bc4\u660e\u663e\u6301\u7eed\u589e\u591a\u3002\u8fd9\u5df2\u7ecf\u4e0d\u662f\u4e2a\u6848\u4e86\u3002",
                  "short_description": null,
                  "addition": "",
                  "selected": false,
                  "ka": 2,
                  "nextQuestionId": 3323
              }, {
                  "id": 1,
                  "point": -1,
                  "description": "\u5b9e\u4f53\u5e97\u7684\u6307\u6807\u538b\u529b\u4e5f\u5f88\u5927\u3002\u518d\u8fd9\u4e48\u62d6\u4e0b\u53bb\uff0c\u4e0b\u534a\u5e74\u7684\u4e1a\u7ee9\u5c31\u6ca1\u6307\u671b\u4e86\u3002\u8001\u79e6\uff0c\u5356\u6211\u4e2a\u9762\u5b50\uff0c\u5e2e\u5e2e\u6211\u4eec\u5427\u3002",
                  "short_description": null,
                  "addition": "",
                  "selected": false,
                  "ka": -1,
                  "nextQuestionId": 3322
              }],
              "directorComment": "\u4eb2\u8eab\u611f\u53d7\u4e86\u6765\u81ea\u987e\u5ba2\u7684\u53cd\u9988\uff0c\u5bf9\u65b9\u7ec8\u4e8e\u5f00\u59cb\u91cd\u89c6\u4f60\u7684\u95ee\u9898\u4e86\u3002\u4e0d\u8fc7\u4ed6\u4f3c\u4e4e\u4ecd\u6ca1\u6709\u610f\u8bc6\u5230\u95ee\u9898\u7684\u7d27\u8feb\u6027\uff0c\u8bf7\u7ee7\u7eed\u52aa\u529b\uff01",
              "expression": "\u6b63\u5e38",
              "description_length": 1
          }, {
              "id": 3318,
              "description": "\u660e\u767d\u3002\u4f46\u6211\u4e5f\u8bf4\u4e86\uff0c\u6700\u8fd1\u5b9e\u5728\u662f\u4eba\u624b\u592a\u7d27\uff0c\u91cd\u70b9\u9879\u76ee\u5927\u8001\u677f\u90fd\u4eb2\u81ea\u76ef\u7740\u5462\u3002\u5b9e\u4f53\u5e97\u90a3\u5757\u662f\u6709\u70b9\u987e\u4e0d\u8fc7\u6765\uff0c\u62b1\u6b49\u62b1\u6b49\u3002",
              "options": [{
                  "id": 2,
                  "point": 9,
                  "description": "\u95e8\u5e97\u7b79\u5907\u65f6\u7269\u6d41\u90e8\u5e2e\u4e86\u5f88\u5927\u7684\u5fd9,\u6211\u4eec\u5f88\u611f\u6fc0\u3002\u6211\u77e5\u9053\u4f60\u4eec\u7279\u522b\u5fd9\uff0c\u4f46\u73b0\u5728\u7684\u72b6\u51b5\u8ba9\u4eba\u5934\u75bc\uff0c\u4f60\u6765\u542c\u542c\u8fd9\u6bb5\u5f55\u97f3\u3002",
                  "short_description": null,
                  "addition": "",
                  "selected": false,
                  "ka": 1,
                  "nextQuestionId": 3317
              }, {
                  "id": 1,
                  "point": 1,
                  "description": "\u4f60\u4eec\u7684\u96be\u5904\uff0c\u6211\u5f88\u7406\u89e3\u3002\u4f46\u5b9e\u4f53\u5e97\u7684\u95ee\u9898\u8fd8\u771f\u5f97\u8bf7\u4f60\u5e2e\u5fd9\u60f3\u60f3\u529e\u6cd5\u3002\u5426\u5219\uff0c\u987e\u5ba2\u62b1\u6028\u8d8a\u6765\u8d8a\u591a\uff0c\u5bf9\u516c\u53f8\u5f71\u54cd\u4e5f\u5f88\u5927\u3002",
                  "short_description": null,
                  "addition": "",
                  "selected": false,
                  "ka": 2,
                  "nextQuestionId": 3317
              }],
              "directorComment": "\u5728\u5bf9\u65b9\u770b\u6765\uff0c\u4f60\u7684\u95ee\u9898\u4f18\u5148\u7ea7\u4e0d\u9ad8\uff0c\u600e\u4e48\u7834\uff1f",
              "expression": "\u6b63\u5e38",
              "description_length": 1
          }, {
              "id": 3319,
              "description": "\u201c\u7ecf\u5e38\u201d\uff1f\u4e0d\u81f3\u4e8e\u5427\u3002\u65b0\u4e1a\u52a1\u561b\uff0c\u4e0d\u7a33\u5b9a\u5728\u6240\u96be\u514d\u3002\u522b\u62c5\u5fc3\uff0c\u56de\u5934\u6211\u5e2e\u4f60\u95ee\u95ee\u4ec0\u4e48\u60c5\u51b5\u3002",
              "options": [{
                  "id": 3,
                  "point": -1,
                  "description": "\u592a\u8c22\u8c22\u4e86\uff01\u4e3a\u4e86\u8fd9\u4e8b\uff0c\u6211\u4eec\u90fd\u5feb\u6101\u6b7b\u4e86\uff01\u987e\u5ba2\u5230\u5e97\u91cc\u4e70\u4e0d\u5230\u4e1c\u897f\uff0c\u53c8\u4e0d\u80fd\u53ca\u65f6\u6536\u5230\u5feb\u9012\uff0c\u52a8\u4e0d\u52a8\u5c31\u7ed9\u5dee\u8bc4\u3002",
                  "short_description": null,
                  "addition": "",
                  "selected": false,
                  "ka": -1,
                  "nextQuestionId": 3321
              }, {
                  "id": 2,
                  "point": 1,
                  "description": "\u90a3\u591a\u8c22\u4f60\u4e86\u3002\u5b9e\u4f53\u5e97\u7684\u7269\u6d41\u95ee\u9898\uff0c\u8981\u8bf7\u4f60\u60f3\u60f3\u529e\u6cd5\u89e3\u51b3\u3002\u5426\u5219\uff0c\u987e\u5ba2\u62b1\u6028\u8d8a\u6765\u8d8a\u591a\uff0c\u5bf9\u516c\u53f8\u5f71\u54cd\u4e5f\u5f88\u5927\u3002",
                  "short_description": null,
                  "addition": "",
                  "selected": false,
                  "ka": 1,
                  "nextQuestionId": 3314
              }, {
                  "id": 1,
                  "point": 3,
                  "description": "\u95e8\u5e97\u7b79\u5907\u65f6\u7269\u6d41\u90e8\u5e2e\u4e86\u5f88\u5927\u7684\u5fd9,\u6211\u4eec\u5f88\u611f\u6fc0\u3002\u6211\u77e5\u9053\u4f60\u4eec\u7279\u522b\u5fd9\uff0c\u4f46\u73b0\u5728\u7684\u72b6\u51b5\u8ba9\u4eba\u5934\u75bc\uff0c\u4f60\u6765\u542c\u542c\u8fd9\u6bb5\u5f55\u97f3\u3002",
                  "short_description": null,
                  "addition": "\u8bed\u97f3\u64ad\u653e",
                  "selected": false,
                  "ka": 1,
                  "nextQuestionId": 3314
              }],
              "directorComment": "\u4f60\u6025\u5f97\u7126\u5934\u70c2\u989d\uff0c\u5bf9\u65b9\u5374\u5e76\u4e0d\u91cd\u89c6\u3002\u8be5\u600e\u4e48\u8ba9\u5bf9\u65b9\u610f\u8bc6\u5230\u95ee\u9898\u7684\u4e25\u91cd\u6027\u5462\uff1f",
              "expression": "\u51b7\u6f20",
              "description_length": 1
          }, {
              "id": 3320,
              "description": "\u90a3\u771f\u662f\u62b1\u6b49\u4e86\u3002\u6700\u8fd1\u5b9e\u5728\u662f\u4eba\u624b\u592a\u7d27\uff0c\u91cd\u70b9\u9879\u76ee\u5927\u8001\u677f\u90fd\u4eb2\u81ea\u76ef\u7740\u5462\u3002\u5b9e\u4f53\u5e97\u90a3\u5757\u662f\u6709\u70b9\u987e\u4e0d\u8fc7\u6765\u3002",
              "options": [{
                  "id": 3,
                  "point": 6,
                  "description": "\u4f60\u4eec\u56e2\u961f\u4e0a\u4e0b\u90fd\u5728\u8d85\u8d1f\u8377\u5de5\u4f5c\uff0c\u771f\u7684\u5f88\u8f9b\u82e6\u3002\u4f46\u6211\u4eec\u78b0\u5230\u7684\u60c5\u51b5\u4e5f\u5f88\u5934\u75bc\u3002\u558f\uff0c\u4f60\u6765\u542c\u542c\u8fd9\u6bb5\u5f55\u97f3\u3002",
                  "short_description": null,
                  "addition": "\u8bed\u97f3\u64ad\u653e",
                  "selected": false,
                  "ka": 1,
                  "nextQuestionId": 3313
              }, {
                  "id": 2,
                  "point": 2,
                  "description": "\u4f46\u5b9e\u4f53\u5e97\u7684\u95ee\u9898\u8fd8\u771f\u5f97\u8bf7\u4f60\u5e2e\u5fd9\u60f3\u60f3\u529e\u6cd5\u3002\u5426\u5219\uff0c\u987e\u5ba2\u62b1\u6028\u8d8a\u6765\u8d8a\u591a\uff0c\u5bf9\u516c\u53f8\u5f71\u54cd\u4e5f\u5f88\u5927\u3002",
                  "short_description": null,
                  "addition": "",
                  "selected": false,
                  "ka": 1,
                  "nextQuestionId": 3313
              }, {
                  "id": 1,
                  "point": -1,
                  "description": "\u8fd9\u8bdd\u4ec0\u4e48\u610f\u601d\uff01\u5927\u8001\u677f\u5173\u6ce8\u7684\u4f60\u4eec\u624d\u505a\uff1f\u6211\u4eec\u5b9e\u4f53\u5e97\u4e5f\u662f\u516c\u53f8\u7684\u6218\u7565\u91cd\u70b9\u554a\u3002\u8fd9\u4e5f\u592a\u539a\u6b64\u8584\u5f7c\u4e86\u5427\uff01",
                  "short_description": null,
                  "addition": "",
                  "selected": false,
                  "ka": -1,
                  "nextQuestionId": 3312
              }],
              "directorComment": "\u5728\u5bf9\u65b9\u770b\u6765\uff0c\u4f60\u7684\u95ee\u9898\u4f18\u5148\u7ea7\u4e0d\u9ad8\uff0c\u600e\u4e48\u7834\uff1f",
              "expression": "\u6b63\u5e38",
              "description_length": 1
          }, {
              "id": 3321,
              "description": "\u6211\u77e5\u9053\u4f60\u4eec\u4e0d\u5bb9\u6613\uff0c\u4f46\u662f\u5c31\u50cf\u6211\u521a\u624d\u8bf4\u7684\uff0c\u6700\u8fd1\u9879\u76ee\u591a\u3001\u4eba\u624b\u7d27\uff0c\u4f60\u8981\u6211\u4eec\u505a\u5230\u50cf\u90a3\u79cd\u5927\u578b\u96f6\u552e\u5546\u7684\u54cd\u5e94\u901f\u5ea6\uff0c\u5f88\u96be\u3002",
              "options": [{
                  "id": 3,
                  "point": 9,
                  "description": "\u6211\u611f\u89c9\u65f6\u95f4\u548c\u4eba\u624b\u662f\u73b0\u5728\u6700\u5927\u7684\u96be\u70b9\u3002\u9664\u6b64\u4e4b\u5916\uff0c\u4f60\u4eec\u8fd8\u4f1a\u6709\u5176\u4ed6\u7684\u56f0\u6270\u5417\uff1f",
                  "short_description": null,
                  "addition": "",
                  "selected": false,
                  "ka": 3,
                  "nextQuestionId": 3326
              }, {
                  "id": 2,
                  "point": 1,
                  "description": "\u6709\u96be\u5904\uff0c\u6211\u4eec\u5c31\u914d\u5408\u4f60\u4eec\u89e3\u51b3\u561b\u3002\u4f60\u89c9\u5f97\u4f1a\u9700\u8981\u4ec0\u4e48\u6837\u7684\u8d44\u6e90\u652f\u6301\uff1f",
                  "short_description": null,
                  "addition": "",
                  "selected": false,
                  "ka": 3,
                  "nextQuestionId": 3325
              }, {
                  "id": 1,
                  "point": -1,
                  "description": "\u4f60\u653e\u5fc3\uff0c\u95ee\u9898\u89e3\u51b3\u80af\u5b9a\u4e0d\u662f\u7269\u6d41\u4e00\u4e2a\u90e8\u95e8\u7684\u4e8b\u60c5\u3002\u6211\u4eec\u4e00\u5b9a\u4f1a\u5168\u529b\u914d\u5408\u4f60\u4eec\u3002",
                  "short_description": null,
                  "addition": "",
                  "selected": false,
                  "ka": -1,
                  "nextQuestionId": 3325
              }],
              "directorComment": "\u4f60\u7684\u82e6\u5bf9\u65b9\u90fd\u61c2\uff0c\u4f46\u8981\u8ba9\u4ed6\u91c7\u53d6\u884c\u52a8\uff0c\u4f30\u8ba1\u8fd8\u6709\u4e00\u6bb5\u8def\u8981\u8d70\u3002\u60f3\u60f3\u6240\u5b66\u7684\u4e03\u5927\u7b56\u7565\u3001\u4e09\u79cd\u5305\u88c5\uff0c\u5e94\u8be5\u5982\u4f55\u7528\u6765\u5f71\u54cd\u5bf9\u65b9\uff1f",
              "expression": "\u51b7\u6f20",
              "description_length": 1
          }, {
              "id": 3322,
              "description": "\u4f60\u8fd9\u4e48\u8bf4\uff0c\u53ef\u592a\u4e3a\u96be\u6211\u4e86\u3002",
              "options": [{
                  "id": 3,
                  "point": 9,
                  "description": "\u6211\u611f\u89c9\u65f6\u95f4\u548c\u4eba\u624b\u662f\u73b0\u5728\u6700\u5927\u7684\u96be\u70b9\u3002\u9664\u6b64\u4e4b\u5916\uff0c\u4f60\u4eec\u8fd8\u4f1a\u6709\u5176\u4ed6\u7684\u56f0\u6270\u5417\uff1f",
                  "short_description": null,
                  "addition": "",
                  "selected": false,
                  "ka": 3,
                  "nextQuestionId": 3326
              }, {
                  "id": 2,
                  "point": 1,
                  "description": "\u6709\u96be\u5904\uff0c\u6211\u4eec\u5c31\u914d\u5408\u4f60\u4eec\u89e3\u51b3\u561b\u3002\u4f60\u89c9\u5f97\u4f1a\u9700\u8981\u4ec0\u4e48\u6837\u7684\u8d44\u6e90\u652f\u6301\uff1f",
                  "short_description": null,
                  "addition": "",
                  "selected": false,
                  "ka": 3,
                  "nextQuestionId": 3325
              }, {
                  "id": 1,
                  "point": -1,
                  "description": "\u4f60\u653e\u5fc3\uff0c\u95ee\u9898\u89e3\u51b3\u80af\u5b9a\u4e0d\u662f\u7269\u6d41\u4e00\u4e2a\u90e8\u95e8\u7684\u4e8b\u60c5\u3002\u6211\u4eec\u4e00\u5b9a\u4f1a\u5168\u529b\u914d\u5408\u4f60\u4eec\u3002",
                  "short_description": null,
                  "addition": "",
                  "selected": false,
                  "ka": -1,
                  "nextQuestionId": 3325
              }],
              "directorComment": "\u201c\u5356\u9762\u5b50\u201d\u53ef\u4e0d\u662f\u8d62\u5f97\u627f\u8bfa\u7684\u552f\u4e00\u62db\u6570\uff0c\u60f3\u60f3\u6240\u5b66\u7684\u4e03\u5927\u7b56\u7565\u3001\u4e09\u79cd\u5305\u88c5\uff0c\u6709\u6ca1\u6709\u66f4\u597d\u7684\u5999\u62db\u6765\u5f71\u54cd\u5bf9\u65b9\uff1f",
              "expression": "\u6297\u62d2",
              "description_length": 1
          }, {
              "id": 3323,
              "description": "\u3010\u76b1\u7709\u3011\u5e72\u6211\u4eec\u8fd9\u4e00\u884c\u7684\uff0c\u771f\u662f\u201c\u505a\u5f97\u597d\uff0c\u6ca1\u4eba\u5938\uff1b\u6709\u95ee\u9898\uff0c\u4e00\u5806\u9a82\u201d\u3002\u5509\uff0c\u771f\u662f\u7684\uff01\u600e\u4e48\u4e8b\u60c5\u90fd\u51d1\u5728\u4e00\u8d77\u4e86\u3002",
              "options": [{
                  "id": 3,
                  "point": 9,
                  "description": "\u6211\u611f\u89c9\u65f6\u95f4\u548c\u4eba\u624b\u662f\u73b0\u5728\u6700\u5927\u7684\u96be\u70b9\u3002\u9664\u6b64\u4e4b\u5916\uff0c\u4f60\u4eec\u8fd8\u4f1a\u6709\u5176\u4ed6\u7684\u56f0\u6270\u5417\uff1f",
                  "short_description": null,
                  "addition": "",
                  "selected": false,
                  "ka": 3,
                  "nextQuestionId": 3326
              }, {
                  "id": 1,
                  "point": -1,
                  "description": "\u4f60\u653e\u5fc3\uff0c\u95ee\u9898\u89e3\u51b3\u80af\u5b9a\u4e0d\u662f\u7269\u6d41\u4e00\u4e2a\u90e8\u95e8\u7684\u4e8b\u60c5\u3002\u6211\u4eec\u4e00\u5b9a\u4f1a\u5168\u529b\u914d\u5408\u4f60\u4eec\u3002",
                  "short_description": null,
                  "addition": "",
                  "selected": false,
                  "ka": -1,
                  "nextQuestionId": 3325
              }, {
                  "id": 2,
                  "point": 1,
                  "description": "\u6709\u96be\u5904\uff0c\u6211\u4eec\u5c31\u914d\u5408\u4f60\u4eec\u89e3\u51b3\u561b\u3002\u4f60\u89c9\u5f97\u4f1a\u9700\u8981\u4ec0\u4e48\u6837\u7684\u8d44\u6e90\u652f\u6301\uff1f",
                  "short_description": null,
                  "addition": "",
                  "selected": false,
                  "ka": 3,
                  "nextQuestionId": 3325
              }],
              "directorComment": "\u6709\u7406\u6709\u636e\uff0c\u6210\u529f\u5f15\u8d77\u5bf9\u65b9\u6ce8\u610f\uff01",
              "expression": "\u4e3a\u96be",
              "description_length": 1
          }, {
              "id": 3324,
              "description": "\u4f60\u8bf4\u7684\u662f\u6ca1\u9519\uff0c\u8c01\u4e0d\u60f3\u628a\u91d1\u4e3b\u90fd\u4f3a\u5019\u597d\u5462\uff1f\u4f46\u4eba\u624b\u4e0d\u8db3\uff0c\u8d44\u6e90\u6709\u9650\uff0c\u6211\u4eec\u603b\u5f97\u987e\u5168\u5927\u5c40\uff0c\u4f60\u7406\u89e3\u5427\uff1f",
              "options": [{
                  "id": 3,
                  "point": 9,
                  "description": "\u6211\u611f\u89c9\u65f6\u95f4\u548c\u4eba\u624b\u662f\u73b0\u5728\u6700\u5927\u7684\u96be\u70b9\u3002\u9664\u6b64\u4e4b\u5916\uff0c\u4f60\u4eec\u8fd8\u4f1a\u6709\u5176\u4ed6\u7684\u56f0\u6270\u5417\uff1f",
                  "short_description": null,
                  "addition": "",
                  "selected": false,
                  "ka": 3,
                  "nextQuestionId": 3326
              }, {
                  "id": 2,
                  "point": 1,
                  "description": "\u6709\u96be\u5904\uff0c\u6211\u4eec\u5c31\u914d\u5408\u4f60\u4eec\u89e3\u51b3\u561b\u3002\u4f60\u89c9\u5f97\u4f1a\u9700\u8981\u4ec0\u4e48\u6837\u7684\u8d44\u6e90\u652f\u6301\uff1f",
                  "short_description": null,
                  "addition": "",
                  "selected": false,
                  "ka": 3,
                  "nextQuestionId": 3325
              }, {
                  "id": 1,
                  "point": -1,
                  "description": "\u4f60\u653e\u5fc3\uff0c\u95ee\u9898\u89e3\u51b3\u80af\u5b9a\u4e0d\u662f\u7269\u6d41\u4e00\u4e2a\u90e8\u95e8\u7684\u4e8b\u60c5\u3002\u6211\u4eec\u4e00\u5b9a\u4f1a\u5168\u529b\u914d\u5408\u4f60\u4eec\u3002",
                  "short_description": null,
                  "addition": "",
                  "selected": false,
                  "ka": -1,
                  "nextQuestionId": 3325
              }],
              "directorComment": "\u5bf9\u65b9\u7684\u89c2\u70b9\u4f3c\u4e4e\u4e5f\u5728\u7406\uff0c\u5e94\u8be5\u5982\u4f55\u5f71\u54cd\u5bf9\u65b9\u5462\uff1f\u60f3\u60f3\u6240\u5b66\u7684\u4e03\u5927\u7b56\u7565\u3001\u4e09\u79cd\u5305\u88c5\uff0c\u603b\u6709\u4e00\u6b3e\u9002\u5408\u4f60\u3002",
              "expression": "\u6297\u62d2",
              "description_length": 1
          }, {
              "id": 3325,
              "description": "\u4e0d\u662f\u914d\u4e0d\u914d\u5408\u7684\u95ee\u9898\u3002\u8bf4\u5b9e\u8bdd\uff0c\u4f60\u4eec\u7684\u4e1a\u52a1\u91cf\u8ddf\u7ebf\u4e0a\u6ca1\u6cd5\u6bd4\uff0c\u8c03\u6574\u4f9b\u5e94\u94fe\u7684\u4ee3\u4ef7\u5374\u5f88\u9ad8\u3002\u5bf9\u6211\u4eec\u6765\u8bf4\uff0c\u6536\u76ca\u6ca1\u591a\u5c11\uff0c\u9ebb\u70e6\u4e00\u5927\u5806\u3002",
              "options": [{
                  "id": 3,
                  "point": -1,
                  "description": "\u8fd9\u8fd8\u662f\u8d44\u6e90\u4e0d\u591f\u9020\u6210\u7684\u5427\u3002\u6211\u53ef\u4ee5\u53bb\u5c3d\u91cf\u4e89\u53d6\u4e9b\u989d\u5916\u9884\u7b97\u3001\u6dfb\u52a0\u4e9b\u4eba\u624b\uff0c\u600e\u4e48\u6837\uff1f",
                  "short_description": null,
                  "addition": "",
                  "selected": false,
                  "ka": -1,
                  "nextQuestionId": 3329
              }, {
                  "id": 2,
                  "point": 9,
                  "description": "\u6211\u4e0d\u6562\u8bf4\u8fd9\u6837\u505a\u5bf9\u4f60\u4eec\u6ca1\u5f71\u54cd\u3002\u4f46\u516c\u53f8\u5f00\u5b9e\u4f53\u5e97\uff0c\u662f\u8981\u7ed9\u987e\u5ba2\u4f18\u8d28\u4f53\u9a8c\u3002\u5982\u679c\u505a\u4e0d\u5230\uff0c\u5c31\u548c\u521d\u8877\u80cc\u9053\u800c\u9a70\u4e86\u3002",
                  "short_description": null,
                  "addition": "",
                  "selected": false,
                  "ka": 1,
                  "nextQuestionId": 3328
              }, {
                  "id": 1,
                  "point": 2,
                  "description": "\u8001\u79e6\uff0c\u8fd9\u4ef6\u4e8b\u5bf9\u4f60\u4eec\u4e5f\u662f\u6709\u597d\u5904\u7684\u3002\u96f6\u552e\u4e1a\u7684\u4f9b\u5e94\u94fe\u8f6c\u578b\u662f\u65e9\u665a\u7684\u4e8b\u3002\u6211\u4eec\u73b0\u5728\u5c31\u505a\uff0c\u4e3b\u52a8\u6743\u8fd8\u5728\u6211\u4eec\u624b\u4e0a\u3002",
                  "short_description": null,
                  "addition": "",
                  "selected": false,
                  "ka": 1,
                  "nextQuestionId": 3327
              }],
              "directorComment": "\u5bf9\u65b9\u632f\u632f\u6709\u8bcd\uff0c\u4f60\u8be5\u5982\u4f55\u63a5\u62db\uff1f",
              "expression": "\u4e3a\u96be",
              "description_length": 1
          }, {
              "id": 3326,
              "description": "\u6211\u8ddf\u4f60\u8bb2\u53e5\u5b9e\u8bdd\uff0c\u4f60\u4eec\u7684\u4e1a\u52a1\u91cf\u8ddf\u7ebf\u4e0a\u6ca1\u6cd5\u6bd4\uff0c\u8c03\u6574\u4f9b\u5e94\u94fe\u7684\u4ee3\u4ef7\u5374\u5f88\u9ad8\u3002\u5bf9\u6211\u4eec\u6765\u8bf4\uff0c\u6536\u76ca\u6ca1\u591a\u5c11\uff0c\u9ebb\u70e6\u4e00\u5927\u5806\u3002",
              "options": [{
                  "id": 3,
                  "point": -1,
                  "description": "\u8fd9\u8fd8\u662f\u8d44\u6e90\u4e0d\u591f\u9020\u6210\u7684\u5427\u3002\u6211\u53ef\u4ee5\u53bb\u5c3d\u91cf\u4e89\u53d6\u4e9b\u989d\u5916\u9884\u7b97\u3001\u6dfb\u52a0\u4e9b\u4eba\u624b\uff0c\u600e\u4e48\u6837\uff1f",
                  "short_description": null,
                  "addition": "",
                  "selected": false,
                  "ka": -1,
                  "nextQuestionId": 3329
              }, {
                  "id": 2,
                  "point": 9,
                  "description": "\u6211\u4e0d\u6562\u8bf4\u8fd9\u6837\u505a\u5bf9\u4f60\u4eec\u6ca1\u5f71\u54cd\u3002\u4f46\u516c\u53f8\u5f00\u5b9e\u4f53\u5e97\uff0c\u662f\u8981\u7ed9\u987e\u5ba2\u4f18\u8d28\u4f53\u9a8c\u3002\u5982\u679c\u505a\u4e0d\u5230\uff0c\u5c31\u548c\u521d\u8877\u80cc\u9053\u800c\u9a70\u4e86\u3002",
                  "short_description": null,
                  "addition": "",
                  "selected": false,
                  "ka": 1,
                  "nextQuestionId": 3328
              }, {
                  "id": 1,
                  "point": 2,
                  "description": "\u8001\u79e6\uff0c\u8fd9\u4ef6\u4e8b\u5bf9\u4f60\u4eec\u4e5f\u662f\u6709\u597d\u5904\u7684\u3002\u96f6\u552e\u4e1a\u7684\u4f9b\u5e94\u94fe\u8f6c\u578b\u662f\u65e9\u665a\u7684\u4e8b\u3002\u6211\u4eec\u73b0\u5728\u5c31\u505a\uff0c\u4e3b\u52a8\u6743\u8fd8\u5728\u6211\u4eec\u624b\u4e0a\u3002",
                  "short_description": null,
                  "addition": "",
                  "selected": false,
                  "ka": 1,
                  "nextQuestionId": 3327
              }],
              "directorComment": "\u5bf9\u65b9\u632f\u632f\u6709\u8bcd\uff0c\u4f60\u8be5\u5982\u4f55\u63a5\u62db\uff1f",
              "expression": "\u4e3a\u96be",
              "description_length": 1
          }, {
              "id": 3327,
              "description": "\u3010\u4e0d\u8010\u70e6\u3011\u8fd8\u7528\u4f60\u6765\u544a\u8bc9\u6211\u8981\u4e0d\u8981\u8f6c\u578b\u5417\uff1f\u4f60\u7684\u610f\u601d\u6211\u660e\u767d\u3002\u8fd9\u6837\u5427\uff0c\u7ed9\u6211\u4e24\u4e2a\u661f\u671f\u3002\u53ea\u8981\u624b\u5934\u7684\u8fd9\u4e2a\u9879\u76ee\u544a\u4e00\u6bb5\u843d\uff0c\u6211\u5c31\u53bb\u7422\u78e8\u600e\u4e48\u63d0\u9ad8\u5b9e\u4f53\u5e97\u914d\u9001\u7684\u54cd\u5e94\u5ea6\u3002",
              "options": [{
                  "id": 3,
                  "point": -1,
                  "description": "\u8001\u79e6\uff0c\u5e2e\u4eba\u5e2e\u5230\u5e95\u3002\u73b0\u5728\u5341\u4e07\u706b\u6025\u7684\uff0c\u53ef\u7b49\u4e0d\u5f97\u4f60\u6162\u6162\u7422\u78e8\u554a\uff01\u81f3\u5c11\u7ed9\u6211\u4e2a\u77ed\u671f\u65b9\u6848\u6551\u6551\u6025\u3002",
                  "short_description": null,
                  "addition": "",
                  "selected": false,
                  "ka": -1,
                  "nextQuestionId": 3332
              }, {
                  "id": 2,
                  "point": 9,
                  "description": "\u8001\u79e6\uff0c\u54b1\u4eec\u8fd9\u884c\u5c31\u662f\u8981\u8ddf\u65f6\u95f4\u8d5b\u8dd1\u3002\u8bb0\u5f97\u53bb\u5e74\u7ade\u4e89\u5bf9\u624b\u7684\u5ba2\u670d\u4e8b\u4ef6\u5417\uff1f\u5c31\u662f\u6ca1\u53ca\u65f6\u54cd\u5e94\uff0c\u4e8b\u540e\u518d\u600e\u4e48\u516c\u5173\u90fd\u662f\u767d\u642d\u3002",
                  "short_description": null,
                  "addition": "",
                  "selected": false,
                  "ka": 2,
                  "nextQuestionId": 3331
              }, {
                  "id": 1,
                  "point": -1,
                  "description": "\u884c\u5427\uff0c\u6211\u4eec\u5b9a\u4e00\u4e0b\u5177\u4f53\u65b9\u6848\uff0c\u6211\u4eec\u5168\u529b\u914d\u5408\u4f60\u3002",
                  "short_description": null,
                  "addition": "",
                  "selected": false,
                  "ka": -1,
                  "nextQuestionId": 3330
              }],
              "directorComment": "\u201c\u63d0\u5021\u76ca\u5904\u201d\u8fd9\u62db\u4f3c\u4e4e\u5bf9\u8001\u79e6\u65e0\u6548\uff0c\u518d\u8bd5\u8bd5\u5176\u4ed6\u529e\u6cd5\u5427\u3002",
              "expression": "\u6297\u62d2",
              "description_length": 1
          }, {
              "id": 3328,
              "description": "\u5514\u2026\u2026\u6211\u77e5\u9053\u4f60\u4e5f\u4e0d\u5bb9\u6613\u3002\u8fd9\u6837\u5427\uff0c\u7ed9\u6211\u4e24\u4e2a\u661f\u671f\u3002\u53ea\u8981\u624b\u5934\u7684\u8fd9\u4e2a\u9879\u76ee\u544a\u4e00\u6bb5\u843d\uff0c\u6211\u5c31\u53bb\u7422\u78e8\u600e\u4e48\u63d0\u9ad8\u5b9e\u4f53\u5e97\u914d\u9001\u7684\u54cd\u5e94\u5ea6\u3002",
              "options": [{
                  "id": 3,
                  "point": -1,
                  "description": "\u8001\u79e6\uff0c\u5e2e\u4eba\u5e2e\u5230\u5e95\u3002\u73b0\u5728\u5341\u4e07\u706b\u6025\u7684\uff0c\u53ef\u7b49\u4e0d\u5f97\u4f60\u6162\u6162\u7422\u78e8\u554a\uff01\u81f3\u5c11\u7ed9\u6211\u4e2a\u77ed\u671f\u65b9\u6848\u6551\u6551\u6025\u3002",
                  "short_description": null,
                  "addition": "",
                  "selected": false,
                  "ka": -1,
                  "nextQuestionId": 3332
              }, {
                  "id": 2,
                  "point": 9,
                  "description": "\u8001\u79e6\uff0c\u54b1\u4eec\u8fd9\u884c\u5c31\u662f\u8981\u8ddf\u65f6\u95f4\u8d5b\u8dd1\u3002\u8bb0\u5f97\u53bb\u5e74\u7ade\u4e89\u5bf9\u624b\u7684\u5ba2\u670d\u4e8b\u4ef6\u5417\uff1f\u5c31\u662f\u6ca1\u53ca\u65f6\u54cd\u5e94\uff0c\u4e8b\u540e\u518d\u600e\u4e48\u516c\u5173\u90fd\u662f\u767d\u642d\u3002",
                  "short_description": null,
                  "addition": "",
                  "selected": false,
                  "ka": 2,
                  "nextQuestionId": 3331
              }, {
                  "id": 1,
                  "point": -1,
                  "description": "\u884c\u5427\uff0c\u6211\u4eec\u5b9a\u4e00\u4e0b\u5177\u4f53\u65b9\u6848\uff0c\u6211\u4eec\u5168\u529b\u914d\u5408\u4f60\u3002",
                  "short_description": null,
                  "addition": "",
                  "selected": false,
                  "ka": -1,
                  "nextQuestionId": 3330
              }],
              "directorComment": "\u8fd9\u62db\u6709\u7528\uff0c\u8001\u79e6\u6001\u5ea6\u6709\u6240\u677e\u52a8\u3002",
              "expression": "\u6b63\u5e38",
              "description_length": 1
          }, {
              "id": 3329,
              "description": "\u3010\u4e0d\u8010\u70e6\u3011\u8ddf\u4f60\u8bf4\u4e0d\u662f\u2026\u2026\u5509\uff0c\u884c\u4e86\u884c\u4e86\uff0c\u54b1\u4eec\u522b\u7ed5\u4e86\u3002\u8bf4\u5427\uff0c\u4f60\u5230\u5e95\u60f3\u600e\u4e48\u505a\uff1f",
              "options": [{
                  "id": 3,
                  "point": 3,
                  "description": "\u95e8\u5e97\u7269\u6d41\u7684\u95ee\u9898\u6709\u4e24\u4e2a\uff1a\u914d\u9001\u54cd\u5e94\u901f\u5ea6\u6162\u3001\u201c\u9001\u8d27\u4e0a\u95e8\u201d\u670d\u52a1\u51c6\u65f6\u7387\u4f4e\u3002\u6240\u4ee5\u6211\u7684\u5efa\u8bae\u662f\u3010\u7ed9\u51fa\u5efa\u8bae\u2026\u2026\u3011",
                  "short_description": null,
                  "addition": "",
                  "selected": false,
                  "ka": 5,
                  "nextQuestionId": 3355
              }, {
                  "id": 1,
                  "point": 3,
                  "description": "\u6211\u4eec\u4e00\u4e2a\u4e2a\u6765\u770b\uff0c\u5148\u8bf4\u95e8\u5e97\u914d\u9001\u95ee\u9898\u5427\u3002",
                  "short_description": null,
                  "addition": "",
                  "selected": false,
                  "ka": 5,
                  "nextQuestionId": 3354
              }, {
                  "id": 2,
                  "point": 9,
                  "description": "\u95e8\u5e97\u7269\u6d41\u7684\u4e3b\u8981\u95ee\u9898\u6709\u4e24\u4e2a\uff1a\u4f9b\u8d27\u901f\u5ea6\u6162\u3001\u201c\u9001\u8d27\u4e0a\u95e8\u201d\u670d\u52a1\u51c6\u65f6\u7387\u4f4e\u3002\u4f60\u89c9\u5f97\u54ea\u4e9b\u53ef\u4ee5\u5148\u505a\u8c03\u6574\u5462\uff1f",
                  "short_description": null,
                  "addition": "",
                  "selected": false,
                  "ka": 5,
                  "nextQuestionId": 3354
              }],
              "directorComment": "\u5bf9\u65b9\u6709\u60c5\u7eea\uff0c\u8be5\u5982\u4f55\u8ddf\u4ed6\u8c08\u65b9\u6848\u5462\uff1f",
              "expression": "\u6297\u62d2",
              "description_length": 1
          }, {
              "id": 3330,
              "description": "\u5230\u65f6\u5019\u518d\u8bf4\u5427\u3002\u6211\u6bd5\u7adf\u5bf9\u5b9e\u4f53\u5e97\u7684\u8fd0\u4f5c\u8fd8\u4e0d\u592a\u4e86\u89e3\uff0c\u9700\u8981\u505a\u70b9\u529f\u8bfe\u3002",
              "options": [{
                  "id": 3,
                  "point": 3,
                  "description": "\u6211\u5012\u662f\u5bf9\u65b0\u96f6\u552e\u7684\u7269\u6d41\u505a\u4e86\u70b9\u7814\u7a76\u3002\u558f\uff0c\u8fd9\u662f\u767d\u76ae\u4e66\u3001\u884c\u4e1a\u62a5\u544a\u2026\u2026\u5e0c\u671b\u5bf9\u4f60\u6709\u5e2e\u52a9\u3002",
                  "short_description": null,
                  "addition": "",
                  "selected": false,
                  "ka": 1,
                  "nextQuestionId": 3335
              }, {
                  "id": 2,
                  "point": 9,
                  "description": "\u7efc\u5408\u8fd0\u8425\u90e8\u7684\u5b63\u7ecf\u7406\uff0c\u539f\u5148\u5728\u4e00\u5bb6\u5927\u578b\u96f6\u552e\u4f01\u4e1a\u505a\u8fc7\uff0c\u5bf9\u4f53\u9a8c\u5e97\u7684\u6a21\u5f0f\u5f88\u719f\u3002\u5982\u679c\u4f60\u613f\u610f\u7684\u8bdd\uff0c\u6211\u8bf7\u5979\u6765\u5206\u4eab\u7ecf\u9a8c\u3002",
                  "short_description": null,
                  "addition": "\u5b63\u5b81\u4eba\u50cf",
                  "selected": false,
                  "ka": 1,
                  "nextQuestionId": 3334
              }, {
                  "id": 1,
                  "point": 3,
                  "description": "\u660e\u767d\u3002\u6211\u5012\u662f\u6709\u4e2a\u529e\u6cd5\uff1a\u4f60\u4eec\u56e2\u961f\u53ef\u4ee5\u6d3e\u4e00\u4e24\u4e2a\u540c\u4e8b\u6765\u5b9e\u4f53\u5e97\u4f53\u9a8c\uff0c\u719f\u6089\u7ebf\u4e0b\u8fd0\u8425\u6a21\u5f0f\uff0c\u76f8\u4fe1\u4f1a\u6709\u5e2e\u52a9\u3002",
                  "short_description": null,
                  "addition": "",
                  "selected": false,
                  "ka": 1,
                  "nextQuestionId": 3333
              }],
              "directorComment": "\u5bf9\u65b9\u8bf4\u51fa\u987e\u8651\uff0c\u4f60\u8be5\u5982\u4f55\u5e94\u5bf9\uff1f",
              "expression": "\u51b7\u6f20",
              "description_length": 1
          }, {
              "id": 3331,
              "description": "\u55ef\u2026\u2026\u65f6\u95f4\u662f\u633a\u91cd\u8981\u3002\u4f46\u662f\u6211\u62c5\u5fc3\u7684\u662f\uff0c\u5173\u4e8e\u7ebf\u4e0b\u4e1a\u52a1\uff0c\u5927\u5bb6\u90fd\u6ca1\u4ec0\u4e48\u7ecf\u9a8c\uff0c\u6211\u9700\u8981\u65f6\u95f4\u505a\u70b9\u529f\u8bfe\u2026\u2026",
              "options": [{
                  "id": 3,
                  "point": 3,
                  "description": "\u6211\u5012\u662f\u5bf9\u65b0\u96f6\u552e\u7684\u7269\u6d41\u505a\u4e86\u70b9\u7814\u7a76\u3002\u558f\uff0c\u8fd9\u662f\u767d\u76ae\u4e66\u3001\u884c\u4e1a\u62a5\u544a\u2026\u2026\u5e0c\u671b\u5bf9\u4f60\u6709\u5e2e\u52a9\u3002",
                  "short_description": null,
                  "addition": "",
                  "selected": false,
                  "ka": 1,
                  "nextQuestionId": 3335
              }, {
                  "id": 2,
                  "point": 9,
                  "description": "\u7efc\u5408\u8fd0\u8425\u90e8\u7684\u5b63\u7ecf\u7406\uff0c\u539f\u5148\u5728\u4e00\u5bb6\u5927\u578b\u96f6\u552e\u4f01\u4e1a\u505a\u8fc7\uff0c\u5bf9\u4f53\u9a8c\u5e97\u7684\u6a21\u5f0f\u5f88\u719f\u3002\u5982\u679c\u4f60\u613f\u610f\u7684\u8bdd\uff0c\u6211\u8bf7\u5979\u6765\u5206\u4eab\u7ecf\u9a8c\u3002",
                  "short_description": null,
                  "addition": "\u5b63\u5b81\u4eba\u50cf",
                  "selected": false,
                  "ka": 1,
                  "nextQuestionId": 3334
              }, {
                  "id": 1,
                  "point": 3,
                  "description": "\u660e\u767d\u3002\u6211\u5012\u662f\u6709\u4e2a\u529e\u6cd5\uff1a\u4f60\u4eec\u56e2\u961f\u53ef\u4ee5\u6d3e\u4e00\u4e24\u4e2a\u540c\u4e8b\u6765\u5b9e\u4f53\u5e97\u4f53\u9a8c\uff0c\u719f\u6089\u7ebf\u4e0b\u8fd0\u8425\u6a21\u5f0f\uff0c\u76f8\u4fe1\u4f1a\u6709\u5e2e\u52a9\u3002",
                  "short_description": null,
                  "addition": "",
                  "selected": false,
                  "ka": 1,
                  "nextQuestionId": 3333
              }],
              "directorComment": "\u6709\u529b\u8bba\u636e\u518d\u6b21\u6210\u529f\u6253\u52a8\u5bf9\u65b9\uff0c\u4f46\u5bf9\u65b9\u4ecd\u6709\u987e\u8651\uff0c\u4f60\u8be5\u5982\u4f55\u5e94\u5bf9\uff1f",
              "expression": "\u4e3a\u96be",
              "description_length": 1
          }, {
              "id": 3332,
              "description": "\u5927\u5bb6\u90fd\u662f\u5934\u4e00\u56de\u505a\u7ebf\u4e0b\u4e1a\u52a1\uff0c\u6ca1\u4ec0\u4e48\u7ecf\u9a8c\u3002\u518d\u600e\u4e48\u6025\uff0c\u6211\u4eec\u4e5f\u5f97\u5148\u505a\u70b9\u529f\u8bfe\u554a\u3002",
              "options": [{
                  "id": 3,
                  "point": 3,
                  "description": "\u6211\u5012\u662f\u5bf9\u65b0\u96f6\u552e\u7684\u7269\u6d41\u505a\u4e86\u70b9\u7814\u7a76\u3002\u558f\uff0c\u8fd9\u662f\u767d\u76ae\u4e66\u3001\u884c\u4e1a\u62a5\u544a\u2026\u2026\u5e0c\u671b\u5bf9\u4f60\u6709\u5e2e\u52a9\u3002",
                  "short_description": null,
                  "addition": "",
                  "selected": false,
                  "ka": 1,
                  "nextQuestionId": 3335
              }, {
                  "id": 2,
                  "point": 9,
                  "description": "\u7efc\u5408\u8fd0\u8425\u90e8\u7684\u5b63\u7ecf\u7406\uff0c\u539f\u5148\u5728\u4e00\u5bb6\u5927\u578b\u96f6\u552e\u4f01\u4e1a\u505a\u8fc7\uff0c\u5bf9\u4f53\u9a8c\u5e97\u7684\u6a21\u5f0f\u5f88\u719f\u3002\u5982\u679c\u4f60\u613f\u610f\u7684\u8bdd\uff0c\u6211\u8bf7\u5979\u6765\u5206\u4eab\u7ecf\u9a8c\u3002",
                  "short_description": null,
                  "addition": "\u5b63\u5b81\u4eba\u50cf",
                  "selected": false,
                  "ka": 1,
                  "nextQuestionId": 3334
              }, {
                  "id": 1,
                  "point": 3,
                  "description": "\u660e\u767d\u3002\u6211\u5012\u662f\u6709\u4e2a\u529e\u6cd5\uff1a\u4f60\u4eec\u56e2\u961f\u53ef\u4ee5\u6d3e\u4e00\u4e24\u4e2a\u540c\u4e8b\u6765\u5b9e\u4f53\u5e97\u4f53\u9a8c\uff0c\u719f\u6089\u7ebf\u4e0b\u8fd0\u8425\u6a21\u5f0f\uff0c\u76f8\u4fe1\u4f1a\u6709\u5e2e\u52a9\u3002",
                  "short_description": null,
                  "addition": "",
                  "selected": false,
                  "ka": 1,
                  "nextQuestionId": 3333
              }],
              "directorComment": "\u5bf9\u65b9\u8bf4\u51fa\u987e\u8651\uff0c\u4f60\u8be5\u5982\u4f55\u5e94\u5bf9\uff1f",
              "expression": "\u6297\u62d2",
              "description_length": 1
          }, {
              "id": 3333,
              "description": "\u2026\u2026\u8fd9\u6050\u6015\u4e0d\u5408\u9002\u3002\u90fd\u5fd9\u5230\u4eba\u4ef0\u9a6c\u7ffb\u4e86\uff0c\u54ea\u6709\u4eba\u624b\u6765\u7ed9\u4f60\u3002",
              "options": [{
                  "id": 2,
                  "point": 4,
                  "description": "\u8001\u79e6\uff0c\u5176\u4ed6\u96f6\u552e\u4f01\u4e1a\u5df2\u7ecf\u8d70\u5728\u524d\u9762\u4e86\uff0c\u5982\u679c\u6211\u4eec\u8fd8\u8fd9\u6837\uff0c\u8fd9\u5bf9\u6bd4\u3001\u8fd9\u843d\u5dee\uff0c\u592a\u624e\u5fc3\u4e86\u3002",
                  "short_description": null,
                  "addition": "",
                  "selected": false,
                  "ka": 2,
                  "nextQuestionId": 3337
              }, {
                  "id": 1,
                  "point": 3,
                  "description": "\u8981\u4e0d\u6211\u4eec\u8ba9\u8fd0\u8425\u90e8\u7684\u5b63\u7ecf\u7406\u6765\u5206\u4eab\u4e00\u4e0b\u5979\u4ee5\u524d\u516c\u53f8\u7684\u7ecf\u9a8c\uff1f",
                  "short_description": null,
                  "addition": "\u5b63\u5b81\u4eba\u50cf",
                  "selected": false,
                  "ka": 1,
                  "nextQuestionId": 3336
              }],
              "directorComment": "\u65b9\u6848\u88ab\u62d2\uff0c\u5982\u4f55\u7ee7\u7eed\uff1f",
              "expression": "\u6297\u62d2",
              "description_length": 1
          }, {
              "id": 3334,
              "description": "\u3010\u5341\u4e94\u5206\u949f\u540e\u3011\u5514\uff0c\u5b63\u7ecf\u7406\u5206\u4eab\u4ed6\u4eec\u4ee5\u524d\u516c\u53f8\u7684\u505a\u6cd5\uff0c\u6709\u70b9\u610f\u601d\u3002",
              "options": [{
                  "id": 2,
                  "point": 9,
                  "description": "\u662f\u7684\uff0c\u5f88\u591a\u4f01\u4e1a\u7684\u7269\u6d41\u5df2\u7ecf\u5230\u8fd9\u6837\u7684\u6c34\u5e73\u4e86\u3002\u800c\u6211\u4eec\uff0c\u95ee\u9898\u4e00\u5927\u5806\u3002\u6362\u505a\u4f60\uff0c\u4f60\u60f3\u6765\u6211\u4eec\u7684\u5e97\u4e70\u4e1c\u897f\u5417\uff1f",
                  "short_description": null,
                  "addition": "",
                  "selected": false,
                  "ka": 2,
                  "nextQuestionId": 3339
              }, {
                  "id": 1,
                  "point": 1,
                  "description": "\u4f60\u89c9\u5f97\u8fd9\u5bf9\u89e3\u51b3\u6211\u4eec\u7684\u95ee\u9898\u6709\u5e2e\u52a9\u5417\uff1f",
                  "short_description": null,
                  "addition": "",
                  "selected": false,
                  "ka": 3,
                  "nextQuestionId": 3338
              }],
              "directorComment": "\u53ee\uff0c\u5f71\u54cd\u529b\u4e03\u5927\u7b56\u7565\u4e4b\u201c\u7b2c\u4e09\u65b9\u4ecb\u5165\u201d\u6210\u5c31\u8fbe\u6210\uff0c\u606d\u559c\uff01",
              "expression": "\u63a5\u53d7",
              "description_length": 1
          }, {
              "id": 3335,
              "description": "\u2026\u2026\u8c22\u8c22\uff0c\u8fd9\u4e9b\u884c\u4e1a\u8d44\u8baf\u76f8\u5173\u6027\u4e0d\u9ad8\uff0c\u800c\u4e14\u6700\u8fd1\u54ea\u6709\u529f\u592b\u770b\u3002",
              "options": [{
                  "id": 2,
                  "point": 4,
                  "description": "\u8001\u79e6\uff0c\u5176\u4ed6\u96f6\u552e\u4f01\u4e1a\u5df2\u7ecf\u8d70\u5728\u524d\u9762\u4e86\uff0c\u5982\u679c\u6211\u4eec\u8fd8\u8fd9\u6837\uff0c\u8fd9\u5bf9\u6bd4\u3001\u8fd9\u843d\u5dee\uff0c\u592a\u624e\u5fc3\u4e86\u3002",
                  "short_description": null,
                  "addition": "",
                  "selected": false,
                  "ka": 2,
                  "nextQuestionId": 3337
              }, {
                  "id": 1,
                  "point": 3,
                  "description": "\u8981\u4e0d\u6211\u4eec\u8ba9\u8fd0\u8425\u90e8\u7684\u5b63\u7ecf\u7406\u6765\u5206\u4eab\u4e00\u4e0b\u5979\u4ee5\u524d\u516c\u53f8\u7684\u7ecf\u9a8c\uff1f",
                  "short_description": null,
                  "addition": "\u5b63\u5b81\u4eba\u50cf",
                  "selected": false,
                  "ka": 1,
                  "nextQuestionId": 3336
              }],
              "directorComment": "\u65b9\u6848\u88ab\u62d2\uff0c\u5982\u4f55\u7ee7\u7eed\uff1f",
              "expression": "\u51b7\u6f20",
              "description_length": 1
          }, {
              "id": 3336,
              "description": "\u3010\u5341\u4e94\u5206\u949f\u540e\u3011\u5514\uff0c\u6709\u70b9\u610f\u601d\u3002\u6709\u4e9b\u505a\u6cd5\u5f88\u6709\u7a81\u7834\u6027\u3002",
              "options": [{
                  "id": 1,
                  "point": -1,
                  "description": "\u4f60\u89c9\u5f97\u8fd9\u5bf9\u6211\u4eec\u7684\u95ee\u9898\u6709\u5e2e\u52a9\u5417\uff1f",
                  "short_description": null,
                  "addition": "",
                  "selected": false,
                  "ka": -1,
                  "nextQuestionId": 3340
              }, {
                  "id": 2,
                  "point": 3,
                  "description": "\u662f\u7684\uff0c\u5f88\u591a\u4f01\u4e1a\u7684\u7269\u6d41\u5df2\u7ecf\u5230\u8fd9\u6837\u7684\u6c34\u5e73\u4e86\u3002\u800c\u6211\u4eec\uff0c\u95ee\u9898\u4e00\u5927\u5806\u3002\u6362\u505a\u4f60\uff0c\u4f60\u60f3\u6765\u6211\u4eec\u7684\u5e97\u4e70\u4e1c\u897f\u5417\uff1f",
                  "short_description": null,
                  "addition": "",
                  "selected": false,
                  "ka": 2,
                  "nextQuestionId": 3341
              }],
              "directorComment": "\u53ee\uff0c\u5f71\u54cd\u529b\u4e03\u5927\u7b56\u7565\u4e4b\u201c\u7b2c\u4e09\u65b9\u4ecb\u5165\u201d\u6210\u5c31\u8fbe\u6210\uff0c\u606d\u559c\uff01",
              "expression": "\u63a5\u53d7",
              "description_length": 1
          }, {
              "id": 3337,
              "description": "\u522b\u8188\u5e94\u6211\u4e86\u2026\u2026",
              "options": [{
                  "id": 3,
                  "point": -1,
                  "description": "\u6211\u548c\u4f60\u7684\u60f3\u6cd5\u4e00\u6837\u3002\u4e0d\u5e0c\u671b\u5ba2\u6237\u5230\u4e86\u6211\u4eec\u5e97\u91cc\uff0c\u8981\u4ec0\u4e48\u6ca1\u4ec0\u4e48\u3002",
                  "short_description": null,
                  "addition": "",
                  "selected": false,
                  "ka": -1,
                  "nextQuestionId": 3347
              }, {
                  "id": 2,
                  "point": 9,
                  "description": "\u53e6\u5916\uff0c\u8bf7\u4f60\u770b\u770b\u8fd9\u51e0\u5f20\u5728\u5e97\u91cc\u62cd\u7684\u7167\u7247\u3002\u201c\u8981\u4ec0\u4e48\u6ca1\u4ec0\u4e48\u201d\u7684\u60c5\u51b5\u5df2\u7ecf\u6709\u4e00\u6bb5\u65f6\u95f4\u4e86\uff0c\u771f\u5e0c\u671b\u4e0d\u4f1a\u518d\u7ee7\u7eed\u4e0b\u53bb\u4e86\u3002",
                  "short_description": null,
                  "addition": "\u624b\u6301\u624b\u673a\u5c55\u793a\u7167\u7247",
                  "selected": false,
                  "ka": 2,
                  "nextQuestionId": 3346
              }, {
                  "id": 1,
                  "point": 1,
                  "description": "\u6240\u4ee5\uff0c\u6253\u94c1\u8981\u8d81\u70ed\uff0c\u6211\u4eec\u4e00\u8d77\u60f3\u60f3\u89e3\u51b3\u65b9\u6848\u5427\u3002",
                  "short_description": null,
                  "addition": "",
                  "selected": false,
                  "ka": 5,
                  "nextQuestionId": 3345
              }],
              "directorComment": "\u8001\u94c1\uff0c\u4f60\u7684\u8fd9\u53e5\u8bdd\u4e5f\u6709\u70b9\u624e\u5fc3\u4e86\u2026\u2026\u63a5\u4e0b\u6765\uff0c\u8be5\u5982\u4f55\u7ee7\u7eed\uff1f",
              "expression": "\u4e3a\u96be",
              "description_length": 1
          }, {
              "id": 3338,
              "description": "\u5f53\u7136\uff0c\u5f88\u6709\u542f\u53d1\u6027\u3002",
              "options": [{
                  "id": 3,
                  "point": 2,
                  "description": "\u90a3\u4f60\u60f3\u60f3\uff0c\u5176\u4ed6\u96f6\u552e\u4f01\u4e1a\u5df2\u7ecf\u8d70\u5728\u524d\u9762\u4e86\uff0c\u518d\u770b\u770b\u6211\u4eec\uff0c\u8fd9\u5bf9\u6bd4\u3001\u8fd9\u843d\u5dee\uff0c\u592a\u624e\u5fc3\u4e86\u3002",
                  "short_description": null,
                  "addition": "",
                  "selected": false,
                  "ka": 2,
                  "nextQuestionId": 3344
              }, {
                  "id": 2,
                  "point": 3,
                  "description": "\u90a3\u6211\u627e\u5bf9\u4eba\u4e86\u3002\u53e6\u5916\uff0c\u4f60\u770b\u8fd9\u51e0\u5f20\u5e97\u5185\u7167\u7247\uff0c\u201c\u8981\u4ec0\u4e48\u6ca1\u4ec0\u4e48\u201d\u7684\u60c5\u51b5\u5df2\u7ecf\u6709\u4e00\u6bb5\u65f6\u95f4\u4e86\uff0c\u5e0c\u671b\u4e0d\u4f1a\u518d\u7ee7\u7eed\u4e0b\u53bb\u4e86\u3002",
                  "short_description": null,
                  "addition": "\u624b\u6301\u624b\u673a\u5c55\u793a\u7167\u7247",
                  "selected": false,
                  "ka": 2,
                  "nextQuestionId": 3343
              }, {
                  "id": 1,
                  "point": 1,
                  "description": "\u90a3\u5b9e\u5728\u662f\u592a\u597d\u4e86\uff01\u6253\u94c1\u8981\u8d81\u70ed\uff0c\u6211\u4eec\u4e00\u8d77\u60f3\u60f3\u89e3\u51b3\u65b9\u6848\u5427\u3002",
                  "short_description": null,
                  "addition": "",
                  "selected": false,
                  "ka": 5,
                  "nextQuestionId": 3342
              }],
              "directorComment": "\u5bf9\u65b9\u5df2\u7ecf\u8ba4\u540c\u5b63\u5b81\u7684\u7ecf\u9a8c\u5206\u4eab\u6709\u7528\uff0c\u4e0b\u4e00\u6b65\u600e\u4e48\u505a\uff1f",
              "expression": "\u6b63\u5e38",
              "description_length": 1
          }, {
              "id": 3339,
              "description": "\u522b\u8188\u5e94\u6211\u4e86\uff0c\u5f53\u7136\u4e0d\u4f1a\u2026\u2026",
              "options": [{
                  "id": 3,
                  "point": -1,
                  "description": "\u6211\u548c\u4f60\u7684\u60f3\u6cd5\u4e00\u6837\u3002\u4e0d\u5e0c\u671b\u5ba2\u6237\u5230\u4e86\u6211\u4eec\u5e97\u91cc\uff0c\u8981\u4ec0\u4e48\u6ca1\u4ec0\u4e48\u3002",
                  "short_description": null,
                  "addition": "",
                  "selected": false,
                  "ka": -1,
                  "nextQuestionId": 3347
              }, {
                  "id": 2,
                  "point": 9,
                  "description": "\u53e6\u5916\uff0c\u8bf7\u4f60\u770b\u770b\u8fd9\u51e0\u5f20\u5728\u5e97\u91cc\u62cd\u7684\u7167\u7247\u3002\u201c\u8981\u4ec0\u4e48\u6ca1\u4ec0\u4e48\u201d\u7684\u60c5\u51b5\u5df2\u7ecf\u6709\u4e00\u6bb5\u65f6\u95f4\u4e86\uff0c\u771f\u5e0c\u671b\u4e0d\u4f1a\u518d\u7ee7\u7eed\u4e0b\u53bb\u4e86\u3002",
                  "short_description": null,
                  "addition": "\u624b\u6301\u624b\u673a\u5c55\u793a\u7167\u7247",
                  "selected": false,
                  "ka": 2,
                  "nextQuestionId": 3346
              }, {
                  "id": 1,
                  "point": 1,
                  "description": "\u6240\u4ee5\uff0c\u6253\u94c1\u8981\u8d81\u70ed\uff0c\u6211\u4eec\u4e00\u8d77\u60f3\u60f3\u89e3\u51b3\u65b9\u6848\u5427\u3002",
                  "short_description": null,
                  "addition": "",
                  "selected": false,
                  "ka": 5,
                  "nextQuestionId": 3345
              }],
              "directorComment": "\u6210\u529f\u629b\u51fa\u523a\u6fc0\u6027\u95ee\u9898\uff0c\u5f71\u54cd\u529b\u5305\u88c5\u7684\u7ecf\u5178\u624b\u6cd5\u7528\u5f97\u5999\uff01",
              "expression": "\u4e3a\u96be",
              "description_length": 1
          }, {
              "id": 3340,
              "description": "\u5f53\u7136\u5f53\u7136\uff0c\u5f88\u6709\u542f\u53d1\u6027\u3002",
              "options": [{
                  "id": 3,
                  "point": 2,
                  "description": "\u90a3\u4f60\u60f3\u60f3\uff0c\u5176\u4ed6\u96f6\u552e\u4f01\u4e1a\u5df2\u7ecf\u8d70\u5728\u524d\u9762\u4e86\uff0c\u518d\u770b\u770b\u6211\u4eec\uff0c\u8fd9\u5bf9\u6bd4\u3001\u8fd9\u843d\u5dee\uff0c\u592a\u624e\u5fc3\u4e86\u3002",
                  "short_description": null,
                  "addition": "",
                  "selected": false,
                  "ka": 2,
                  "nextQuestionId": 3344
              }, {
                  "id": 2,
                  "point": 3,
                  "description": "\u90a3\u6211\u627e\u5bf9\u4eba\u4e86\u3002\u53e6\u5916\uff0c\u4f60\u770b\u8fd9\u51e0\u5f20\u5e97\u5185\u7167\u7247\uff0c\u201c\u8981\u4ec0\u4e48\u6ca1\u4ec0\u4e48\u201d\u7684\u60c5\u51b5\u5df2\u7ecf\u6709\u4e00\u6bb5\u65f6\u95f4\u4e86\uff0c\u5e0c\u671b\u4e0d\u4f1a\u518d\u7ee7\u7eed\u4e0b\u53bb\u4e86\u3002",
                  "short_description": null,
                  "addition": "\u624b\u6301\u624b\u673a\u5c55\u793a\u7167\u7247",
                  "selected": false,
                  "ka": 2,
                  "nextQuestionId": 3343
              }, {
                  "id": 1,
                  "point": 1,
                  "description": "\u90a3\u5b9e\u5728\u662f\u592a\u597d\u4e86\uff01\u6253\u94c1\u8981\u8d81\u70ed\uff0c\u6211\u4eec\u4e00\u8d77\u60f3\u60f3\u89e3\u51b3\u65b9\u6848\u5427\u3002",
                  "short_description": null,
                  "addition": "",
                  "selected": false,
                  "ka": 5,
                  "nextQuestionId": 3342
              }],
              "directorComment": "\u5bf9\u65b9\u5df2\u7ecf\u8ba4\u540c\u5b63\u5b81\u7684\u7ecf\u9a8c\u5206\u4eab\u6709\u7528\uff0c\u4e0b\u4e00\u6b65\u600e\u4e48\u505a\uff1f",
              "expression": "\u6b63\u5e38",
              "description_length": 1
          }, {
              "id": 3341,
              "description": "\u522b\u8188\u5e94\u6211\u4e86\uff0c\u5f53\u7136\u4e0d\u4f1a\u2026\u2026",
              "options": [{
                  "id": 3,
                  "point": -1,
                  "description": "\u6211\u548c\u4f60\u7684\u60f3\u6cd5\u4e00\u6837\u3002\u4e0d\u5e0c\u671b\u5ba2\u6237\u5230\u4e86\u6211\u4eec\u5e97\u91cc\uff0c\u8981\u4ec0\u4e48\u6ca1\u4ec0\u4e48\u3002",
                  "short_description": null,
                  "addition": "",
                  "selected": false,
                  "ka": -1,
                  "nextQuestionId": 3347
              }, {
                  "id": 2,
                  "point": 9,
                  "description": "\u53e6\u5916\uff0c\u8bf7\u4f60\u770b\u770b\u8fd9\u51e0\u5f20\u5728\u5e97\u91cc\u62cd\u7684\u7167\u7247\u3002\u201c\u8981\u4ec0\u4e48\u6ca1\u4ec0\u4e48\u201d\u7684\u60c5\u51b5\u5df2\u7ecf\u6709\u4e00\u6bb5\u65f6\u95f4\u4e86\uff0c\u771f\u5e0c\u671b\u4e0d\u4f1a\u518d\u7ee7\u7eed\u4e0b\u53bb\u4e86\u3002",
                  "short_description": null,
                  "addition": "\u624b\u6301\u624b\u673a\u5c55\u793a\u7167\u7247",
                  "selected": false,
                  "ka": 2,
                  "nextQuestionId": 3346
              }, {
                  "id": 1,
                  "point": 1,
                  "description": "\u6240\u4ee5\uff0c\u6253\u94c1\u8981\u8d81\u70ed\uff0c\u6211\u4eec\u4e00\u8d77\u60f3\u60f3\u89e3\u51b3\u65b9\u6848\u5427\u3002",
                  "short_description": null,
                  "addition": "",
                  "selected": false,
                  "ka": 5,
                  "nextQuestionId": 3345
              }],
              "directorComment": "\u6210\u529f\u629b\u51fa\u523a\u6fc0\u6027\u95ee\u9898\uff0c\u5f71\u54cd\u529b\u5305\u88c5\u7684\u7ecf\u5178\u624b\u6cd5\u7528\u5f97\u5999\uff01",
              "expression": "\u4e3a\u96be",
              "description_length": 1
          }, {
              "id": 3342,
              "description": "\u884c\uff0c\u5f00\u59cb\u5427\u3002",
              "options": [{
                  "id": 3,
                  "point": 3,
                  "description": "\u95e8\u5e97\u7269\u6d41\u7684\u95ee\u9898\u6709\u4e24\u4e2a\uff1a\u914d\u9001\u54cd\u5e94\u901f\u5ea6\u6162\u3001\u201c\u9001\u8d27\u4e0a\u95e8\u201d\u670d\u52a1\u51c6\u65f6\u7387\u4f4e\u3002\u6240\u4ee5\u6211\u7684\u5efa\u8bae\u662f\u3010\u7ed9\u51fa\u5efa\u8bae\u2026\u2026\u3011",
                  "short_description": null,
                  "addition": "",
                  "selected": false,
                  "ka": 5,
                  "nextQuestionId": 3355
              }, {
                  "id": 2,
                  "point": 9,
                  "description": "\u95e8\u5e97\u7269\u6d41\u7684\u4e3b\u8981\u95ee\u9898\u6709\u4e24\u4e2a\uff1a\u4f9b\u8d27\u901f\u5ea6\u6162\u3001\u201c\u9001\u8d27\u4e0a\u95e8\u201d\u670d\u52a1\u51c6\u65f6\u7387\u4f4e\u3002\u4f60\u89c9\u5f97\u54ea\u4e9b\u53ef\u4ee5\u5148\u505a\u8c03\u6574\u5462\uff1f",
                  "short_description": null,
                  "addition": "",
                  "selected": false,
                  "ka": 5,
                  "nextQuestionId": 3354
              }, {
                  "id": 1,
                  "point": 3,
                  "description": "\u6211\u4eec\u4e00\u4e2a\u4e2a\u6765\u770b\uff0c\u5148\u8bf4\u95e8\u5e97\u914d\u9001\u95ee\u9898\u5427\u3002",
                  "short_description": null,
                  "addition": "",
                  "selected": false,
                  "ka": 5,
                  "nextQuestionId": 3354
              }],
              "directorComment": "\u591a\u7b56\u7565\u7ec4\u5408\u62f3\u6709\u6548\u3002\u63a5\u4e0b\u6765\uff0c\u8be5\u5982\u4f55\u8ddf\u5bf9\u65b9\u5f00\u5c55\u65b9\u6848\u5462\uff1f",
              "expression": "\u6b63\u5e38",
              "description_length": 1
          }, {
              "id": 3343,
              "description": "\u771f\u6ca1\u60f3\u5230\u8fd9\u4e48\u4e25\u91cd\u2026\u2026",
              "options": [{
                  "id": 3,
                  "point": 1,
                  "description": "\u662f\u554a\uff0c\u6211\u5feb\u65e0\u8ba1\u53ef\u65bd\u4e86\u3002\u8001\u79e6\uff0c\u6211\u4eec\u8981\u662f\u518d\u60f3\u4e0d\u51fa\u4ec0\u4e48\u62db\uff0c\u6211\u53ea\u80fd\u628a\u95ee\u9898\u518d\u5f80\u4e0a\u53cd\u6620\u4e86\u3002",
                  "short_description": null,
                  "addition": "",
                  "selected": false,
                  "ka": 1,
                  "nextQuestionId": 3353
              }, {
                  "id": 1,
                  "point": 2,
                  "description": "\u6240\u4ee5\u6211\u624d\u5e0c\u671b\u6709\u6240\u884c\u52a8\u3002\u73b0\u5728\u5929\u5929\u8981\u9762\u5bf9\u8fd9\u6837\u7684\u573a\u666f\uff0c\u665a\u4e0a\u7b80\u76f4\u7761\u4e0d\u7740\u89c9\u3002",
                  "short_description": null,
                  "addition": "",
                  "selected": false,
                  "ka": 2,
                  "nextQuestionId": 3351
              }, {
                  "id": 2,
                  "point": 9,
                  "description": "\u6240\u4ee5\u6211\u4eec\u9700\u8981\u4f60\u4eec\u7684\u5e2e\u52a9\u3002\u53ef\u4ee5\u5148\u89e3\u51b3\u71c3\u7709\u4e4b\u6025\uff0c\u4e0d\u9700\u8981\u4e00\u6b65\u5230\u4f4d\u3002",
                  "short_description": null,
                  "addition": "",
                  "selected": false,
                  "ka": 1,
                  "nextQuestionId": 3352
              }],
              "directorComment": "\u7528\u7167\u7247\u5c55\u793a\u5e97\u5185\u60c5\u51b5\uff0c\u8fd9\u6ce2\u64cd\u4f5c\u884c\uff01",
              "expression": "\u4e3a\u96be",
              "description_length": 1
          }, {
              "id": 3344,
              "description": "\u884c\u4e86\uff0c\u522b\u8188\u5e94\u6211\u4e86\u3002",
              "options": [{
                  "id": 3,
                  "point": -1,
                  "description": "\u8001\u79e6\uff0c\u4e0d\u662f\u8981\u8188\u5e94\u4f60\uff0c\u6211\u5feb\u65e0\u8ba1\u53ef\u65bd\u4e86\u3002\u8981\u662f\u518d\u60f3\u4e0d\u51fa\u4ec0\u4e48\u62db\uff0c\u6211\u53ea\u80fd\u628a\u95ee\u9898\u518d\u5f80\u4e0a\u53cd\u6620\u4e86\u3002",
                  "short_description": null,
                  "addition": "",
                  "selected": false,
                  "ka": -1,
                  "nextQuestionId": 3350
              }, {
                  "id": 1,
                  "point": 2,
                  "description": "\u6211\u5e0c\u671b\u6709\u6240\u884c\u52a8\uff0c\u5426\u5219\u4e00\u60f3\u5230\u8fd9\u5dee\u8ddd\uff0c\u665a\u4e0a\u7b80\u76f4\u7761\u4e0d\u7740\u89c9\u3002",
                  "short_description": null,
                  "addition": "",
                  "selected": false,
                  "ka": 2,
                  "nextQuestionId": 3348
              }, {
                  "id": 2,
                  "point": 3,
                  "description": "\u6211\u77e5\u9053\u4e00\u4e0b\u5b50\u505a\u5927\u8c03\u6574\u5f88\u96be\u3002\u6211\u4eec\u5148\u89e3\u51b3\u71c3\u7709\u4e4b\u6025\u5c31\u597d\uff0c\u4e0d\u9700\u8981\u4e00\u6b65\u5230\u4f4d\u3002",
                  "short_description": null,
                  "addition": "",
                  "selected": false,
                  "ka": 1,
                  "nextQuestionId": 3349
              }],
              "directorComment": "\u8001\u94c1\uff0c\u4f60\u7684\u8fd9\u53e5\u8bdd\u4e5f\u6709\u70b9\u624e\u5fc3\u4e86\u2026\u2026\u63a5\u4e0b\u6765\uff0c\u8be5\u5982\u4f55\u7ee7\u7eed\uff1f",
              "expression": "\u4e3a\u96be",
              "description_length": 1
          }, {
              "id": 3345,
              "description": "\u90a3\u5c31\u60f3\u60f3\u600e\u4e48\u505a\u5427\u3002",
              "options": [{
                  "id": 3,
                  "point": 3,
                  "description": "\u95e8\u5e97\u7269\u6d41\u7684\u95ee\u9898\u6709\u4e24\u4e2a\uff1a\u914d\u9001\u54cd\u5e94\u901f\u5ea6\u6162\u3001\u201c\u9001\u8d27\u4e0a\u95e8\u201d\u670d\u52a1\u51c6\u65f6\u7387\u4f4e\u3002\u6240\u4ee5\u6211\u7684\u5efa\u8bae\u662f\u3010\u7ed9\u51fa\u5efa\u8bae\u2026\u2026\u3011",
                  "short_description": null,
                  "addition": "",
                  "selected": false,
                  "ka": 5,
                  "nextQuestionId": 3355
              }, {
                  "id": 1,
                  "point": 3,
                  "description": "\u6211\u4eec\u4e00\u4e2a\u4e2a\u6765\u770b\uff0c\u5148\u8bf4\u95e8\u5e97\u914d\u9001\u95ee\u9898\u5427\u3002",
                  "short_description": null,
                  "addition": "",
                  "selected": false,
                  "ka": 5,
                  "nextQuestionId": 3354
              }, {
                  "id": 2,
                  "point": 9,
                  "description": "\u95e8\u5e97\u7269\u6d41\u7684\u4e3b\u8981\u95ee\u9898\u6709\u4e24\u4e2a\uff1a\u4f9b\u8d27\u901f\u5ea6\u6162\u3001\u201c\u9001\u8d27\u4e0a\u95e8\u201d\u670d\u52a1\u51c6\u65f6\u7387\u4f4e\u3002\u4f60\u89c9\u5f97\u54ea\u4e9b\u53ef\u4ee5\u5148\u505a\u8c03\u6574\u5462\uff1f",
                  "short_description": null,
                  "addition": "",
                  "selected": false,
                  "ka": 5,
                  "nextQuestionId": 3354
              }],
              "directorComment": "\u591a\u7b56\u7565\u7ec4\u5408\u62f3\u6709\u6548\u3002\u63a5\u4e0b\u6765\uff0c\u8be5\u5982\u4f55\u8ddf\u5bf9\u65b9\u5f00\u5c55\u65b9\u6848\u5462\uff1f",
              "expression": "\u6b63\u5e38",
              "description_length": 1
          }, {
              "id": 3346,
              "description": "\u771f\u6ca1\u60f3\u5230\u8fd9\u4e48\u4e25\u91cd\u2026\u2026\u2028",
              "options": [{
                  "id": 3,
                  "point": 1,
                  "description": "\u662f\u554a\uff0c\u6211\u5feb\u65e0\u8ba1\u53ef\u65bd\u4e86\u3002\u8001\u79e6\uff0c\u6211\u4eec\u8981\u662f\u518d\u60f3\u4e0d\u51fa\u4ec0\u4e48\u62db\uff0c\u6211\u53ea\u80fd\u628a\u95ee\u9898\u518d\u5f80\u4e0a\u53cd\u6620\u4e86\u3002",
                  "short_description": null,
                  "addition": "",
                  "selected": false,
                  "ka": 1,
                  "nextQuestionId": 3353
              }, {
                  "id": 2,
                  "point": 9,
                  "description": "\u6240\u4ee5\u6211\u4eec\u9700\u8981\u4f60\u4eec\u7684\u5e2e\u52a9\u3002\u53ef\u4ee5\u5148\u89e3\u51b3\u71c3\u7709\u4e4b\u6025\uff0c\u4e0d\u9700\u8981\u4e00\u6b65\u5230\u4f4d\u3002",
                  "short_description": null,
                  "addition": "",
                  "selected": false,
                  "ka": 1,
                  "nextQuestionId": 3352
              }, {
                  "id": 1,
                  "point": 2,
                  "description": "\u6240\u4ee5\u6211\u624d\u5e0c\u671b\u6709\u6240\u884c\u52a8\u3002\u73b0\u5728\u5929\u5929\u8981\u9762\u5bf9\u8fd9\u6837\u7684\u573a\u666f\uff0c\u665a\u4e0a\u7b80\u76f4\u7761\u4e0d\u7740\u89c9\u3002",
                  "short_description": null,
                  "addition": "",
                  "selected": false,
                  "ka": 2,
                  "nextQuestionId": 3351
              }],
              "directorComment": "\u7528\u7167\u7247\u5c55\u793a\u5e97\u5185\u60c5\u51b5\uff0c\u8fd9\u6ce2\u64cd\u4f5c\u884c\uff01",
              "expression": "\u4e3a\u96be",
              "description_length": 1
          }, {
              "id": 3347,
              "description": "\u884c\u4e86\u3002\u90a3\u5c31\u60f3\u60f3\u600e\u4e48\u505a\u5427\u3002",
              "options": [{
                  "id": 3,
                  "point": 3,
                  "description": "\u95e8\u5e97\u7269\u6d41\u7684\u95ee\u9898\u6709\u4e24\u4e2a\uff1a\u914d\u9001\u54cd\u5e94\u901f\u5ea6\u6162\u3001\u201c\u9001\u8d27\u4e0a\u95e8\u201d\u670d\u52a1\u51c6\u65f6\u7387\u4f4e\u3002\u6240\u4ee5\u6211\u7684\u5efa\u8bae\u662f\u3010\u7ed9\u51fa\u5efa\u8bae\u2026\u2026\u3011",
                  "short_description": null,
                  "addition": "",
                  "selected": false,
                  "ka": 5,
                  "nextQuestionId": 3355
              }, {
                  "id": 1,
                  "point": 3,
                  "description": "\u6211\u4eec\u4e00\u4e2a\u4e2a\u6765\u770b\uff0c\u5148\u8bf4\u95e8\u5e97\u914d\u9001\u95ee\u9898\u5427\u3002",
                  "short_description": null,
                  "addition": "",
                  "selected": false,
                  "ka": 5,
                  "nextQuestionId": 3354
              }, {
                  "id": 2,
                  "point": 9,
                  "description": "\u95e8\u5e97\u7269\u6d41\u7684\u4e3b\u8981\u95ee\u9898\u6709\u4e24\u4e2a\uff1a\u4f9b\u8d27\u901f\u5ea6\u6162\u3001\u201c\u9001\u8d27\u4e0a\u95e8\u201d\u670d\u52a1\u51c6\u65f6\u7387\u4f4e\u3002\u4f60\u89c9\u5f97\u54ea\u4e9b\u53ef\u4ee5\u5148\u505a\u8c03\u6574\u5462\uff1f",
                  "short_description": null,
                  "addition": "",
                  "selected": false,
                  "ka": 5,
                  "nextQuestionId": 3354
              }],
              "directorComment": "\u591a\u7b56\u7565\u7ec4\u5408\u62f3\u6709\u6548\u3002\u63a5\u4e0b\u6765\uff0c\u8be5\u5982\u4f55\u8ddf\u5bf9\u65b9\u5f00\u5c55\u65b9\u6848\u5462\uff1f",
              "expression": "\u51b7\u6f20",
              "description_length": 1
          }, {
              "id": 3348,
              "description": "\u884c\u4e86\uff0c\u884c\u4e86\u3002\u90a3\u5c31\u60f3\u60f3\u600e\u4e48\u505a\u5427\u3002",
              "options": [{
                  "id": 3,
                  "point": 3,
                  "description": "\u95e8\u5e97\u7269\u6d41\u7684\u95ee\u9898\u6709\u4e24\u4e2a\uff1a\u914d\u9001\u54cd\u5e94\u901f\u5ea6\u6162\u3001\u201c\u9001\u8d27\u4e0a\u95e8\u201d\u670d\u52a1\u51c6\u65f6\u7387\u4f4e\u3002\u6240\u4ee5\u6211\u7684\u5efa\u8bae\u662f\u3010\u7ed9\u51fa\u5efa\u8bae\u2026\u2026\u3011",
                  "short_description": null,
                  "addition": "",
                  "selected": false,
                  "ka": 5,
                  "nextQuestionId": 3355
              }, {
                  "id": 1,
                  "point": 3,
                  "description": "\u6211\u4eec\u4e00\u4e2a\u4e2a\u6765\u770b\uff0c\u5148\u8bf4\u95e8\u5e97\u914d\u9001\u95ee\u9898\u5427\u3002",
                  "short_description": null,
                  "addition": "",
                  "selected": false,
                  "ka": 5,
                  "nextQuestionId": 3354
              }, {
                  "id": 2,
                  "point": 9,
                  "description": "\u95e8\u5e97\u7269\u6d41\u7684\u4e3b\u8981\u95ee\u9898\u6709\u4e24\u4e2a\uff1a\u4f9b\u8d27\u901f\u5ea6\u6162\u3001\u201c\u9001\u8d27\u4e0a\u95e8\u201d\u670d\u52a1\u51c6\u65f6\u7387\u4f4e\u3002\u4f60\u89c9\u5f97\u54ea\u4e9b\u53ef\u4ee5\u5148\u505a\u8c03\u6574\u5462\uff1f",
                  "short_description": null,
                  "addition": "",
                  "selected": false,
                  "ka": 5,
                  "nextQuestionId": 3354
              }],
              "directorComment": "\u201c\u5356\u60e8\u201d\u6709\u98ce\u9669\uff0c\u4f7f\u7528\u9700\u8c28\u614e\u3002\u63a5\u4e0b\u6765\uff0c\u8be5\u5982\u4f55\u8ddf\u5bf9\u65b9\u5f00\u5c55\u65b9\u6848\u5462\uff1f",
              "expression": "\u51b7\u6f20",
              "description_length": 1
          }, {
              "id": 3349,
              "description": "\u5514\uff1f\u8fd9\u4e2a\u53ef\u4ee5\u6709\u3002",
              "options": [{
                  "id": 3,
                  "point": 3,
                  "description": "\u95e8\u5e97\u7269\u6d41\u7684\u95ee\u9898\u6709\u4e24\u4e2a\uff1a\u914d\u9001\u54cd\u5e94\u901f\u5ea6\u6162\u3001\u201c\u9001\u8d27\u4e0a\u95e8\u201d\u670d\u52a1\u51c6\u65f6\u7387\u4f4e\u3002\u6240\u4ee5\u6211\u7684\u5efa\u8bae\u662f\u3010\u7ed9\u51fa\u5efa\u8bae\u2026\u2026\u3011",
                  "short_description": null,
                  "addition": "",
                  "selected": false,
                  "ka": 5,
                  "nextQuestionId": 3355
              }, {
                  "id": 1,
                  "point": 3,
                  "description": "\u6211\u4eec\u4e00\u4e2a\u4e2a\u6765\u770b\uff0c\u5148\u8bf4\u95e8\u5e97\u914d\u9001\u95ee\u9898\u5427\u3002",
                  "short_description": null,
                  "addition": "",
                  "selected": false,
                  "ka": 5,
                  "nextQuestionId": 3354
              }, {
                  "id": 2,
                  "point": 9,
                  "description": "\u95e8\u5e97\u7269\u6d41\u7684\u4e3b\u8981\u95ee\u9898\u6709\u4e24\u4e2a\uff1a\u4f9b\u8d27\u901f\u5ea6\u6162\u3001\u201c\u9001\u8d27\u4e0a\u95e8\u201d\u670d\u52a1\u51c6\u65f6\u7387\u4f4e\u3002\u4f60\u89c9\u5f97\u54ea\u4e9b\u53ef\u4ee5\u5148\u505a\u8c03\u6574\u5462\uff1f",
                  "short_description": null,
                  "addition": "",
                  "selected": false,
                  "ka": 5,
                  "nextQuestionId": 3354
              }],
              "directorComment": "\u201c\u7b56\u5212\u5c0f\u578b\u80dc\u5229\u201d\uff0c\u505a\u5f97\u4e0d\u9519\uff01\u63a5\u4e0b\u6765\uff0c\u8be5\u5982\u4f55\u8ddf\u5bf9\u65b9\u5f00\u5c55\u65b9\u6848\u5462\uff1f",
              "expression": "\u63a5\u53d7",
              "description_length": 1
          }, {
              "id": 3350,
              "description": "\u884c\u4e86\uff0c\u884c\u4e86\u3002\u90a3\u5c31\u60f3\u62db\u5457\u3002",
              "options": [{
                  "id": 3,
                  "point": 3,
                  "description": "\u95e8\u5e97\u7269\u6d41\u7684\u95ee\u9898\u6709\u4e24\u4e2a\uff1a\u914d\u9001\u54cd\u5e94\u901f\u5ea6\u6162\u3001\u201c\u9001\u8d27\u4e0a\u95e8\u201d\u670d\u52a1\u51c6\u65f6\u7387\u4f4e\u3002\u6240\u4ee5\u6211\u7684\u5efa\u8bae\u662f\u3010\u7ed9\u51fa\u5efa\u8bae\u2026\u2026\u3011",
                  "short_description": null,
                  "addition": "",
                  "selected": false,
                  "ka": 5,
                  "nextQuestionId": 3355
              }, {
                  "id": 1,
                  "point": 3,
                  "description": "\u6211\u4eec\u4e00\u4e2a\u4e2a\u6765\u770b\uff0c\u5148\u8bf4\u95e8\u5e97\u914d\u9001\u95ee\u9898\u5427\u3002",
                  "short_description": null,
                  "addition": "",
                  "selected": false,
                  "ka": 5,
                  "nextQuestionId": 3354
              }, {
                  "id": 2,
                  "point": 9,
                  "description": "\u95e8\u5e97\u7269\u6d41\u7684\u4e3b\u8981\u95ee\u9898\u6709\u4e24\u4e2a\uff1a\u4f9b\u8d27\u901f\u5ea6\u6162\u3001\u201c\u9001\u8d27\u4e0a\u95e8\u201d\u670d\u52a1\u51c6\u65f6\u7387\u4f4e\u3002\u4f60\u89c9\u5f97\u54ea\u4e9b\u53ef\u4ee5\u5148\u505a\u8c03\u6574\u5462\uff1f",
                  "short_description": null,
                  "addition": "",
                  "selected": false,
                  "ka": 5,
                  "nextQuestionId": 3354
              }],
              "directorComment": "\u8bf7\u4e0a\u7ea7\u9886\u5bfc\u4ecb\u5165\uff0c\u4e5f\u8bb8\u77ed\u65f6\u95f4\u5185\u80fd\u89e3\u51b3\u95ee\u9898\u3002\u4f46\u662f\uff0c\u60f3\u8981\u8ba9\u5bf9\u65b9\u4e3b\u52a8\u7ad9\u5728\u4f60\u8fd9\u4e00\u8fb9\uff0c\u201c\u5411\u4e0a\u53cd\u6620\u201d\u8fd9\u4e00\u62db\u8981\u614e\u7528\u3002",
              "expression": "\u51b7\u6f20",
              "description_length": 1
          }, {
              "id": 3351,
              "description": "\u884c\u5427\uff0c\u90a3\u770b\u770b\u600e\u4e48\u505a\u3002",
              "options": [{
                  "id": 3,
                  "point": 3,
                  "description": "\u95e8\u5e97\u7269\u6d41\u7684\u95ee\u9898\u6709\u4e24\u4e2a\uff1a\u914d\u9001\u54cd\u5e94\u901f\u5ea6\u6162\u3001\u201c\u9001\u8d27\u4e0a\u95e8\u201d\u670d\u52a1\u51c6\u65f6\u7387\u4f4e\u3002\u6240\u4ee5\u6211\u7684\u5efa\u8bae\u662f\u3010\u7ed9\u51fa\u5efa\u8bae\u2026\u2026\u3011",
                  "short_description": null,
                  "addition": "",
                  "selected": false,
                  "ka": 5,
                  "nextQuestionId": 3355
              }, {
                  "id": 2,
                  "point": 9,
                  "description": "\u95e8\u5e97\u7269\u6d41\u7684\u4e3b\u8981\u95ee\u9898\u6709\u4e24\u4e2a\uff1a\u4f9b\u8d27\u901f\u5ea6\u6162\u3001\u201c\u9001\u8d27\u4e0a\u95e8\u201d\u670d\u52a1\u51c6\u65f6\u7387\u4f4e\u3002\u4f60\u89c9\u5f97\u54ea\u4e9b\u53ef\u4ee5\u5148\u505a\u8c03\u6574\u5462\uff1f",
                  "short_description": null,
                  "addition": "",
                  "selected": false,
                  "ka": 5,
                  "nextQuestionId": 3354
              }, {
                  "id": 1,
                  "point": 3,
                  "description": "\u6211\u4eec\u4e00\u4e2a\u4e2a\u6765\u770b\uff0c\u5148\u8bf4\u95e8\u5e97\u914d\u9001\u95ee\u9898\u5427\u3002",
                  "short_description": null,
                  "addition": "",
                  "selected": false,
                  "ka": 5,
                  "nextQuestionId": 3354
              }],
              "directorComment": "\u201c\u5356\u60e8\u201d\u6709\u98ce\u9669\uff0c\u4f7f\u7528\u9700\u8c28\u614e\u3002\u63a5\u4e0b\u6765\uff0c\u8be5\u5982\u4f55\u8ddf\u5bf9\u65b9\u5f00\u5c55\u65b9\u6848\u5462\uff1f",
              "expression": "\u51b7\u6f20",
              "description_length": 1
          }, {
              "id": 3352,
              "description": "\u5514\uff1f\u8fd9\u4e2a\u53ef\u4ee5\u6709\u3002",
              "options": [{
                  "id": 3,
                  "point": 3,
                  "description": "\u95e8\u5e97\u7269\u6d41\u7684\u95ee\u9898\u6709\u4e24\u4e2a\uff1a\u914d\u9001\u54cd\u5e94\u901f\u5ea6\u6162\u3001\u201c\u9001\u8d27\u4e0a\u95e8\u201d\u670d\u52a1\u51c6\u65f6\u7387\u4f4e\u3002\u6240\u4ee5\u6211\u7684\u5efa\u8bae\u662f\u3010\u7ed9\u51fa\u5efa\u8bae\u2026\u2026\u3011",
                  "short_description": null,
                  "addition": "",
                  "selected": false,
                  "ka": 5,
                  "nextQuestionId": 3355
              }, {
                  "id": 1,
                  "point": 3,
                  "description": "\u6211\u4eec\u4e00\u4e2a\u4e2a\u6765\u770b\uff0c\u5148\u8bf4\u95e8\u5e97\u914d\u9001\u95ee\u9898\u5427\u3002",
                  "short_description": null,
                  "addition": "",
                  "selected": false,
                  "ka": 5,
                  "nextQuestionId": 3354
              }, {
                  "id": 2,
                  "point": 9,
                  "description": "\u95e8\u5e97\u7269\u6d41\u7684\u4e3b\u8981\u95ee\u9898\u6709\u4e24\u4e2a\uff1a\u4f9b\u8d27\u901f\u5ea6\u6162\u3001\u201c\u9001\u8d27\u4e0a\u95e8\u201d\u670d\u52a1\u51c6\u65f6\u7387\u4f4e\u3002\u4f60\u89c9\u5f97\u54ea\u4e9b\u53ef\u4ee5\u5148\u505a\u8c03\u6574\u5462\uff1f",
                  "short_description": null,
                  "addition": "",
                  "selected": false,
                  "ka": 5,
                  "nextQuestionId": 3354
              }],
              "directorComment": "\u201c\u7b56\u7565\u201d\u52a0\u201c\u5305\u88c5\u201d\u53cc\u7ba1\u9f50\u4e0b\u5f71\u54cd\u5bf9\u65b9\uff0c\u503c\u5f97\u8868\u626c\uff01\u63a5\u4e0b\u6765\uff0c\u8be5\u5982\u4f55\u8ddf\u5bf9\u65b9\u5f00\u5c55\u65b9\u6848\u5462\uff1f",
              "expression": "\u6b63\u5e38",
              "description_length": 1
          }, {
              "id": 3353,
              "description": "\u884c\u4e86\u884c\u4e86\uff0c\u90a3\u6211\u4eec\u5c31\u770b\u770b\u600e\u4e48\u505a\u5427\u3002",
              "options": [{
                  "id": 3,
                  "point": 3,
                  "description": "\u95e8\u5e97\u7269\u6d41\u7684\u95ee\u9898\u6709\u4e24\u4e2a\uff1a\u914d\u9001\u54cd\u5e94\u901f\u5ea6\u6162\u3001\u201c\u9001\u8d27\u4e0a\u95e8\u201d\u670d\u52a1\u51c6\u65f6\u7387\u4f4e\u3002\u6240\u4ee5\u6211\u7684\u5efa\u8bae\u662f\u3010\u7ed9\u51fa\u5efa\u8bae\u2026\u2026\u3011",
                  "short_description": null,
                  "addition": "",
                  "selected": false,
                  "ka": 5,
                  "nextQuestionId": 3355
              }, {
                  "id": 2,
                  "point": 9,
                  "description": "\u95e8\u5e97\u7269\u6d41\u7684\u4e3b\u8981\u95ee\u9898\u6709\u4e24\u4e2a\uff1a\u4f9b\u8d27\u901f\u5ea6\u6162\u3001\u201c\u9001\u8d27\u4e0a\u95e8\u201d\u670d\u52a1\u51c6\u65f6\u7387\u4f4e\u3002\u4f60\u89c9\u5f97\u54ea\u4e9b\u53ef\u4ee5\u5148\u505a\u8c03\u6574\u5462\uff1f",
                  "short_description": null,
                  "addition": "",
                  "selected": false,
                  "ka": 5,
                  "nextQuestionId": 3354
              }, {
                  "id": 1,
                  "point": 3,
                  "description": "\u6211\u4eec\u4e00\u4e2a\u4e2a\u6765\u770b\uff0c\u5148\u8bf4\u95e8\u5e97\u914d\u9001\u95ee\u9898\u5427\u3002",
                  "short_description": null,
                  "addition": "",
                  "selected": false,
                  "ka": 5,
                  "nextQuestionId": 3354
              }],
              "directorComment": "\u8bf7\u4e0a\u7ea7\u9886\u5bfc\u4ecb\u5165\uff0c\u4e5f\u8bb8\u77ed\u65f6\u95f4\u5185\u80fd\u89e3\u51b3\u95ee\u9898\u3002\u4f46\u662f\uff0c\u60f3\u8981\u8ba9\u5bf9\u65b9\u4e3b\u52a8\u7ad9\u5728\u4f60\u8fd9\u4e00\u8fb9\uff0c\u201c\u5411\u4e0a\u53cd\u6620\u201d\u8fd9\u4e00\u62db\u8981\u614e\u7528\u3002",
              "expression": "\u51b7\u6f20",
              "description_length": 1
          }, {
              "id": 3354,
              "description": "\u7cfb\u7edf\u662f\u4e0d\u80fd\u8f7b\u6613\u52a8\u7684\u3002\u4e0d\u8fc7\uff0c\u6211\u53ef\u4ee5\u817e\u51fa\u4e00\u4e2a\u4eba\u624b\u6765\uff0c\u8fd9\u6bb5\u65f6\u95f4\u5c31\u53ea\u5904\u7406\u4f60\u4eec\u914d\u9001\u7684\u95ee\u9898\uff0c\u786e\u4fdd\u914d\u9001\u53ca\u65f6\u3002",
              "options": [{
                  "id": 3,
                  "point": 9,
                  "description": "\u90a3\u592a\u597d\u4e86\uff0c\u8fd9\u53ef\u4ee5\u5e2e\u52a9\u6211\u4eec\u6e21\u8fc7\u773c\u524d\u7684\u96be\u5173\u4e86\u3002\u6211\u4e5f\u4f1a\u6d3e\u4e00\u4e2a\u540c\u4e8b\u4e13\u95e8\u8d1f\u8d23\u548c\u4f60\u4eec\u5bf9\u63a5\u3002",
                  "short_description": null,
                  "addition": "",
                  "selected": false,
                  "ka": 5,
                  "nextQuestionId": 3358
              }, {
                  "id": 2,
                  "point": -1,
                  "description": "\u975e\u5e38\u611f\u8c22\uff01\u7ec8\u4e8e\u53ef\u4ee5\u653e\u4e0b\u5fc3\u4e86\u3002\u8981\u4f60\u4eec\u5728\u8fd9\u4e48\u5fd9\u7684\u5de5\u4f5c\u5185\uff0c\u8fd8\u62bd\u51fa\u65f6\u95f4\u89e3\u51b3\u6211\u4eec\u7684\u95ee\u9898\uff0c\u771f\u662f\u8fc7\u610f\u4e0d\u53bb\u3002",
                  "short_description": null,
                  "addition": "",
                  "selected": false,
                  "ka": -1,
                  "nextQuestionId": 3357
              }, {
                  "id": 1,
                  "point": -1,
                  "description": "\u597d\uff01\u6ca1\u95ee\u9898\uff0c\u5982\u679c\u9700\u8981\u6211\u914d\u5408\u7684\uff0c\u4f60\u4eec\u5c3d\u7ba1\u5f00\u53e3\u3002",
                  "short_description": null,
                  "addition": "",
                  "selected": false,
                  "ka": -1,
                  "nextQuestionId": 3356
              }],
              "directorComment": "\u5bf9\u65b9\u63d0\u51fa\u65b9\u6848\u4e86\uff0c\u4f60\u89c9\u5f97\u600e\u4e48\u6837\uff1f",
              "expression": "\u6b63\u5e38",
              "description_length": 1
          }, {
              "id": 3355,
              "description": "\u4ec0\u4e48\u3001\u4ec0\u4e48\uff1f\u8bf4\u8fd9\u4e48\u591a\u54ea\u91cc\u8bb0\u5f97\u4f4f\uff1f",
              "options": [{
                  "id": 2,
                  "point": 3,
                  "description": "\u4f60\u89c9\u5f97\u54ea\u4e9b\u53ef\u4ee5\u5148\u505a\u8c03\u6574\u5462\uff1f",
                  "short_description": null,
                  "addition": "",
                  "selected": false,
                  "ka": 5,
                  "nextQuestionId": 3360
              }, {
                  "id": 1,
                  "point": 1,
                  "description": "\u90a3\u6211\u4eec\u4e00\u4e2a\u4e2a\u6765\u5427\uff0c\u5148\u8bf4\u5546\u54c1\u914d\u9001\u7684\u95ee\u9898\uff0c\u6211\u7684\u5efa\u8bae\u662f\uff1a\u3010\u7ed9\u51fa\u5efa\u8bae\u2026\u2026\u3011",
                  "short_description": null,
                  "addition": "",
                  "selected": false,
                  "ka": 5,
                  "nextQuestionId": 3359
              }],
              "directorComment": "\u5206\u4eab\u5efa\u8bae\u662f\u597d\u4e8b\uff0c\u4f46\u522b\u628a\u53d1\u5c55\u65b9\u6848\u53d8\u6210\u4f60\u4e00\u4e2a\u4eba\u7684\u201c\u72ec\u89d2\u620f\u201d\u3002",
              "expression": "\u6297\u62d2",
              "description_length": 1
          }, {
              "id": 3356,
              "description": "\u5230\u65f6\u5019\u4e00\u5b9a\u9700\u8981\u4f60\u4eec\u914d\u5408\u7684\u3002\u53e6\u5916\uff0c\u8fd9\u53ea\u80fd\u89e3\u51b3\u71c3\u7709\u4e4b\u6025\uff0c\u957f\u671f\u53ef\u4e0d\u80fd\u6307\u671b\u4e00\u76f4\u8fd9\u4e48\u505a\u3002",
              "options": [{
                  "id": 3,
                  "point": 1,
                  "description": "\u90a3\u4f60\u89c9\u5f97\uff0c\u957f\u671f\u800c\u8a00\uff0c\u5e94\u8be5\u600e\u4e48\u89e3\u51b3\u6211\u63d0\u5230\u7684\u4e24\u4e2a\u95ee\u9898\u5462\uff1f",
                  "short_description": null,
                  "addition": "",
                  "selected": false,
                  "ka": 5,
                  "nextQuestionId": 3363
              }, {
                  "id": 2,
                  "point": 9,
                  "description": "\u5f53\u7136\uff0c\u957f\u671f\u7684\u95ee\u9898\u6211\u4eec\u8fc7\u4f1a\u513f\u518d\u8c08\u3002\u7b2c\u4e8c\u4e2a\u662f\u201c\u9650\u65f6\u9001\u5230\u5bb6\u201d\u7684\u95ee\u9898\u2026\u2026",
                  "short_description": null,
                  "addition": "",
                  "selected": false,
                  "ka": 5,
                  "nextQuestionId": 3362
              }, {
                  "id": 1,
                  "point": -1,
                  "description": "\u6ca1\u95ee\u9898\u6ca1\u95ee\u9898\uff0c\u80fd\u628a\u6700\u7d27\u6025\u7684\u95ee\u9898\u89e3\u51b3\uff0c\u5df2\u7ecf\u662f\u5e2e\u4e86\u6211\u4eec\u5927\u5fd9\u4e86\u3002",
                  "short_description": null,
                  "addition": "",
                  "selected": false,
                  "ka": -1,
                  "nextQuestionId": 3361
              }],
              "directorComment": "\u6210\u529f\u8fc8\u51fa\u4e86\u89e3\u51b3\u95ee\u9898\u7684\u7b2c\u4e00\u6b65\uff0c\u8bf7\u7ee7\u7eed\u3002",
              "expression": "\u6b63\u5e38",
              "description_length": 1
          }, {
              "id": 3357,
              "description": "\u8fd9\u662f\u5de5\u4f5c\u5206\u5185\u7684\u4e8b\uff0c\u5e94\u8be5\u7684\u3002\u4e0d\u8fc7\u8fd9\u53ea\u80fd\u89e3\u51b3\u71c3\u7709\u4e4b\u6025\uff0c\u957f\u671f\u53ef\u4e0d\u80fd\u6307\u671b\u4e00\u76f4\u8fd9\u4e48\u505a\u3002",
              "options": [{
                  "id": 3,
                  "point": 1,
                  "description": "\u90a3\u4f60\u89c9\u5f97\uff0c\u957f\u671f\u800c\u8a00\uff0c\u5e94\u8be5\u600e\u4e48\u89e3\u51b3\u6211\u63d0\u5230\u7684\u4e24\u4e2a\u95ee\u9898\u5462\uff1f",
                  "short_description": null,
                  "addition": "",
                  "selected": false,
                  "ka": 5,
                  "nextQuestionId": 3363
              }, {
                  "id": 2,
                  "point": 9,
                  "description": "\u5f53\u7136\uff0c\u957f\u671f\u7684\u95ee\u9898\u6211\u4eec\u8fc7\u4f1a\u513f\u518d\u8c08\u3002\u7b2c\u4e8c\u4e2a\u662f\u201c\u9650\u65f6\u9001\u5230\u5bb6\u201d\u7684\u95ee\u9898\u2026\u2026",
                  "short_description": null,
                  "addition": "",
                  "selected": false,
                  "ka": 5,
                  "nextQuestionId": 3362
              }, {
                  "id": 1,
                  "point": -1,
                  "description": "\u6ca1\u95ee\u9898\u6ca1\u95ee\u9898\uff0c\u80fd\u628a\u6700\u7d27\u6025\u7684\u95ee\u9898\u89e3\u51b3\uff0c\u5df2\u7ecf\u662f\u5e2e\u4e86\u6211\u4eec\u5927\u5fd9\u4e86\u3002",
                  "short_description": null,
                  "addition": "",
                  "selected": false,
                  "ka": -1,
                  "nextQuestionId": 3361
              }],
              "directorComment": "\u6210\u529f\u8fc8\u51fa\u4e86\u89e3\u51b3\u95ee\u9898\u7684\u7b2c\u4e00\u6b65\uff0c\u8bf7\u7ee7\u7eed\u3002",
              "expression": "\u6b63\u5e38",
              "description_length": 1
          }, {
              "id": 3358,
              "description": "\u4f60\u4eec\u80fd\u914d\u5408\uff0c\u90a3\u5c31\u66f4\u597d\u4e86\u3002\u5f53\u7136\u8fd9\u53ea\u80fd\u5e94\u71c3\u7709\u4e4b\u6025\uff0c\u957f\u671f\u53ef\u4e0d\u80fd\u6307\u671b\u6211\u4eec\u4e00\u76f4\u8fd9\u4e48\u505a\u3002",
              "options": [{
                  "id": 2,
                  "point": 9,
                  "description": "\u5f53\u7136\uff0c\u957f\u671f\u7684\u95ee\u9898\u6211\u4eec\u8fc7\u4f1a\u513f\u518d\u8c08\u3002\u7b2c\u4e8c\u4e2a\u662f\u201c\u9650\u65f6\u9001\u5230\u5bb6\u201d\u7684\u95ee\u9898\u2026\u2026",
                  "short_description": null,
                  "addition": "",
                  "selected": false,
                  "ka": 5,
                  "nextQuestionId": 3362
              }, {
                  "id": 1,
                  "point": -1,
                  "description": "\u6ca1\u95ee\u9898\u6ca1\u95ee\u9898\uff0c\u80fd\u628a\u6700\u7d27\u6025\u7684\u95ee\u9898\u89e3\u51b3\uff0c\u5df2\u7ecf\u662f\u5e2e\u4e86\u6211\u4eec\u5927\u5fd9\u4e86\u3002",
                  "short_description": null,
                  "addition": "",
                  "selected": false,
                  "ka": -1,
                  "nextQuestionId": 3361
              }, {
                  "id": 3,
                  "point": 1,
                  "description": "\u90a3\u4f60\u89c9\u5f97\uff0c\u957f\u671f\u800c\u8a00\uff0c\u5e94\u8be5\u600e\u4e48\u89e3\u51b3\u6211\u63d0\u5230\u7684\u4e24\u4e2a\u95ee\u9898\u5462\uff1f",
                  "short_description": null,
                  "addition": "",
                  "selected": false,
                  "ka": 5,
                  "nextQuestionId": 3363
              }],
              "directorComment": "\u6210\u529f\u8fc8\u51fa\u4e86\u89e3\u51b3\u95ee\u9898\u7684\u7b2c\u4e00\u6b65\uff0c\u8bf7\u7ee7\u7eed\u3002",
              "expression": "\u6b63\u5e38",
              "description_length": 1
          }, {
              "id": 3359,
              "description": "\u4f60\u8fd9\u4e2a\u5efa\u8bae\u53ef\u884c\u6027\u4e0d\u9ad8\uff0c\u6211\u4eec\u4f30\u8ba1\u505a\u4e0d\u4e86\u3002",
              "options": [{
                  "id": 3,
                  "point": -1,
                  "description": "\u8fd9\u53ea\u662f\u6211\u7684\u60f3\u6cd5\uff0c\u4f9b\u4f60\u53c2\u8003\u3002\u90a3\u4f60\u7684\u610f\u89c1\u662f\uff1f",
                  "short_description": null,
                  "addition": "",
                  "selected": false,
                  "ka": -1,
                  "nextQuestionId": 3366
              }, {
                  "id": 2,
                  "point": 1,
                  "description": "\u4e0d\u597d\u610f\u601d\uff0c\u6211\u6bd5\u7adf\u4e0d\u592a\u4e86\u89e3\u4f60\u4eec\u7684\u5de5\u4f5c\u7279\u70b9\u3002\u6211\u53ea\u662f\u5e0c\u671b\u80fd\u5bf9\u89e3\u51b3\u95ee\u9898\u6709\u5e2e\u52a9\u3002",
                  "short_description": null,
                  "addition": "",
                  "selected": false,
                  "ka": 4,
                  "nextQuestionId": 3365
              }, {
                  "id": 1,
                  "point": -1,
                  "description": "\u600e\u4e48\u5c31\u505a\u4e0d\u4e86\uff1f\u90a3\u4f60\u5012\u662f\u8bf4\u8bf4\u770b\uff0c\u5e94\u8be5\u600e\u4e48\u505a\u3002",
                  "short_description": null,
                  "addition": "",
                  "selected": false,
                  "ka": -1,
                  "nextQuestionId": 3364
              }],
              "directorComment": "\u554a\u54e6\uff0c\u5efa\u8bae\u4e0d\u88ab\u91c7\u7eb3\uff0c\u600e\u4e48\u529e\uff1f",
              "expression": "\u6297\u62d2",
              "description_length": 1
          }, {
              "id": 3360,
              "description": "\u6211\u4eec\u56e2\u961f\u53ef\u4ee5\u817e\u51fa\u4e00\u4e2a\u4eba\u624b\u6765\uff0c\u8fd9\u6bb5\u65f6\u95f4\u5c31\u53ea\u5904\u7406\u4f60\u4eec\u914d\u9001\u7684\u95ee\u9898\uff0c\u786e\u4fdd\u914d\u9001\u53ca\u65f6\u3002",
              "options": [{
                  "id": 2,
                  "point": -1,
                  "description": "\u975e\u5e38\u611f\u8c22\uff01\u7ec8\u4e8e\u53ef\u4ee5\u653e\u4e0b\u5fc3\u4e86\u3002\u8981\u4f60\u4eec\u5728\u8fd9\u4e48\u5fd9\u7684\u5de5\u4f5c\u5185\uff0c\u8fd8\u62bd\u51fa\u65f6\u95f4\u89e3\u51b3\u6211\u4eec\u7684\u95ee\u9898\uff0c\u771f\u662f\u8fc7\u610f\u4e0d\u53bb\u3002",
                  "short_description": null,
                  "addition": "",
                  "selected": false,
                  "ka": -1,
                  "nextQuestionId": 3357
              }, {
                  "id": 1,
                  "point": -1,
                  "description": "\u597d\uff01\u6ca1\u95ee\u9898\uff0c\u5982\u679c\u9700\u8981\u6211\u914d\u5408\u7684\uff0c\u4f60\u4eec\u5c3d\u7ba1\u5f00\u53e3\u3002",
                  "short_description": null,
                  "addition": "",
                  "selected": false,
                  "ka": -1,
                  "nextQuestionId": 3356
              }, {
                  "id": 3,
                  "point": 9,
                  "description": "\u90a3\u592a\u597d\u4e86\uff0c\u8fd9\u53ef\u4ee5\u5e2e\u52a9\u6211\u4eec\u6e21\u8fc7\u773c\u524d\u7684\u96be\u5173\u4e86\u3002\u6211\u4e5f\u4f1a\u6d3e\u4e00\u4e2a\u540c\u4e8b\u4e13\u95e8\u8d1f\u8d23\u548c\u4f60\u4eec\u5bf9\u63a5\u3002",
                  "short_description": null,
                  "addition": "",
                  "selected": false,
                  "ka": 5,
                  "nextQuestionId": 3358
              }],
              "directorComment": "\u5bf9\u65b9\u63d0\u51fa\u65b9\u6848\u4e86\uff0c\u4f60\u89c9\u5f97\u600e\u4e48\u6837\uff1f",
              "expression": "\u63a5\u53d7",
              "description_length": 1
          }, {
              "id": 3361,
              "description": "\u54e6\uff1f\u90a3\u5c31\u597d\u3002\u6240\u4ee5\u8c08\u5f97\u5dee\u4e0d\u591a\u4e86\u5427\uff1f",
              "options": [{
                  "id": 2,
                  "point": 2,
                  "description": "\u8fd8\u6709\u4e00\u4e2a\u201c\u9650\u65f6\u9001\u5230\u5bb6\u201d\u7684\u95ee\u9898\u9700\u8981\u89e3\u51b3\u3002",
                  "short_description": null,
                  "addition": "",
                  "selected": false,
                  "ka": 5,
                  "nextQuestionId": 3368
              }, {
                  "id": 1,
                  "point": -1,
                  "description": "\u662f\u7684\uff0c\u4eca\u5929\u5dee\u4e0d\u591a\u4e86\u3002\u8001\u79e6\uff0c\u8c22\u8c22\u4e86\uff01\u6539\u5929\u6211\u4eec\u4e00\u8d77\u5403\u4e2a\u996d\u5427\u3002",
                  "short_description": null,
                  "addition": "",
                  "selected": false,
                  "ka": -1,
                  "nextQuestionId": 3367
              }],
              "directorComment": "\u5bf9\u65b9\u91ca\u653e\u51fa\u7ed3\u675f\u4f1a\u8bae\u7684\u4fe1\u53f7\uff0c\u53ef\u4ee5\u6109\u5feb\u5730\u7ed3\u675f\u4e86\u5417\uff1f",
              "expression": "\u63a5\u53d7",
              "description_length": 1
          }, {
              "id": 3362,
              "description": "\u5f53\u65f6\u6ca1\u60f3\u5230\u8fd9\u4e2a\u670d\u52a1\u7684\u9700\u6c42\u91cf\u8fd9\u4e48\u5927\u3002\u73b0\u5728\u7684\u8d44\u6e90\u548c\u6210\u672c\uff0c\u6839\u672c\u505a\u4e0d\u5230\u6211\u4eec\u627f\u8bfa\u7684\u65f6\u95f4\u3002\u6240\u4ee5\u4e0d\u5982\u628a\u8fd9\u4e2a\u670d\u52a1\u53d6\u6d88\u5427\u3002",
              "options": [{
                  "id": 3,
                  "point": 1,
                  "description": "\u5f53\u521d\u786e\u5b9e\u662f\u8003\u91cf\u4e0d\u5468\uff0c\u4e0d\u8fc7\u4e5f\u4e0d\u80fd\u8bf4\u64a4\u5c31\u64a4\u3002\u8981\u4e0d\u8fd9\u6837\uff0c\u6211\u56de\u53bb\u95ee\u95ee\u770b\u6211\u8001\u677f\uff0c\u542c\u542c\u4ed6\u7684\u610f\u89c1\u3002",
                  "short_description": null,
                  "addition": "",
                  "selected": false,
                  "ka": 5,
                  "nextQuestionId": 3371
              }, {
                  "id": 2,
                  "point": 9,
                  "description": "\u8fd9\u4e00\u70b9\uff0c\u6211\u5012\u662f\u6709\u4e0d\u540c\u7684\u60f3\u6cd5\u3002\u9700\u6c42\u91cf\u5927\u6070\u6070\u8bf4\u660e\u65b9\u5411\u662f\u6b63\u786e\u7684\uff0c\u6211\u5efa\u8bae\u4fdd\u7559\u3002",
                  "short_description": null,
                  "addition": "",
                  "selected": false,
                  "ka": 4,
                  "nextQuestionId": 3370
              }, {
                  "id": 1,
                  "point": -1,
                  "description": "\u8fd9\u4e0d\u592a\u597d\u5427\u3002\u5f00\u4e1a\u6ca1\u591a\u4e45\u5c31\u8981\u53d6\u6d88\u670d\u52a1\uff0c\u6709\u635f\u4fe1\u8a89\u554a\u3002",
                  "short_description": null,
                  "addition": "",
                  "selected": false,
                  "ka": -1,
                  "nextQuestionId": 3369
              }],
              "directorComment": "\u627f\u8bfa\u4e0d\u5408\u7406\uff0c\u670d\u52a1\u8981\u53d6\u6d88\uff1f\u5e97\u957f\uff0c\u4f60\u600e\u4e48\u770b\uff1f",
              "expression": "\u6297\u62d2",
              "description_length": 1
          }, {
              "id": 3363,
              "description": "\u54ce\u54df\uff0c\u8fd9\u4e2a\u95ee\u9898\u592a\u5927\u4e86\uff0c\u4e0d\u662f\u6211\u80fd\u5b9a\u5f97\u4e86\u7684\u3002\u7269\u6d41\u90e8\u95e8\u8981\u652f\u6301\u6240\u6709\u7684\u4e1a\u52a1\u7ebf\uff0c\u7275\u4e00\u53d1\u800c\u52a8\u5168\u8eab\u554a\u3002",
              "options": [{
                  "id": 2,
                  "point": 9,
                  "description": "\u5f53\u7136\u5f53\u7136\uff0c\u6211\u660e\u767d\u3002\u8fd9\u6837\uff0c\u6211\u6253\u7b97\u5411\u7ba1\u7406\u5c42\u505a\u4e2a\u6c47\u62a5\uff0c\u8c08\u8c08\u5b9e\u4f53\u5e97\u8981\u89e3\u51b3\u7684\u95ee\u9898\u3002\u7269\u6d41\u65b9\u9762\u80fd\u8bf7\u4f60\u5e2e\u6211\u505a\u4e2a\u89c4\u5212\u5417\uff1f",
                  "short_description": null,
                  "addition": "",
                  "selected": false,
                  "ka": 1,
                  "nextQuestionId": 3381
              }, {
                  "id": 1,
                  "point": -1,
                  "description": "\u8fd9\u6837\u554a\u2026\u2026\u90a3\u6211\u5230\u65f6\u5019\u8054\u7edc\u5404\u90e8\u95e8\uff0c\u5927\u5bb6\u4e00\u8d77\u5f00\u4e2a\u4f1a\uff0c\u770b\u770b\u5982\u4f55\u89e3\u51b3\u3002\u5230\u65f6\u5019\uff0c\u8bf7\u4f60\u4e00\u8d77\u53c2\u52a0\u3002",
                  "short_description": null,
                  "addition": "",
                  "selected": false,
                  "ka": -1,
                  "nextQuestionId": 3380
              }],
              "directorComment": "\u4efb\u52a1\u6709\u96be\u5ea6\uff0c\u5982\u4f55\u7834\u89e3\uff1f",
              "expression": "\u4e3a\u96be",
              "description_length": 1
          }, {
              "id": 3364,
              "description": "\u4f60\u5148\u522b\u6fc0\u52a8\u3002\u8fd9\u6837\uff0c\u6211\u540e\u9762\u8fd8\u6709\u4e8b\u3002\u4e4b\u540e\u6211\u4eec\u518d\u7ea6\u65f6\u95f4\u5427\uff0c\u65b9\u6848\u6211\u4f1a\u60f3\u60f3\u3002\u597d\u5427\uff1f\u6162\u8d70\uff0c\u4e0d\u9001\u3002",
              "options": [],
              "directorComment": "\u3010\u8c08\u8bdd\u7ed3\u675f\u3011\u554a\u54e6\uff0c\u95ee\u9898\u8fd8\u6ca1\u89e3\u51b3\uff0c\u8001\u79e6\u5c31\u4e0b\u4e86\u9010\u5ba2\u4ee4\u3002\u770b\u6765\u56de\u53bb\u4e4b\u540e\uff0c\u4f60\u8981\u7ee7\u7eed\u627f\u53d7\u987e\u5ba2\u4e0a\u5e1d\u7684\u6012\u706b\u4e86\u3002",
              "expression": "\u6297\u62d2",
              "description_length": 1
          }, {
              "id": 3365,
              "description": "\u6ca1\u5173\u7cfb\u3002\u6211\u7684\u60f3\u6cd5\u662f\uff1a\u7cfb\u7edf\u662f\u4e0d\u80fd\u8f7b\u6613\u52a8\u7684\u3002\u4e0d\u8fc7\uff0c\u6211\u53ef\u4ee5\u817e\u51fa\u4e00\u4e2a\u4eba\u624b\u6765\uff0c\u8fd9\u6bb5\u65f6\u95f4\u5c31\u53ea\u5904\u7406\u4f60\u4eec\u914d\u9001\u7684\u95ee\u9898\uff0c\u786e\u4fdd\u914d\u9001\u53ca\u65f6\u3002",
              "options": [{
                  "id": 3,
                  "point": 9,
                  "description": "\u90a3\u592a\u597d\u4e86\uff0c\u8fd9\u53ef\u4ee5\u5e2e\u52a9\u6211\u4eec\u6e21\u8fc7\u773c\u524d\u7684\u96be\u5173\u4e86\u3002\u6211\u4e5f\u4f1a\u6d3e\u4e00\u4e2a\u540c\u4e8b\u4e13\u95e8\u8d1f\u8d23\u548c\u4f60\u4eec\u5bf9\u63a5\u3002",
                  "short_description": null,
                  "addition": "",
                  "selected": false,
                  "ka": 5,
                  "nextQuestionId": 3358
              }, {
                  "id": 2,
                  "point": -1,
                  "description": "\u975e\u5e38\u611f\u8c22\uff01\u7ec8\u4e8e\u53ef\u4ee5\u653e\u4e0b\u5fc3\u4e86\u3002\u8981\u4f60\u4eec\u5728\u8fd9\u4e48\u5fd9\u7684\u5de5\u4f5c\u5185\uff0c\u8fd8\u62bd\u51fa\u65f6\u95f4\u89e3\u51b3\u6211\u4eec\u7684\u95ee\u9898\uff0c\u771f\u662f\u8fc7\u610f\u4e0d\u53bb\u3002",
                  "short_description": null,
                  "addition": "",
                  "selected": false,
                  "ka": -1,
                  "nextQuestionId": 3357
              }, {
                  "id": 1,
                  "point": -1,
                  "description": "\u597d\uff01\u6ca1\u95ee\u9898\uff0c\u5982\u679c\u9700\u8981\u6211\u914d\u5408\u7684\uff0c\u4f60\u4eec\u5c3d\u7ba1\u5f00\u53e3\u3002",
                  "short_description": null,
                  "addition": "",
                  "selected": false,
                  "ka": -1,
                  "nextQuestionId": 3356
              }],
              "directorComment": "\u5bf9\u65b9\u63d0\u51fa\u65b9\u6848\u4e86\uff0c\u4f60\u89c9\u5f97\u600e\u4e48\u6837\uff1f",
              "expression": "\u6b63\u5e38",
              "description_length": 1
          }, {
              "id": 3366,
              "description": "\u6211\u5728\u56e2\u961f\u91cc\u817e\u51fa\u4e00\u4e2a\u4eba\u624b\u6765\uff0c\u8fd9\u6bb5\u65f6\u95f4\u5c31\u53ea\u5904\u7406\u4f60\u4eec\u914d\u9001\u7684\u95ee\u9898\uff0c\u786e\u4fdd\u914d\u9001\u53ca\u65f6\u3002",
              "options": [{
                  "id": 3,
                  "point": 9,
                  "description": "\u90a3\u592a\u597d\u4e86\uff0c\u8fd9\u53ef\u4ee5\u5e2e\u52a9\u6211\u4eec\u6e21\u8fc7\u773c\u524d\u7684\u96be\u5173\u4e86\u3002\u6211\u4e5f\u4f1a\u6d3e\u4e00\u4e2a\u540c\u4e8b\u4e13\u95e8\u8d1f\u8d23\u548c\u4f60\u4eec\u5bf9\u63a5\u3002",
                  "short_description": null,
                  "addition": "",
                  "selected": false,
                  "ka": 5,
                  "nextQuestionId": 3358
              }, {
                  "id": 2,
                  "point": -1,
                  "description": "\u975e\u5e38\u611f\u8c22\uff01\u7ec8\u4e8e\u53ef\u4ee5\u653e\u4e0b\u5fc3\u4e86\u3002\u8981\u4f60\u4eec\u5728\u8fd9\u4e48\u5fd9\u7684\u5de5\u4f5c\u5185\uff0c\u8fd8\u62bd\u51fa\u65f6\u95f4\u89e3\u51b3\u6211\u4eec\u7684\u95ee\u9898\uff0c\u771f\u662f\u8fc7\u610f\u4e0d\u53bb\u3002",
                  "short_description": null,
                  "addition": "",
                  "selected": false,
                  "ka": -1,
                  "nextQuestionId": 3357
              }, {
                  "id": 1,
                  "point": -1,
                  "description": "\u597d\uff01\u6ca1\u95ee\u9898\uff0c\u5982\u679c\u9700\u8981\u6211\u914d\u5408\u7684\uff0c\u4f60\u4eec\u5c3d\u7ba1\u5f00\u53e3\u3002",
                  "short_description": null,
                  "addition": "",
                  "selected": false,
                  "ka": -1,
                  "nextQuestionId": 3356
              }],
              "directorComment": "\u5bf9\u65b9\u63d0\u51fa\u65b9\u6848\u4e86\uff0c\u4f60\u89c9\u5f97\u600e\u4e48\u6837\uff1f",
              "expression": "\u6b63\u5e38",
              "description_length": 1
          }, {
              "id": 3367,
              "description": "\u6ca1\u4e8b\uff0c\u5927\u5bb6\u90fd\u662f\u4e3a\u4e86\u5de5\u4f5c\uff0c\u5e94\u8be5\u7684\u3002",
              "options": [],
              "directorComment": "\u3010\u4f60\u79bb\u5f00\u4e86\u79e6\u98de\u7684\u529e\u516c\u5ba4\u3011\u4ec5\u9760\u4e00\u4e2a\u77ed\u671f\u65b9\u6848\uff0c\u80fd\u5f7b\u5e95\u89e3\u51b3\u95e8\u5e97\u7684\u7269\u6d41\u95ee\u9898\u5417\uff1f\u6050\u6015\u8fc7\u4e0d\u4e86\u591a\u4e45\uff0c\u4f60\u53c8\u5f97\u9891\u7e41\u9020\u8bbf\u7269\u6d41\u90e8\u4e86\u3002",
              "expression": "\u63a5\u53d7",
              "description_length": 1
          }, {
              "id": 3368,
              "description": "\u5f53\u65f6\u6ca1\u60f3\u5230\u8fd9\u4e2a\u670d\u52a1\u7684\u9700\u6c42\u91cf\u8fd9\u4e48\u5927\u3002\u73b0\u5728\u7684\u8d44\u6e90\u548c\u6210\u672c\uff0c\u6839\u672c\u505a\u4e0d\u5230\u6211\u4eec\u627f\u8bfa\u7684\u65f6\u95f4\u3002\u6240\u4ee5\u4e0d\u5982\u628a\u8fd9\u4e2a\u670d\u52a1\u53d6\u6d88\u5427\u3002",
              "options": [{
                  "id": 3,
                  "point": 1,
                  "description": "\u5f53\u521d\u786e\u5b9e\u662f\u8003\u91cf\u4e0d\u5468\uff0c\u4e0d\u8fc7\u4e5f\u4e0d\u80fd\u8bf4\u64a4\u5c31\u64a4\u3002\u8981\u4e0d\u8fd9\u6837\uff0c\u6211\u56de\u53bb\u95ee\u95ee\u770b\u6211\u8001\u677f\uff0c\u542c\u542c\u4ed6\u7684\u610f\u89c1\u3002",
                  "short_description": null,
                  "addition": "",
                  "selected": false,
                  "ka": 5,
                  "nextQuestionId": 3371
              }, {
                  "id": 2,
                  "point": 9,
                  "description": "\u8fd9\u4e00\u70b9\uff0c\u6211\u5012\u662f\u6709\u4e0d\u540c\u7684\u60f3\u6cd5\u3002\u9700\u6c42\u91cf\u5927\u6070\u6070\u8bf4\u660e\u65b9\u5411\u662f\u6b63\u786e\u7684\uff0c\u6211\u5efa\u8bae\u4fdd\u7559\u3002",
                  "short_description": null,
                  "addition": "",
                  "selected": false,
                  "ka": 4,
                  "nextQuestionId": 3370
              }, {
                  "id": 1,
                  "point": -1,
                  "description": "\u8fd9\u4e0d\u592a\u597d\u5427\u3002\u5f00\u4e1a\u6ca1\u591a\u4e45\u5c31\u8981\u53d6\u6d88\u670d\u52a1\uff0c\u6709\u635f\u4fe1\u8a89\u554a\u3002",
                  "short_description": null,
                  "addition": "",
                  "selected": false,
                  "ka": -1,
                  "nextQuestionId": 3369
              }],
              "directorComment": "\u627f\u8bfa\u4e0d\u5408\u7406\uff0c\u670d\u52a1\u8981\u53d6\u6d88\uff1f\u5e97\u957f\uff0c\u4f60\u600e\u4e48\u770b\uff1f",
              "expression": "\u6297\u62d2",
              "description_length": 1
          }, {
              "id": 3369,
              "description": "\u6211\u77e5\u9053\u8fd9\u6837\u5bf9\u4f60\u4eec\u5e97\u7684\u58f0\u8a89\u6709\u5f71\u54cd\u3002\u4f46\u6211\u4eec\u8fd8\u662f\u8981\u73b0\u5b9e\u70b9\uff0c\u5bf9\u4e0d\u5bf9\uff1f\u8fd9\u4e2a\u5bf9\u7269\u6d41\u7684\u7075\u6d3b\u5ea6\u8981\u6c42\u592a\u9ad8\uff0c\u505a\u4e0d\u4e86\u3002",
              "options": [{
                  "id": 3,
                  "point": 9,
                  "description": "\u5982\u679c\u5bf9\u670d\u52a1\u9879\u76ee\u505a\u4e9b\u8c03\u6574\u5462\uff1f\u6bd4\u5982\u5ef6\u957f\u9001\u8d27\u65f6\u95f4\u5230\u4e24\u5c0f\u65f6\uff0c\u6216\u8005\u91c7\u53d6\u90e8\u5206\u4ed8\u8d39\u673a\u5236\uff1f\u8fd9\u6837\uff0c\u80fd\u4fdd\u7559\u8fd9\u9879\u670d\u52a1\u5417\uff1f",
                  "short_description": null,
                  "addition": "",
                  "selected": false,
                  "ka": 5,
                  "nextQuestionId": 3374
              }, {
                  "id": 2,
                  "point": 1,
                  "description": "\u6211\u77e5\u9053\u8fd9\u4e2a\u96be\u5ea6\u6709\u70b9\u5927\uff0c\u4f46\u662f\u53d6\u6d88\u7684\u8bdd\uff0c\u4e1a\u52a1\u5f71\u54cd\u4e5f\u5f88\u5927\u3002\u6709\u4ec0\u4e48\u6298\u4e2d\u7684\u65b9\u5f0f\u5417\uff1f",
                  "short_description": null,
                  "addition": "",
                  "selected": false,
                  "ka": 5,
                  "nextQuestionId": 3373
              }, {
                  "id": 1,
                  "point": -1,
                  "description": "\u8fd9\u6837\u554a\u2026\u2026\u90a3\u6211\u56de\u53bb\u548c\u6211\u8001\u677f\u6c9f\u901a\u4e00\u4e0b\uff0c\u5b9e\u5728\u4e0d\u884c\u7684\u8bdd\uff0c\u6682\u65f6\u53d6\u6d88\u8fd9\u9879\u670d\u52a1\u3002",
                  "short_description": null,
                  "addition": "",
                  "selected": false,
                  "ka": -1,
                  "nextQuestionId": 3372
              }],
              "directorComment": "\u64cd\u4f5c\u6709\u96be\u5ea6\uff0c\u5bf9\u65b9\u76f4\u8a00\u62d2\u7edd\uff0c\u60f3\u60f3\u8fd8\u6709\u4ec0\u4e48\u62db\u5427\u3002",
              "expression": "\u6297\u62d2",
              "description_length": 1
          }, {
              "id": 3370,
              "description": "\u6211\u77e5\u9053\u8fd9\u4e2a\u5bf9\u4e1a\u52a1\u8d21\u732e\u5ea6\u5f88\u5927\u3002\u4f46\u6211\u4eec\u8fd8\u662f\u8981\u73b0\u5b9e\u70b9\uff0c\u5bf9\u4e0d\u5bf9\uff1f\u8fd9\u4e2a\u5bf9\u7269\u6d41\u7684\u7075\u6d3b\u5ea6\u8981\u6c42\u592a\u9ad8\uff0c\u505a\u4e0d\u4e86\u3002",
              "options": [{
                  "id": 3,
                  "point": 9,
                  "description": "\u5982\u679c\u5bf9\u670d\u52a1\u9879\u76ee\u505a\u4e9b\u8c03\u6574\u5462\uff1f\u6bd4\u5982\u5ef6\u957f\u9001\u8d27\u65f6\u95f4\u5230\u4e24\u5c0f\u65f6\uff0c\u6216\u8005\u91c7\u53d6\u90e8\u5206\u4ed8\u8d39\u673a\u5236\uff1f\u8fd9\u6837\uff0c\u80fd\u4fdd\u7559\u8fd9\u9879\u670d\u52a1\u5417\uff1f",
                  "short_description": null,
                  "addition": "",
                  "selected": false,
                  "ka": 5,
                  "nextQuestionId": 3374
              }, {
                  "id": 2,
                  "point": 1,
                  "description": "\u6211\u77e5\u9053\u8fd9\u4e2a\u96be\u5ea6\u6709\u70b9\u5927\uff0c\u4f46\u662f\u53d6\u6d88\u7684\u8bdd\uff0c\u4e1a\u52a1\u5f71\u54cd\u4e5f\u5f88\u5927\u3002\u6709\u4ec0\u4e48\u6298\u4e2d\u7684\u65b9\u5f0f\u5417\uff1f",
                  "short_description": null,
                  "addition": "",
                  "selected": false,
                  "ka": 5,
                  "nextQuestionId": 3373
              }, {
                  "id": 1,
                  "point": -1,
                  "description": "\u8fd9\u6837\u554a\u2026\u2026\u90a3\u6211\u56de\u53bb\u548c\u6211\u8001\u677f\u6c9f\u901a\u4e00\u4e0b\uff0c\u5b9e\u5728\u4e0d\u884c\u7684\u8bdd\uff0c\u6682\u65f6\u53d6\u6d88\u8fd9\u9879\u670d\u52a1\u3002",
                  "short_description": null,
                  "addition": "",
                  "selected": false,
                  "ka": -1,
                  "nextQuestionId": 3372
              }],
              "directorComment": "\u64cd\u4f5c\u6709\u96be\u5ea6\uff0c\u5bf9\u65b9\u76f4\u8a00\u62d2\u7edd\uff0c\u60f3\u60f3\u8fd8\u6709\u4ec0\u4e48\u62db\u5427\u3002",
              "expression": "\u6297\u62d2",
              "description_length": 1
          }, {
              "id": 3371,
              "description": "\u53ef\u4ee5\u554a\uff0c\u6211\u6ca1\u610f\u89c1\u3002",
              "options": [{
                  "id": 1,
                  "point": -1,
                  "description": "\u90a3\u4eca\u5929\u5dee\u4e0d\u591a\u4e86\u3002\u7b49\u6211\u786e\u8ba4\u4e86\uff0c\u54b1\u4eec\u518d\u7ea6\u65f6\u95f4\uff01",
                  "short_description": null,
                  "addition": "",
                  "selected": false,
                  "ka": -1,
                  "nextQuestionId": 3375
              }, {
                  "id": 2,
                  "point": 1,
                  "description": "\u597d\uff0c\u90a3\u5230\u65f6\u5019\u6211\u4eec\u518d\u7ea6\u65f6\u95f4\u3002\u53e6\u5916\uff0c\u957f\u671f\u6765\u770b\uff0c\u5b9e\u4f53\u5e97\u7684\u7269\u6d41\u89c4\u5212\u8be5\u600e\u4e48\u4f18\u5316\uff1f",
                  "short_description": null,
                  "addition": "",
                  "selected": false,
                  "ka": 5,
                  "nextQuestionId": 3376
              }],
              "directorComment": "\u7529\u9505\u7ed9\u8001\u677f\uff0c\u8001\u677f\u5f88\u65e0\u5948\u2026\u2026",
              "expression": "\u51b7\u6f20",
              "description_length": 1
          }, {
              "id": 3372,
              "description": "\u53ef\u4ee5\uff0c\u6211\u6ca1\u610f\u89c1\u3002",
              "options": [{
                  "id": 2,
                  "point": 1,
                  "description": "\u597d\uff0c\u90a3\u5230\u65f6\u5019\u6211\u4eec\u518d\u7ea6\u65f6\u95f4\u3002\u53e6\u5916\uff0c\u957f\u671f\u6765\u770b\uff0c\u5b9e\u4f53\u5e97\u7684\u7269\u6d41\u89c4\u5212\u8be5\u600e\u4e48\u4f18\u5316\uff1f",
                  "short_description": null,
                  "addition": "",
                  "selected": false,
                  "ka": 5,
                  "nextQuestionId": 3376
              }, {
                  "id": 1,
                  "point": -1,
                  "description": "\u90a3\u4eca\u5929\u5dee\u4e0d\u591a\u4e86\u3002\u7b49\u6211\u786e\u8ba4\u4e86\uff0c\u54b1\u4eec\u518d\u7ea6\u65f6\u95f4\uff01",
                  "short_description": null,
                  "addition": "",
                  "selected": false,
                  "ka": -1,
                  "nextQuestionId": 3375
              }],
              "directorComment": "\u7529\u9505\u7ed9\u8001\u677f\uff0c\u8001\u677f\u5f88\u65e0\u5948\u2026\u2026",
              "expression": "\u51b7\u6f20",
              "description_length": 1
          }, {
              "id": 3373,
              "description": "\u90a3\u6211\u56de\u5934\u60f3\u60f3\uff0c\u4e4b\u540e\u518d\u7ed9\u4f60\u7b54\u590d\u3002",
              "options": [{
                  "id": 3,
                  "point": -1,
                  "description": "\u90a3\u6211\u4eec\u5c31\u8c08\u8c08\u5177\u4f53\u7684\u65f6\u95f4\u70b9\u548c\u4efb\u52a1\u5b89\u6392\u5427\uff0c\u600e\u4e48\u6837\uff1f",
                  "short_description": null,
                  "addition": "",
                  "selected": false,
                  "ka": -1,
                  "nextQuestionId": 3379
              }, {
                  "id": 2,
                  "point": -1,
                  "description": "\u884c\u5427\uff0c\u53cd\u6b63\u4e5f\u662f\u6743\u5b9c\u4e4b\u8ba1\u3002\u6211\u4eec\u8fd8\u8981\u60f3\u4e2a\u957f\u671f\u65b9\u6848\uff0c\u5f7b\u5e95\u89e3\u51b3\u7269\u6d41\u95ee\u9898\u3002",
                  "short_description": null,
                  "addition": "",
                  "selected": false,
                  "ka": -1,
                  "nextQuestionId": 3377
              }, {
                  "id": 1,
                  "point": 3,
                  "description": "\u597d\u7684\uff0c\u90a3\u6211\u7b49\u4f60\u6d88\u606f\u3002\u81f3\u4e8e\u957f\u671f\u7684\u7269\u6d41\u95ee\u9898\u8be5\u600e\u4e48\u89e3\u51b3\uff0c\u4f60\u6709\u4ec0\u4e48\u5efa\u8bae\u5417\uff1f",
                  "short_description": null,
                  "addition": "",
                  "selected": false,
                  "ka": 5,
                  "nextQuestionId": 3378
              }],
              "directorComment": "\u8bf7\u6c42\u5bf9\u65b9\u7ed9\u7b54\u6848\u7684\u65f6\u5019\uff0c\u4e5f\u4e0d\u59a8\u5206\u4eab\u4e00\u4e0b\u81ea\u5df1\u7684\u601d\u8def\u3002\u8fd9\u6837\uff0c\u65b9\u6848\u7684\u5f00\u5c55\u4f1a\u66f4\u9ad8\u6548\u54e6\u3002",
              "expression": "\u51b7\u6f20",
              "description_length": 1
          }, {
              "id": 3374,
              "description": "\u3010\u601d\u8003\u4e2d\u3011\u8fd9\u6837\u5427\uff0c\u6211\u7b80\u5355\u8bc4\u4f30\u4e00\u4e0b\u3002\u603b\u4e4b\uff0c\u8fd9\u9879\u670d\u52a1\u4f60\u60f3\u7559\u4e0b\uff0c\u5bf9\u4e0d\u5bf9\uff1f",
              "options": [{
                  "id": 3,
                  "point": -1,
                  "description": "\u6ca1\u9519\u3002\u6240\u4ee5\uff0c\u63a5\u4e0b\u6765\u5f97\u7684\u5177\u4f53\u884c\u52a8\u8ba1\u5212\uff0c\u4f60\u6253\u7b97\u4ec0\u4e48\u65f6\u5019\u5f00\u5c55\uff1f",
                  "short_description": null,
                  "addition": "",
                  "selected": false,
                  "ka": -1,
                  "nextQuestionId": 3379
              }, {
                  "id": 2,
                  "point": 9,
                  "description": "\u662f\u7684\uff0c\u8fd9\u6837\u6211\u4eec\u603b\u7b97\u6682\u65f6\u80fd\u6e21\u8fc7\u96be\u5173\u4e86\u3002\u81f3\u4e8e\u957f\u671f\u7684\u7269\u6d41\u95ee\u9898\u8be5\u600e\u4e48\u89e3\u51b3\uff0c\u4f60\u6709\u4ec0\u4e48\u5efa\u8bae\u5417\uff1f",
                  "short_description": null,
                  "addition": "",
                  "selected": false,
                  "ka": 5,
                  "nextQuestionId": 3378
              }, {
                  "id": 1,
                  "point": -1,
                  "description": "\u5bf9\u3002\u53e6\u5916\uff0c\u8fd9\u4e9b\u53ea\u80fd\u77ed\u671f\u5185\u5e94\u5e94\u6025\u3002\u6211\u4eec\u8fd8\u5f97\u518d\u60f3\u4e00\u4e2a\u957f\u671f\u89e3\u51b3\u65b9\u6848\u624d\u884c\u3002",
                  "short_description": null,
                  "addition": "",
                  "selected": false,
                  "ka": -1,
                  "nextQuestionId": 3377
              }],
              "directorComment": "\u6210\u529f\u8bf4\u670d\u5bf9\u65b9\uff0c\u505a\u5f97\u597d\uff01",
              "expression": "\u4e3a\u96be",
              "description_length": 1
          }, {
              "id": 3375,
              "description": "\u597d\u554a\uff0c\u6ca1\u95ee\u9898\u3002\u6709\u4e8b\u968f\u65f6\u8054\u7cfb\u3002",
              "options": [],
              "directorComment": "\u3010\u4f60\u79bb\u5f00\u4e86\u79e6\u98de\u7684\u529e\u516c\u5ba4\u3011\u5c31\u8fd9\u4e48\u7ed3\u675f\u5bf9\u8bdd\uff0c\u4f3c\u4e4e\u4ecd\u672a\u89e3\u51b3\u95e8\u5e97\u7684\u7269\u6d41\u95ee\u9898\u3002\u770b\u6765\u63a5\u4e0b\u6765\u7684\u4e00\u6bb5\u65e5\u5b50\uff0c\u4f60\u8fd8\u5f97\u9891\u7e41\u9020\u8bbf\u7269\u6d41\u90e8\u4e86\u3002",
              "expression": "\u51b7\u6f20",
              "description_length": 1
          }, {
              "id": 3376,
              "description": "\u54ce\u54df\uff0c\u8fd9\u4e2a\u95ee\u9898\u592a\u5927\u4e86\uff0c\u4e0d\u662f\u6211\u80fd\u5b9a\u5f97\u4e86\u7684\u3002\u7269\u6d41\u90e8\u95e8\u8981\u652f\u6301\u6240\u6709\u7684\u4e1a\u52a1\u7ebf\uff0c\u7275\u4e00\u53d1\u800c\u52a8\u5168\u8eab\u554a\u3002",
              "options": [{
                  "id": 2,
                  "point": 9,
                  "description": "\u5f53\u7136\u5f53\u7136\uff0c\u6211\u660e\u767d\u3002\u8fd9\u6837\uff0c\u6211\u6253\u7b97\u5411\u7ba1\u7406\u5c42\u505a\u4e2a\u6c47\u62a5\uff0c\u8c08\u8c08\u5b9e\u4f53\u5e97\u8981\u89e3\u51b3\u7684\u95ee\u9898\u3002\u7269\u6d41\u65b9\u9762\u80fd\u8bf7\u4f60\u5e2e\u6211\u505a\u4e2a\u89c4\u5212\u5417\uff1f",
                  "short_description": null,
                  "addition": "",
                  "selected": false,
                  "ka": 1,
                  "nextQuestionId": 3381
              }, {
                  "id": 1,
                  "point": -1,
                  "description": "\u8fd9\u6837\u554a\u2026\u2026\u90a3\u6211\u5230\u65f6\u5019\u8054\u7edc\u5404\u90e8\u95e8\uff0c\u5927\u5bb6\u4e00\u8d77\u5f00\u4e2a\u4f1a\uff0c\u770b\u770b\u5982\u4f55\u89e3\u51b3\u3002\u5230\u65f6\u5019\uff0c\u8bf7\u4f60\u4e00\u8d77\u53c2\u52a0\u3002",
                  "short_description": null,
                  "addition": "",
                  "selected": false,
                  "ka": -1,
                  "nextQuestionId": 3380
              }],
              "directorComment": "\u4efb\u52a1\u6709\u96be\u5ea6\uff0c\u5982\u4f55\u7834\u89e3\uff1f",
              "expression": "\u4e3a\u96be",
              "description_length": 1
          }, {
              "id": 3377,
              "description": "\u8fd9\u4e2a\u6211\u73b0\u5728\u4e5f\u7ed9\u4e0d\u4e86\u4f60\u3002\u4f9b\u5e94\u7ba1\u7406\u7275\u6d89\u5230\u6240\u6709\u7684\u4e1a\u52a1\u7ebf\uff0c\u7275\u4e00\u53d1\u800c\u52a8\u8eab\uff0c\u4e0d\u662f\u4f60\u6211\u62cd\u62cd\u8111\u888b\u5c31\u80fd\u641e\u5b9a\u7684\u3002",
              "options": [{
                  "id": 2,
                  "point": 9,
                  "description": "\u5f53\u7136\u5f53\u7136\uff0c\u6211\u660e\u767d\u3002\u8fd9\u6837\uff0c\u6211\u6253\u7b97\u5411\u7ba1\u7406\u5c42\u505a\u4e2a\u6c47\u62a5\uff0c\u8c08\u8c08\u5b9e\u4f53\u5e97\u8981\u89e3\u51b3\u7684\u95ee\u9898\u3002\u7269\u6d41\u65b9\u9762\u80fd\u8bf7\u4f60\u5e2e\u6211\u505a\u4e2a\u89c4\u5212\u5417\uff1f",
                  "short_description": null,
                  "addition": "",
                  "selected": false,
                  "ka": 1,
                  "nextQuestionId": 3381
              }, {
                  "id": 1,
                  "point": -1,
                  "description": "\u8fd9\u6837\u554a\u2026\u2026\u90a3\u6211\u5230\u65f6\u5019\u8054\u7edc\u5404\u90e8\u95e8\uff0c\u5927\u5bb6\u4e00\u8d77\u5f00\u4e2a\u4f1a\uff0c\u770b\u770b\u5982\u4f55\u89e3\u51b3\u3002\u5230\u65f6\u5019\uff0c\u8bf7\u4f60\u4e00\u8d77\u53c2\u52a0\u3002",
                  "short_description": null,
                  "addition": "",
                  "selected": false,
                  "ka": -1,
                  "nextQuestionId": 3380
              }],
              "directorComment": "\u4efb\u52a1\u6709\u96be\u5ea6\uff0c\u5982\u4f55\u7834\u89e3\uff1f",
              "expression": "\u4e3a\u96be",
              "description_length": 1
          }, {
              "id": 3378,
              "description": "\u54ce\u54df\uff0c\u8fd9\u4e2a\u95ee\u9898\u592a\u5927\u4e86\uff0c\u4e0d\u662f\u6211\u80fd\u5b9a\u5f97\u4e86\u7684\u3002\u7269\u6d41\u90e8\u95e8\u8981\u652f\u6301\u6240\u6709\u7684\u4e1a\u52a1\u7ebf\uff0c\u7275\u4e00\u53d1\u800c\u52a8\u5168\u8eab\u554a\u3002",
              "options": [{
                  "id": 2,
                  "point": 9,
                  "description": "\u5f53\u7136\u5f53\u7136\uff0c\u6211\u660e\u767d\u3002\u8fd9\u6837\uff0c\u6211\u6253\u7b97\u5411\u7ba1\u7406\u5c42\u505a\u4e2a\u6c47\u62a5\uff0c\u8c08\u8c08\u5b9e\u4f53\u5e97\u8981\u89e3\u51b3\u7684\u95ee\u9898\u3002\u7269\u6d41\u65b9\u9762\u80fd\u8bf7\u4f60\u5e2e\u6211\u505a\u4e2a\u89c4\u5212\u5417\uff1f",
                  "short_description": null,
                  "addition": "",
                  "selected": false,
                  "ka": 1,
                  "nextQuestionId": 3381
              }, {
                  "id": 1,
                  "point": -1,
                  "description": "\u8fd9\u6837\u554a\u2026\u2026\u90a3\u6211\u5230\u65f6\u5019\u8054\u7edc\u5404\u90e8\u95e8\uff0c\u5927\u5bb6\u4e00\u8d77\u5f00\u4e2a\u4f1a\uff0c\u770b\u770b\u5982\u4f55\u89e3\u51b3\u3002\u5230\u65f6\u5019\uff0c\u8bf7\u4f60\u4e00\u8d77\u53c2\u52a0\u3002",
                  "short_description": null,
                  "addition": "",
                  "selected": false,
                  "ka": -1,
                  "nextQuestionId": 3380
              }],
              "directorComment": "\u4efb\u52a1\u6709\u96be\u5ea6\uff0c\u5982\u4f55\u7834\u89e3\uff1f",
              "expression": "\u4e3a\u96be",
              "description_length": 1
          }, {
              "id": 3379,
              "description": "\u6211\u4eca\u5929\u4e0b\u73ed\u524d\u5e2e\u4f60\u627e\u5230\u4eba\u624b\uff0c\u4e13\u95e8\u89e3\u51b3\u4f60\u4eec\u95e8\u5e97\u7684\u914d\u9001\u95ee\u9898\u3002",
              "options": [{
                  "id": 3,
                  "point": 3,
                  "description": "\u884c\uff01\u5230\u5e95\u662f\u8001\u79e6\u6709\u6548\u7387\u3002\u90a3\u201c\u9650\u65f6\u9001\u5230\u5bb6\u201d\u670d\u52a1\u7684\u8bc4\u4f30\uff0c\u4ec0\u4e48\u65f6\u5019\u51fa\u6765\uff1f",
                  "short_description": null,
                  "addition": "",
                  "selected": false,
                  "ka": 6,
                  "nextQuestionId": 3384
              }, {
                  "id": 1,
                  "point": 3,
                  "description": "\u884c\uff01\u6211\u8ba9\u65b0\u6765\u7684\u5c0f\u8f76\u8d1f\u8d23\u548c\u4f60\u4eec\u5bf9\u63a5\u3002",
                  "short_description": null,
                  "addition": "",
                  "selected": false,
                  "ka": 6,
                  "nextQuestionId": 3382
              }, {
                  "id": 2,
                  "point": 2,
                  "description": "\u6ca1\u95ee\u9898\uff01\u4eca\u5929\u6765\u4e00\u8d9f\uff0c\u89e3\u51b3\u4e86\u8ba9\u6211\u5934\u75bc\u7684\u95ee\u9898\u3002\u7ec8\u4e8e\u80fd\u677e\u53e3\u6c14\u4e86\u3002\u591a\u8c22\u4e86\uff01",
                  "short_description": null,
                  "addition": "",
                  "selected": false,
                  "ka": 3,
                  "nextQuestionId": 3383
              }],
              "directorComment": "\u5bf9\u8bdd\u6e10\u5165\u4f73\u5883\uff0c\u8bf7\u7ee7\u7eed\u3002",
              "expression": "\u6b63\u5e38",
              "description_length": 1
          }, {
              "id": 3380,
              "description": "\u597d\u554a\uff0c\u4e00\u5b9a\u652f\u6301\u3002",
              "options": [{
                  "id": 3,
                  "point": 2,
                  "description": "\u4f1a\u8bae\u6211\u6765\u5b89\u6392\uff0c\u4e0d\u8fc7\u80fd\u4e0d\u80fd\u8bf7\u4f60\u5e2e\u6211\u505a\u4e2a\u7269\u6d41\u65b9\u6848\uff0c\u8fd9\u6837\u4f1a\u8bae\u7684\u8ba8\u8bba\u66f4\u6709\u65b9\u5411\u3002",
                  "short_description": null,
                  "addition": "",
                  "selected": false,
                  "ka": 5,
                  "nextQuestionId": 3381
              }, {
                  "id": 2,
                  "point": -1,
                  "description": "\u8c22\u8c22\uff01\u65f6\u95f4\u4e5f\u4e0d\u65e9\u4e86\uff0c\u6211\u603b\u7ed3\u4e00\u4e0b\u884c\u52a8\u8ba1\u5212\u5427\uff1a\u5546\u54c1\u8865\u7ed9\u7684\u95ee\u9898\uff0c\u4f60\u4eec\u4f1a\u6709\u4e13\u4eba\u6765\u5904\u7406\uff0c\u5bf9\u5427\uff1f",
                  "short_description": null,
                  "addition": "",
                  "selected": false,
                  "ka": -1,
                  "nextQuestionId": 3408
              }, {
                  "id": 1,
                  "point": -1,
                  "description": "\u8c22\u8c22\uff01\u4f60\u7684\u652f\u6301\u5bf9\u6211\u4eec\u6765\u8bf4\u592a\u91cd\u8981\u4e86\u3002\u4eca\u5929\u8c08\u5f97\u5dee\u4e0d\u591a\u4e86\uff0c\u6211\u4e5f\u4e0d\u518d\u53e8\u6270\u4e86\u3002",
                  "short_description": null,
                  "addition": "",
                  "selected": false,
                  "ka": -1,
                  "nextQuestionId": 3407
              }],
              "directorComment": "\u5bf9\u65b9\u8868\u793a\u540c\u610f\uff0c\u4f60\u8be5\u5982\u4f55\u56de\u5e94\uff1f",
              "expression": "\u6b63\u5e38",
              "description_length": 1
          }, {
              "id": 3381,
              "description": "\u53ef\u4ee5\u662f\u53ef\u4ee5\uff0c\u4e0d\u8fc7\u2026\u2026\u6211\u4eec\u5bf9\u4f60\u4eec\u7684\u60c5\u51b5\u4e0d\u592a\u4e86\u89e3\u3002",
              "options": [{
                  "id": 3,
                  "point": 6,
                  "description": "\u6ca1\u4e8b\uff0c\u6211\u4eec\u4e00\u5b9a\u77e5\u65e0\u4e0d\u8a00\uff0c\u8a00\u65e0\u4e0d\u5c3d\u3002\u4e0d\u8fc7\uff0c\u8fd9\u9879\u5de5\u4f5c\u4ec0\u4e48\u65f6\u5019\u5f00\u59cb\uff0c\u5177\u4f53\u600e\u4e48\u6267\u884c\u5462\uff1f",
                  "short_description": null,
                  "addition": "",
                  "selected": false,
                  "ka": 6,
                  "nextQuestionId": 3387
              }, {
                  "id": 2,
                  "point": 9,
                  "description": "\u653e\u5fc3\uff0c\u6211\u4eec\u53ef\u4ee5\u914d\u5408\u4f60\u505a\u6570\u636e\u548c\u8d44\u6599\u6574\u7406\u3002\u6211\u6765\u603b\u7ed3\u4e00\u4e0b\u884c\u52a8\u8ba1\u5212\u5427\uff1a\u5546\u54c1\u8865\u7ed9\u7684\u95ee\u9898\uff0c\u4f60\u4eec\u4f1a\u6709\u4e13\u4eba\u5904\u7406\uff0c\u5bf9\u5427\uff1f",
                  "short_description": null,
                  "addition": "",
                  "selected": false,
                  "ka": 6,
                  "nextQuestionId": 3386
              }, {
                  "id": 1,
                  "point": 3,
                  "description": "\u653e\u5fc3\uff0c\u6570\u636e\u548c\u8d44\u6599\u65b9\u9762\uff0c\u6211\u4eec\u4f1a\u63d0\u4f9b\u3002\u65f6\u95f4\u5dee\u4e0d\u591a\u4e86\uff0c\u4eca\u5929\u8c22\u8c22\u4f60\u7684\u65f6\u95f4\u4e86\u3002",
                  "short_description": null,
                  "addition": "",
                  "selected": false,
                  "ka": 6,
                  "nextQuestionId": 3385
              }],
              "directorComment": "\u8bf7\u6c42\u5408\u7406\u5230\u4f4d\uff01\u5bf9\u65b9\u7684\u90a3\u4e00\u70b9\u5c0f\u987e\u8651\uff0c\u4e5f\u8bf7\u53ca\u65f6\u56de\u5e94\u3002",
              "expression": "\u4e3a\u96be",
              "description_length": 1
          }, {
              "id": 3382,
              "description": "\u597d\u554a\u3002",
              "options": [{
                  "id": 1,
                  "point": 3,
                  "description": "\u90a3\u4eca\u5929\u5c31\u5dee\u4e0d\u591a\u4e86\u3002\u201c\u9650\u65f6\u9001\u5230\u5bb6\u201d\u670d\u52a1\u8bc4\u4f30\u4ec0\u4e48\u65f6\u5019\u80fd\u56de\u590d\u6211\uff1f\u6211\u4eec\u9700\u8981\u518d\u7ea6\u4e2a\u4f1a\u3002",
                  "short_description": null,
                  "addition": "",
                  "selected": false,
                  "ka": 6,
                  "nextQuestionId": 3388
              }, {
                  "id": 2,
                  "point": -1,
                  "description": "\u90a3\u6211\u5c31\u4e0d\u518d\u53e8\u6270\u4e86\uff01\u7b49\u201c\u9650\u65f6\u9001\u5230\u5bb6\u201d\u670d\u52a1\u8bc4\u4f30\u5b8c\u4e86\uff0c\u6211\u4eec\u518d\u7ea6\u4e2a\u4f1a\u5427\u3002",
                  "short_description": null,
                  "addition": "",
                  "selected": false,
                  "ka": -1,
                  "nextQuestionId": 3389
              }],
              "directorComment": "\u53ca\u65f6\u4e3b\u52a8\u5730\u63d0\u4f9b\u652f\u6301\uff0c\u597d\u8bc4\uff01",
              "expression": "\u6b63\u5e38",
              "description_length": 1
          }, {
              "id": 3383,
              "description": "\u5ba2\u6c14\u4e86\uff0c\u5e94\u8be5\u7684\u3002\u4ee5\u540e\u6709\u4e8b\u968f\u65f6\u8054\u7cfb\u3002",
              "options": [],
              "directorComment": "\u3010\u4f60\u79bb\u5f00\u4e86\u529e\u516c\u5ba4\uff0c\u5fc3\u91cc\u7f8e\u6ecb\u6ecb\u3002\u3011\u71c3\u7709\u4e4b\u6025\u786e\u5b9e\u89e3\u51b3\u4e86\uff0c\u4f46\u8fd9\u4e9b\u65b9\u6848\u7ba1\u5f97\u4e86\u4e00\u65f6\uff0c\u7ba1\u4e0d\u4e86\u4e00\u4e16\uff0c\u5b9e\u4f53\u95e8\u5e97\u7269\u6d41\u7684\u957f\u671f\u89c4\u5212\u8fd8\u6ca1\u6709\u7740\u843d\u3002\u6050\u6015\u8fc7\u4e0d\u4e86\u591a\u4e45\uff0c\u4f60\u53c8\u5f97\u9891\u7e41\u9020\u8bbf\u7269\u6d41\u90e8\u4e86\u3002",
              "expression": "\u63a5\u53d7",
              "description_length": 1
          }, {
              "id": 3384,
              "description": "\u4e0b\u5468\u4e00\u6211\u7ed9\u4f60\u56de\u590d\u3002",
              "options": [{
                  "id": 1,
                  "point": -1,
                  "description": "\u597d\u7684\uff0c\u90a3\u6211\u4e0d\u53e8\u6270\u4e86\uff0c\u6539\u5929\u8bf7\u4f60\u5403\u996d\u3002",
                  "short_description": null,
                  "addition": "",
                  "selected": false,
                  "ka": -1,
                  "nextQuestionId": 3390
              }, {
                  "id": 2,
                  "point": -1,
                  "description": "\u4f60\u7684\u652f\u6301\u5bf9\u6211\u4eec\u6765\u8bf4\u592a\u91cd\u8981\u4e86\uff0c\u76f8\u4fe1\u6211\u4eec\u7684\u52aa\u529b\u5f88\u5feb\u5c31\u80fd\u8ba9\u987e\u5ba2\u770b\u5230\u53d8\u5316\u3002",
                  "short_description": null,
                  "addition": "",
                  "selected": false,
                  "ka": -1,
                  "nextQuestionId": 3391
              }],
              "directorComment": "\u65f6\u95f4\u70b9\u786e\u8ba4\uff0c\u8bf7\u7ee7\u7eed\u3002",
              "expression": "\u6b63\u5e38",
              "description_length": 1
          }, {
              "id": 3385,
              "description": "\u6ca1\u95ee\u9898\uff0c\u6709\u95ee\u9898\u6211\u4eec\u968f\u65f6\u8054\u7cfb\uff01",
              "options": [],
              "directorComment": "\u3010\u4f60\u79bb\u5f00\u4e86\u529e\u516c\u5ba4\uff0c\u5fc3\u91cc\u7f8e\u6ecb\u6ecb\u3002\u3011\u770b\u4e0a\u53bb\uff0c\u4f60\u7684\u95ee\u9898\u90fd\u6709\u89e3\u51b3\u65b9\u6848\u4e86\u3002\u4e0d\u8fc7\u6ca1\u6709\u843d\u5b9e\u4e3a\u5177\u4f53\u884c\u52a8\uff0c\u518d\u597d\u7684\u65b9\u6848\u4e5f\u4e0d\u8fc7\u662f\u7a7a\u4e2d\u697c\u9601\u3002\u4e0b\u6b21\u8ba8\u8bba\uff0c\u522b\u518d\u8fd9\u6837\u529f\u4e8f\u4e00\u7bd1\u54af\u3002",
              "expression": "\u63a5\u53d7",
              "description_length": 1
          }, {
              "id": 3386,
              "description": "\u5bf9\u3002\u6211\u4eca\u5929\u5c31\u5e2e\u4f60\u627e\u4eba\uff0c\u4e0b\u73ed\u524d\u7ed9\u4f60\u56de\u590d\u3002",
              "options": [{
                  "id": 1,
                  "point": 4,
                  "description": "\u597d\uff0c\u8c22\u8c22\uff01\u53e6\u5916\u4e00\u4e2a\u5c31\u662f\u201c\u9650\u65f6\u9001\u5230\u5bb6\u201d\u7684\u670d\u52a1\u8bc4\u4f30\uff0c\u4e5f\u9700\u8981\u4e00\u4e2a\u65f6\u95f4\u70b9\u3002",
                  "short_description": null,
                  "addition": "",
                  "selected": false,
                  "ka": 6,
                  "nextQuestionId": 3392
              }, {
                  "id": 2,
                  "point": 9,
                  "description": "\u597d\u7684\u3002\u5230\u65f6\u5019\u6211\u4f1a\u8ba9\u5c0f\u8f76\u914d\u5408\u4f60\u4eec\u3002\u7b2c\u4e8c\u4e2a\u5c31\u662f\u201c\u9650\u65f6\u9001\u5230\u5bb6\u201d\u7684\u670d\u52a1\u8bc4\u4f30\uff0c\u4f60\u770b\u600e\u4e48\u5b89\u6392\uff1f",
                  "short_description": null,
                  "addition": "",
                  "selected": false,
                  "ka": 6,
                  "nextQuestionId": 3392
              }],
              "directorComment": "\u53c8\u4e00\u9879\u65b9\u6848\u843d\u5730\uff0c\u518d\u63a5\u518d\u5389\uff01",
              "expression": "\u6b63\u5e38",
              "description_length": 1
          }, {
              "id": 3387,
              "description": "\u7ed9\u6211\u4e24\u4e2a\u661f\u671f\uff0c\u7b2c\u4e09\u5468\u7684\u4e0a\u534a\u5468\uff0c\u6211\u4eec\u53ef\u4ee5\u7ea6\u4e2a\u4f1a\u8ba8\u8bba\u4e00\u4e0b\u3002",
              "options": [{
                  "id": 1,
                  "point": 3,
                  "description": "\u592a\u68d2\u4e86\uff01\u4f60\u7684\u652f\u6301\u5bf9\u6211\u4eec\u6765\u8bf4\u592a\u91cd\u8981\u4e86\u3002\u4eca\u5929\u8c08\u5f97\u5dee\u4e0d\u591a\u4e86\uff0c\u6211\u4e5f\u4e0d\u518d\u53e8\u6270\u4e86\u3002",
                  "short_description": null,
                  "addition": "",
                  "selected": false,
                  "ka": 4,
                  "nextQuestionId": 3393
              }, {
                  "id": 2,
                  "point": 6,
                  "description": "\u597d\u7684\u3002\u90a3\u5176\u4ed6\u4e24\u4e2a\u77ed\u671f\u65b9\u6848\uff0c\u5927\u6982\u662f\u4ec0\u4e48\u65f6\u95f4\u70b9\uff1f",
                  "short_description": null,
                  "addition": "",
                  "selected": false,
                  "ka": 6,
                  "nextQuestionId": 3394
              }],
              "directorComment": "\u4f1a\u8bae\u65f6\u95f4\u786e\u8ba4\u4e86\uff0c\u4e0b\u4e00\u6b65\u3002",
              "expression": "\u51b7\u6f20",
              "description_length": 1
          }, {
              "id": 3388,
              "description": "\u4e0b\u5468\u4e00\u6211\u628a\u8bc4\u4f30\u7ed3\u679c\u544a\u8bc9\u4f60\uff0c\u6211\u4eec\u5230\u65f6\u5019\u518d\u6572\u5b9a\u4e00\u4e0b\u65b9\u6848\u3002",
              "options": [],
              "directorComment": "\u3010\u4f60\u548c\u79e6\u98de\u544a\u8f9e\u3011\u71c3\u7709\u4e4b\u6025\u786e\u5b9e\u89e3\u51b3\u4e86\uff0c\u4f46\u8fd9\u4e9b\u65b9\u6848\u7ba1\u5f97\u4e86\u4e00\u65f6\uff0c\u7ba1\u4e0d\u4e86\u4e00\u4e16\uff0c\u5b9e\u4f53\u95e8\u5e97\u7269\u6d41\u7684\u957f\u671f\u89c4\u5212\u8fd8\u6ca1\u6709\u7740\u843d\u3002\u6050\u6015\u8fc7\u4e0d\u4e86\u591a\u4e45\uff0c\u4f60\u53c8\u5f97\u9891\u7e41\u9020\u8bbf\u7269\u6d41\u90e8\u4e86\u3002",
              "expression": "\u6b63\u5e38",
              "description_length": 1
          }, {
              "id": 3389,
              "description": "\u884c\uff0c\u6ca1\u95ee\u9898\u3002\u5230\u65f6\u5019\u518d\u7ea6\u3002",
              "options": [],
              "directorComment": "\u3010\u4f60\u79bb\u5f00\u4e86\u529e\u516c\u5ba4\u3011\u770b\u4e0a\u53bb\uff0c\u4f60\u7684\u95ee\u9898\u90fd\u6709\u89e3\u51b3\u65b9\u6848\u4e86\u3002\u4e0d\u8fc7\u6ca1\u6709\u843d\u5b9e\u4e3a\u5177\u4f53\u884c\u52a8\uff0c\u518d\u597d\u7684\u65b9\u6848\u4e5f\u4e0d\u8fc7\u662f\u7a7a\u4e2d\u697c\u9601\u3002\u4e0b\u6b21\u8ba8\u8bba\uff0c\u522b\u518d\u8fd9\u6837\u529f\u4e8f\u4e00\u7bd1\u54af\u3002",
              "expression": "\u63a5\u53d7",
              "description_length": 1
          }, {
              "id": 3390,
              "description": "\u5ba2\u6c14\u5ba2\u6c14\uff0c\u5e94\u8be5\u7684\u3002\u5927\u5bb6\u90fd\u662f\u4e3a\u4e86\u5de5\u4f5c\u561b\u3002",
              "options": [],
              "directorComment": "\u3010\u4f60\u79bb\u5f00\u4e86\u529e\u516c\u5ba4\u3011\u71c3\u7709\u4e4b\u6025\u786e\u5b9e\u89e3\u51b3\u4e86\uff0c\u4f46\u8fd9\u4e9b\u65b9\u6848\u7ba1\u5f97\u4e86\u4e00\u65f6\uff0c\u7ba1\u4e0d\u4e86\u4e00\u4e16\uff0c\u5b9e\u4f53\u95e8\u5e97\u7269\u6d41\u7684\u957f\u671f\u89c4\u5212\u8fd8\u6ca1\u6709\u7740\u843d\u3002\u6050\u6015\u8fc7\u4e0d\u4e86\u591a\u4e45\uff0c\u4f60\u53c8\u5f97\u9891\u7e41\u9020\u8bbf\u7269\u6d41\u90e8\u4e86\u3002",
              "expression": "\u63a5\u53d7",
              "description_length": 1
          }, {
              "id": 3391,
              "description": "\u5ba2\u6c14\u4e86\u3002\u5927\u5bb6\u90fd\u662f\u4e00\u5bb6\u516c\u53f8\u7684\uff0c\u5c31\u662f\u8981\u4e92\u76f8\u652f\u6301\u7684\u561b\u3002",
              "options": [],
              "directorComment": "\u3010\u4f60\u79bb\u5f00\u4e86\u529e\u516c\u5ba4\u3011\u71c3\u7709\u4e4b\u6025\u786e\u5b9e\u89e3\u51b3\u4e86\uff0c\u4f46\u8fd9\u4e9b\u65b9\u6848\u7ba1\u5f97\u4e86\u4e00\u65f6\uff0c\u7ba1\u4e0d\u4e86\u4e00\u4e16\uff0c\u5b9e\u4f53\u95e8\u5e97\u7269\u6d41\u7684\u957f\u671f\u89c4\u5212\u8fd8\u6ca1\u6709\u7740\u843d\u3002\u6050\u6015\u8fc7\u4e0d\u4e86\u591a\u4e45\uff0c\u4f60\u53c8\u5f97\u9891\u7e41\u9020\u8bbf\u7269\u6d41\u90e8\u4e86\u3002",
              "expression": "\u63a5\u53d7",
              "description_length": 1
          }, {
              "id": 3392,
              "description": "\u6211\u4e0b\u5468\u4e00\u7ed9\u4f60\u56de\u590d\u3002",
              "options": [{
                  "id": 1,
                  "point": -1,
                  "description": "\u884c\uff0c\u6211\u7b49\u4f60\u7684\u6d88\u606f\uff01\u73b0\u5728\u771f\u7684\u662f\u4e0d\u65e9\u4e86\u3002\u8001\u79e6\uff0c\u4eca\u5929\u8c22\u8c22\u4e86\uff01",
                  "short_description": null,
                  "addition": "",
                  "selected": false,
                  "ka": -1,
                  "nextQuestionId": 3395
              }, {
                  "id": 2,
                  "point": 9,
                  "description": "\u597d\u3002\u6700\u540e\u5c31\u662f\u957f\u671f\u7269\u6d41\u89c4\u5212\u4e86\u3002\u4f60\u770b\u6211\u4eec\u8be5\u600e\u4e48\u8fdb\u884c\uff1f",
                  "short_description": null,
                  "addition": "",
                  "selected": false,
                  "ka": 6,
                  "nextQuestionId": 3396
              }, {
                  "id": 3,
                  "point": 3,
                  "description": "\u7136\u540e\u5c31\u662f\u6700\u91cd\u8981\u7684\u957f\u671f\u7269\u6d41\u89c4\u5212\u4e86\u3002\u6211\u5efa\u8bae\u5206\u51e0\u4e2a\u9636\u6bb5\u8fdb\u884c\uff1a\u3010\u7ed9\u51fa\u65f6\u95f4\u8868\u2026\u2026\u3011",
                  "short_description": null,
                  "addition": "",
                  "selected": false,
                  "ka": 6,
                  "nextQuestionId": 3397
              }],
              "directorComment": "\u53c8\u4e00\u9879\u884c\u52a8\u843d\u5730\uff0c\u606d\u559c\uff01",
              "expression": "\u6b63\u5e38",
              "description_length": 1
          }, {
              "id": 3393,
              "description": "\u54ea\u91cc\u54ea\u91cc\uff0c\u90fd\u662f\u5206\u5185\u4e8b\u3002\u4ee5\u540e\u6709\u95ee\u9898\uff0c\u968f\u65f6\u8054\u7edc\u3002",
              "options": [],
              "directorComment": "\u3010\u8c08\u8bdd\u7ed3\u675f\u3011\u957f\u671f\u89c4\u5212\u804a\u5f97\u4e0d\u4ea6\u4e50\u4e4e\uff0c\u4f46\u662f\u77ed\u671f\u65b9\u6848\u7684\u884c\u52a8\u8ba1\u5212\u5374\u6ca1\u6709\u843d\u5b9e\u3002\u6050\u6015\u987e\u5ba2\u7684\u62b1\u6028\u4f60\u8fd8\u5f97\u518d\u542c\u4e00\u9635\u5b50\u4e86\u3002",
              "expression": "\u63a5\u53d7",
              "description_length": 1
          }, {
              "id": 3394,
              "description": "\u7b2c\u4e00\u4e2a\u627e\u4e13\u4eba\u8d1f\u8d23\uff0c\u6211\u4eca\u5929\u4e0b\u73ed\u73ed\u524d\u5c31\u80fd\u7ed9\u4f60\u56de\u590d\uff1b\u670d\u52a1\u8bc4\u4f30\u4e48\uff0c\u5514\uff0c\u4e0b\u5468\u4e00\u5427\u3002",
              "options": [{
                  "id": 1,
                  "point": -1,
                  "description": "\u884c\u3002\u8001\u79e6\uff0c\u4eca\u5929\u771f\u662f\u592a\u8c22\u8c22\u4e86\u3002\u6211\u60ac\u4e86\u8fd9\u4e48\u591a\u5929\u7684\u5fc3\u603b\u7b97\u653e\u4e0b\u4e86\u3002\u6539\u5929\u4e00\u5b9a\u8981\u8bf7\u4f60\u5403\u996d\u3002",
                  "short_description": null,
                  "addition": "",
                  "selected": false,
                  "ka": -1,
                  "nextQuestionId": 3398
              }, {
                  "id": 2,
                  "point": 1,
                  "description": "\u597d\u7684\uff0c\u8c22\u8c22\u4f60\u4eec\u56e2\u961f\uff0c\u53c8\u5e2e\u4e86\u6211\u4eec\u5927\u5fd9\u4e86\u3002\u76f8\u4fe1\u6709\u4e86\u4f60\u4eec\u7684\u5e2e\u52a9\uff0c\u6211\u4eec\u4e00\u5b9a\u80fd\u5f88\u5feb\u770b\u5230\u6210\u6548\u3002",
                  "short_description": null,
                  "addition": "",
                  "selected": false,
                  "ka": 4,
                  "nextQuestionId": 3399
              }],
              "directorComment": "\u65f6\u95f4\u70b9\u660e\u786e\uff0c\u9f13\u638c\uff01",
              "expression": "\u63a5\u53d7",
              "description_length": 1
          }, {
              "id": 3395,
              "description": "\u4e0d\u7528\u5ba2\u6c14\uff0c\u90fd\u662f\u540c\u4e8b\u561b\uff0c\u4e92\u76f8\u652f\u6301\u662f\u5e94\u8be5\u7684\u3002",
              "options": [],
              "directorComment": "\u3010\u4f60\u79bb\u5f00\u4e86\u529e\u516c\u5ba4\u3011\u71c3\u7709\u4e4b\u6025\u786e\u5b9e\u89e3\u51b3\u4e86\uff0c\u4f46\u8fd9\u4e9b\u65b9\u6848\u7ba1\u5f97\u4e86\u4e00\u65f6\uff0c\u7ba1\u4e0d\u4e86\u4e00\u4e16\uff0c\u5b9e\u4f53\u95e8\u5e97\u7269\u6d41\u7684\u957f\u671f\u89c4\u5212\u8fd8\u6ca1\u6709\u7740\u843d\u3002\u6050\u6015\u8fc7\u4e0d\u4e86\u591a\u4e45\uff0c\u4f60\u53c8\u5f97\u9891\u7e41\u9020\u8bbf\u7269\u6d41\u90e8\u4e86\u3002",
              "expression": "\u63a5\u53d7",
              "description_length": 1
          }, {
              "id": 3396,
              "description": "\u6211\u4eec\u4e00\u822c\u9700\u8981\u8fd9\u51e0\u4e2a\u6b65\u9aa4\uff1a\u3010\u884c\u52a8\u8ba1\u5212\u5236\u5b9a\u4e2d\u2026\u2026\u3011",
              "options": [{
                  "id": 1,
                  "point": -1,
                  "description": "\u884c\uff0c\u542c\u4f60\u7684\u3002\u603b\u7b97\u628a\u95ee\u9898\u90fd\u8c08\u5b8c\u4e86\uff0c\u4eca\u5929\u8c22\u8c22\u4e86\uff01\u6539\u5929\u8bf7\u4f60\u5403\u996d\uff01",
                  "short_description": null,
                  "addition": "",
                  "selected": false,
                  "ka": -1,
                  "nextQuestionId": 3400
              }, {
                  "id": 2,
                  "point": 9,
                  "description": "\u597d\u7684\u3002\u4f60\u7684\u652f\u6301\u5bf9\u6211\u4eec\u6765\u8bf4\u592a\u91cd\u8981\u4e86\uff0c\u4eca\u5929\u771f\u662f\u8c22\u8c22\u4e86\u3002\u76f8\u4fe1\u6211\u4eec\u7684\u52aa\u529b\u5f88\u5feb\u5c31\u80fd\u8ba9\u987e\u5ba2\u770b\u5230\u53d8\u5316\u3002",
                  "short_description": null,
                  "addition": "",
                  "selected": false,
                  "ka": 4,
                  "nextQuestionId": 3401
              }],
              "directorComment": "\u957f\u671f\u89c4\u5212\u4e5f\u6709\u7709\u76ee\u4e86\uff0c\u884c\u52a8\u8ba1\u5212\u90fd\u8c08\u59a5\u4e86\uff0c\u8c08\u8bdd\u4e5f\u8fdb\u5165\u4e86\u5c3e\u58f0\uff0c\u6765\u4e2a\u6f02\u4eae\u7684\u6536\u5b98\u600e\u4e48\u6837\uff1f",
              "expression": "\u63a5\u53d7",
              "description_length": 1
          }, {
              "id": 3397,
              "description": "\u5443\u2026\u2026\u6211\u4eec\u4e00\u822c\u4e0d\u8fd9\u4e48\u505a\uff0c\u8fd9\u4e2a\u6211\u6765\u5b89\u6392\u5c31\u597d\u3002",
              "options": [{
                  "id": 1,
                  "point": -1,
                  "description": "\u884c\uff0c\u542c\u4f60\u7684\u3002\u603b\u7b97\u628a\u95ee\u9898\u90fd\u8c08\u5b8c\u4e86\uff0c\u4eca\u5929\u8c22\u8c22\u4e86\uff01\u6539\u5929\u8bf7\u4f60\u5403\u996d\uff01",
                  "short_description": null,
                  "addition": "",
                  "selected": false,
                  "ka": -1,
                  "nextQuestionId": 3400
              }, {
                  "id": 2,
                  "point": 9,
                  "description": "\u597d\u7684\u3002\u4f60\u7684\u652f\u6301\u5bf9\u6211\u4eec\u6765\u8bf4\u592a\u91cd\u8981\u4e86\uff0c\u4eca\u5929\u771f\u662f\u8c22\u8c22\u4e86\u3002\u76f8\u4fe1\u6211\u4eec\u7684\u52aa\u529b\u5f88\u5feb\u5c31\u80fd\u8ba9\u987e\u5ba2\u770b\u5230\u53d8\u5316\u3002",
                  "short_description": null,
                  "addition": "",
                  "selected": false,
                  "ka": 4,
                  "nextQuestionId": 3401
              }],
              "directorComment": "\u5728\u5236\u5b9a\u884c\u52a8\u8ba1\u5212\u65f6\uff0c\u4e0d\u59a8\u5148\u8be2\u95ee\u518d\u5206\u4eab\uff0c\u907f\u514d\u8c08\u4e0d\u62e2\u7684\u5c34\u5c2c\u3002",
              "expression": "\u6297\u62d2",
              "description_length": 1
          }, {
              "id": 3398,
              "description": "\u54ea\u91cc\u54ea\u91cc\uff0c\u90fd\u662f\u5206\u5185\u4e8b\u3002\u4ee5\u540e\u6709\u95ee\u9898\uff0c\u968f\u65f6\u8054\u7edc\u3002",
              "options": [],
              "directorComment": "\u6109\u5feb\u7ed3\u675f\u8c08\u8bdd\u3002\u5982\u679c\u5728\u7ed9\u5bf9\u65b9\u63d0\u4f9b\u652f\u6301\u7684\u65f6\u5019\uff0c\u9664\u4e86\u201c\u77e5\u65e0\u4e0d\u8a00\uff0c\u8a00\u65e0\u4e0d\u5c3d\u201d\u4e4b\u5916\uff0c\u8fd8\u6709\u5177\u4f53\u7684\u884c\u52a8\u548c\u8d44\u6e90\u652f\u6301\uff0c\u90a3\u5c31\u66f4\u5b8c\u7f8e\u5566\uff01",
              "expression": "\u63a5\u53d7",
              "description_length": 1
          }, {
              "id": 3399,
              "description": "\u5e94\u8be5\u7684\u3002\u4eca\u5929\u6211\u4e5f\u6709\u4e86\u4e0d\u5c11\u6536\u83b7\u3002\u4ee5\u540e\u6211\u4eec\u4fdd\u6301\u6c9f\u901a\uff0c\u6709\u95ee\u9898\u591a\u591a\u4ea4\u6d41\u3002",
              "options": [],
              "directorComment": "\u6109\u5feb\u7ed3\u675f\u8c08\u8bdd\u3002\u5982\u679c\u5728\u7ed9\u5bf9\u65b9\u63d0\u4f9b\u652f\u6301\u7684\u65f6\u5019\uff0c\u9664\u4e86\u201c\u77e5\u65e0\u4e0d\u8a00\uff0c\u8a00\u65e0\u4e0d\u5c3d\u201d\u4e4b\u5916\uff0c\u8fd8\u6709\u5177\u4f53\u7684\u884c\u52a8\u548c\u8d44\u6e90\u652f\u6301\uff0c\u90a3\u5c31\u66f4\u5b8c\u7f8e\u5566\uff01",
              "expression": "\u63a5\u53d7",
              "description_length": 1
          }, {
              "id": 3400,
              "description": "\u5e94\u8be5\u7684\u3001\u5e94\u8be5\u7684\u3002\u4eca\u5929\u6211\u4e5f\u6709\u4e86\u4e0d\u5c11\u6536\u83b7\u3002\u6211\u4eec\u4fdd\u6301\u8054\u7cfb\u3002",
              "options": [],
              "directorComment": "\u6109\u5feb\u7ed3\u675f\u8c08\u8bdd\u3002\u5982\u679c\u80fd\u9002\u65f6\u8868\u8fbe\u5bf9\u65b9\u652f\u6301\u7684\u91cd\u8981\u6027\u4ee5\u53ca\u8fd9\u4e9b\u884c\u52a8\u80fd\u5e26\u6765\u7684\u6539\u53d8\uff0c\u6548\u679c\u66f4\u4f73\uff01",
              "expression": "\u63a5\u53d7",
              "description_length": 1
          }, {
              "id": 3401,
              "description": "\u5e94\u8be5\u7684\u3002\u4eca\u5929\u6211\u4e5f\u6709\u4e86\u4e0d\u5c11\u6536\u83b7\u3002\u4ee5\u540e\u6211\u4eec\u4fdd\u6301\u6c9f\u901a\uff0c\u6709\u95ee\u9898\u591a\u591a\u4ea4\u6d41\u3002",
              "options": [],
              "directorComment": "\u51fa\u8272\u8868\u73b0\u8fce\u6765\u5b8c\u7f8e\u6536\u5b98\uff01\u65e0\u8bba\u662f\u77ed\u671f\u65b9\u6848\uff0c\u8fd8\u662f\u957f\u671f\u89c4\u5212\uff0c\u4f60\u90fd\u8ddf\u5bf9\u65b9\u660e\u786e\u4e86\u5177\u4f53\u884c\u52a8\u8ba1\u5212\u3002\u8ba9\u6211\u4eec\u4e00\u8d77\u671f\u5f85\u5b9e\u4f53\u5e97\u7684\u559c\u4eba\u53d8\u5316\uff01",
              "expression": "\u63a5\u53d7",
              "description_length": 1
          }, {
              "id": 3402,
              "description": "\u8fd9\u70b9\u4f60\u653e\u5fc3\uff0c\u4f60\u4eec\u51b2\u950b\u9677\u9635\u62fc\u4e1a\u7ee9\uff0c\u6211\u4eec\u4e00\u5b9a\u505a\u597d\u652f\u6301\u5de5\u4f5c\u3002\u7b49\u6211\u8fd9\u9635\u5b50\u5fd9\u5b8c\u4e86\uff0c\u5c31\u6765\u770b\u600e\u4e48\u89e3\u51b3\u3002",
              "options": [{
                  "id": 1,
                  "point": -1,
                  "description": "\u5509\uff0c\u4f60\u770b\u5b9e\u4f53\u5e97\u7684\u6307\u6807\u538b\u529b\u8fd9\u4e48\u5927\u3002\u518d\u62d6\u4e0b\u53bb\uff0c\u4e0b\u534a\u5e74\u7684\u4e1a\u7ee9\u5c31\u6ca1\u6307\u671b\u4e86\u3002\u8001\u79e6\uff0c\u5356\u6211\u4e2a\u9762\u5b50\uff0c\u60f3\u60f3\u600e\u4e48\u641e\u5b9a\u3002",
                  "short_description": null,
                  "addition": "",
                  "selected": false,
                  "ka": -1,
                  "nextQuestionId": 3404
              }, {
                  "id": 2,
                  "point": 3,
                  "description": "\u8001\u79e6\uff0c\u4f60\u770b\u4e00\u4e0b\u8fd9\u5f20\u8868\uff0c\u5f53\u7f3a\u8d27\u91cf\u8d70\u9ad8\u65f6\uff0c\u5ba2\u6237\u5dee\u8bc4\u660e\u663e\u6301\u7eed\u589e\u591a\u3002\u8fd9\u5df2\u7ecf\u4e0d\u662f\u4e2a\u6848\u4e86\u3002",
                  "short_description": null,
                  "addition": "",
                  "selected": false,
                  "ka": 2,
                  "nextQuestionId": 3405
              }, {
                  "id": 3,
                  "point": -1,
                  "description": "\u4e2a\u522b\u95ee\u9898\u4e5f\u4e0d\u80fd\u5ffd\u89c6\u554a\uff01\u201c\u5ba2\u8bc9\u65e0\u5c0f\u4e8b\u201d\uff0c\u4e00\u4e2a\u987e\u5ba2\u7684\u62b1\u6028\u5f88\u6709\u53ef\u80fd\u5bf9\u516c\u53f8\u5f62\u8c61\u9020\u6210\u5f71\u54cd\u3002",
                  "short_description": null,
                  "addition": "",
                  "selected": false,
                  "ka": -1,
                  "nextQuestionId": 3406
              }],
              "directorComment": "\u5bf9\u65b9\u5f00\u51fa\u4e00\u5f20\u534e\u4e3d\u4e3d\u7684\u201c\u957f\u671f\u652f\u7968\u201d\uff0c\u600e\u4e48\u63a5\u62db\uff1f",
              "expression": "\u63a5\u53d7",
              "description_length": 1
          }, {
              "id": 3403,
              "description": "\u5514\uff0c\u662f\u633a\u5934\u75bc\u7684\u3002\u4f46\u6211\u4e5f\u8ddf\u4f60\u638f\u5fc3\u638f\u80ba\u8bf4\u4e00\u53e5\uff0c\u867d\u7136\u4f60\u4eec\u7684\u6f5c\u529b\u5f88\u5927\uff0c\u4f46\u662f\u76ee\u524d\u91cd\u70b9\u4e1a\u52a1\u8fd8\u662f\u5728\u7ebf\u4e0a\u3002\u6211\u4eec\u603b\u4e0d\u80fd\u4e3a\u4e86\u89e3\u51b3\u5b9e\u4f53\u5e97\u7684\u4e2a\u522b\u95ee\u9898\uff0c\u5f71\u54cd\u516c\u53f8\u6574\u4f53\u7684\u7269\u6d41\u89c4\u5212\u5427\uff1f\u4f60\u653e\u4e00\u767e\u4e8c\u5341\u4e2a\u5fc3\uff0c\u7b49\u6211\u5fd9\u5b8c\u8fd9\u4e00\u9635\uff0c\u4e00\u5b9a\u60f3\u529e\u6cd5\u5e2e\u4f60\u4eec\u89e3\u51b3\uff0c\u597d\u4e0d\u597d\uff1f ",
              "options": [{
                  "id": 1,
                  "point": -1,
                  "description": "\u5b9e\u4f53\u5e97\u7684\u6307\u6807\u538b\u529b\u4e5f\u5f88\u5927\u3002\u518d\u8fd9\u4e48\u62d6\u4e0b\u53bb\uff0c\u4e0b\u534a\u5e74\u7684\u4e1a\u7ee9\u5c31\u6ca1\u6307\u671b\u4e86\u3002\u8001\u79e6\uff0c\u5356\u6211\u4e2a\u9762\u5b50\uff0c\u5e2e\u5e2e\u6211\u4eec\u5427\u3002",
                  "short_description": null,
                  "addition": "",
                  "selected": false,
                  "ka": -1,
                  "nextQuestionId": 3322
              }, {
                  "id": 2,
                  "point": 9,
                  "description": "\u8001\u79e6\uff0c\u4f60\u770b\u4e00\u4e0b\u8fd9\u5f20\u8868\uff0c\u5f53\u7f3a\u8d27\u91cf\u8d70\u9ad8\u65f6\uff0c\u5ba2\u6237\u5dee\u8bc4\u660e\u663e\u6301\u7eed\u589e\u591a\u3002\u8fd9\u5df2\u7ecf\u4e0d\u662f\u4e2a\u6848\u4e86\u3002",
                  "short_description": null,
                  "addition": "",
                  "selected": false,
                  "ka": 2,
                  "nextQuestionId": 3323
              }, {
                  "id": 3,
                  "point": -1,
                  "description": "\u4e2a\u522b\u95ee\u9898\u4e5f\u4e0d\u80fd\u5ffd\u89c6\u554a\uff01\u201c\u5ba2\u8bc9\u65e0\u5c0f\u4e8b\u201d\uff0c\u4e00\u4e2a\u987e\u5ba2\u7684\u62b1\u6028\u5f88\u6709\u53ef\u80fd\u5bf9\u54c1\u724c\u9020\u6210\u5f71\u54cd\u3002",
                  "short_description": null,
                  "addition": "",
                  "selected": false,
                  "ka": -1,
                  "nextQuestionId": 3324
              }],
              "directorComment": "\u4eb2\u8eab\u611f\u53d7\u4e86\u6765\u81ea\u987e\u5ba2\u7684\u53cd\u9988\uff0c\u5bf9\u65b9\u7ec8\u4e8e\u5f00\u59cb\u91cd\u89c6\u4f60\u7684\u95ee\u9898\u4e86\u3002\u4e0d\u8fc7\u4ed6\u4f3c\u4e4e\u4ecd\u6ca1\u6709\u610f\u8bc6\u5230\u95ee\u9898\u7684\u7d27\u8feb\u6027\uff0c\u8bf7\u7ee7\u7eed\u52aa\u529b\uff01",
              "expression": "\u51b7\u6f20",
              "description_length": 1
          }, {
              "id": 3404,
              "description": "\u4f60\u8fd9\u4e48\u8bf4\uff0c\u53ef\u592a\u4e3a\u96be\u6211\u4e86\u3002",
              "options": [{
                  "id": 1,
                  "point": -1,
                  "description": "\u4f60\u653e\u5fc3\uff0c\u95ee\u9898\u89e3\u51b3\u80af\u5b9a\u4e0d\u662f\u7269\u6d41\u4e00\u4e2a\u90e8\u95e8\u7684\u4e8b\u60c5\u3002\u6211\u4eec\u4e00\u5b9a\u4f1a\u5168\u529b\u914d\u5408\u4f60\u4eec\u3002",
                  "short_description": null,
                  "addition": "",
                  "selected": false,
                  "ka": -1,
                  "nextQuestionId": 3325
              }, {
                  "id": 2,
                  "point": 1,
                  "description": "\u6709\u96be\u5904\uff0c\u6211\u4eec\u5c31\u914d\u5408\u4f60\u4eec\u89e3\u51b3\u561b\u3002\u4f60\u89c9\u5f97\u4f1a\u9700\u8981\u4ec0\u4e48\u6837\u7684\u8d44\u6e90\u652f\u6301\uff1f",
                  "short_description": null,
                  "addition": "",
                  "selected": false,
                  "ka": 3,
                  "nextQuestionId": 3325
              }, {
                  "id": 3,
                  "point": 9,
                  "description": "\u6211\u611f\u89c9\u65f6\u95f4\u548c\u4eba\u624b\u662f\u73b0\u5728\u6700\u5927\u7684\u96be\u70b9\u3002\u9664\u6b64\u4e4b\u5916\uff0c\u4f60\u4eec\u8fd8\u4f1a\u6709\u5176\u4ed6\u7684\u56f0\u6270\u5417\uff1f",
                  "short_description": null,
                  "addition": "",
                  "selected": false,
                  "ka": 3,
                  "nextQuestionId": 3326
              }],
              "directorComment": "\u201c\u5356\u9762\u5b50\u201d\u53ef\u4e0d\u662f\u8d62\u5f97\u627f\u8bfa\u7684\u552f\u4e00\u62db\u6570\uff0c\u60f3\u60f3\u6240\u5b66\u7684\u4e03\u5927\u7b56\u7565\u3001\u4e09\u79cd\u5305\u88c5\uff0c\u6709\u6ca1\u6709\u66f4\u597d\u7684\u5999\u62db\u6765\u5f71\u54cd\u5bf9\u65b9\uff1f",
              "expression": "\u4e3a\u96be",
              "description_length": 1
          }, {
              "id": 3405,
              "description": "\u3010\u76b1\u7709\u3011\u5e72\u6211\u4eec\u8fd9\u4e00\u884c\u7684\uff0c\u771f\u662f\u201c\u505a\u5f97\u597d\uff0c\u6ca1\u4eba\u5938\uff1b\u6709\u95ee\u9898\uff0c\u4e00\u5806\u9a82\u201d\u3002\u5509\uff0c\u771f\u662f\u7684\uff01\u600e\u4e48\u4e8b\u60c5\u90fd\u51d1\u5728\u4e00\u8d77\u4e86\u3002",
              "options": [{
                  "id": 1,
                  "point": -1,
                  "description": "\u4f60\u653e\u5fc3\uff0c\u95ee\u9898\u89e3\u51b3\u80af\u5b9a\u4e0d\u662f\u7269\u6d41\u4e00\u4e2a\u90e8\u95e8\u7684\u4e8b\u60c5\u3002\u6211\u4eec\u4e00\u5b9a\u4f1a\u5168\u529b\u914d\u5408\u4f60\u4eec\u3002",
                  "short_description": null,
                  "addition": "",
                  "selected": false,
                  "ka": -1,
                  "nextQuestionId": 3325
              }, {
                  "id": 2,
                  "point": 1,
                  "description": "\u6709\u96be\u5904\uff0c\u6211\u4eec\u5c31\u914d\u5408\u4f60\u4eec\u89e3\u51b3\u561b\u3002\u4f60\u89c9\u5f97\u4f1a\u9700\u8981\u4ec0\u4e48\u6837\u7684\u8d44\u6e90\u652f\u6301\uff1f",
                  "short_description": null,
                  "addition": "",
                  "selected": false,
                  "ka": 3,
                  "nextQuestionId": 3325
              }, {
                  "id": 3,
                  "point": 9,
                  "description": "\u6211\u611f\u89c9\u65f6\u95f4\u548c\u4eba\u624b\u662f\u73b0\u5728\u6700\u5927\u7684\u96be\u70b9\u3002\u9664\u6b64\u4e4b\u5916\uff0c\u4f60\u4eec\u8fd8\u4f1a\u6709\u5176\u4ed6\u7684\u56f0\u6270\u5417\uff1f",
                  "short_description": null,
                  "addition": "",
                  "selected": false,
                  "ka": 3,
                  "nextQuestionId": 3326
              }],
              "directorComment": "\u6709\u7406\u6709\u636e\uff0c\u6210\u529f\u5f15\u8d77\u5bf9\u65b9\u6ce8\u610f\uff01",
              "expression": "\u6297\u62d2",
              "description_length": 1
          }, {
              "id": 3406,
              "description": "\u4f60\u8bf4\u7684\u662f\u6ca1\u9519\uff0c\u8c01\u4e0d\u60f3\u628a\u91d1\u4e3b\u90fd\u4f3a\u5019\u597d\u5462\uff1f\u4f46\u4eba\u624b\u4e0d\u8db3\uff0c\u8d44\u6e90\u6709\u9650\uff0c\u6211\u4eec\u603b\u5f97\u987e\u5168\u5927\u5c40\uff0c\u4f60\u7406\u89e3\u5427\uff1f",
              "options": [{
                  "id": 1,
                  "point": -1,
                  "description": "\u4f60\u653e\u5fc3\uff0c\u95ee\u9898\u89e3\u51b3\u80af\u5b9a\u4e0d\u662f\u7269\u6d41\u4e00\u4e2a\u90e8\u95e8\u7684\u4e8b\u60c5\u3002\u6211\u4eec\u4e00\u5b9a\u4f1a\u5168\u529b\u914d\u5408\u4f60\u4eec\u3002",
                  "short_description": null,
                  "addition": "",
                  "selected": false,
                  "ka": -1,
                  "nextQuestionId": 3325
              }, {
                  "id": 2,
                  "point": 1,
                  "description": "\u6709\u96be\u5904\uff0c\u6211\u4eec\u5c31\u914d\u5408\u4f60\u4eec\u89e3\u51b3\u561b\u3002\u4f60\u89c9\u5f97\u4f1a\u9700\u8981\u4ec0\u4e48\u6837\u7684\u8d44\u6e90\u652f\u6301\uff1f",
                  "short_description": null,
                  "addition": "",
                  "selected": false,
                  "ka": 3,
                  "nextQuestionId": 3325
              }, {
                  "id": 3,
                  "point": 9,
                  "description": "\u6211\u611f\u89c9\u65f6\u95f4\u548c\u4eba\u624b\u662f\u73b0\u5728\u6700\u5927\u7684\u96be\u70b9\u3002\u9664\u6b64\u4e4b\u5916\uff0c\u4f60\u4eec\u8fd8\u4f1a\u6709\u5176\u4ed6\u7684\u56f0\u6270\u5417\uff1f",
                  "short_description": null,
                  "addition": "",
                  "selected": false,
                  "ka": 3,
                  "nextQuestionId": 3326
              }],
              "directorComment": "\u5bf9\u65b9\u7684\u89c2\u70b9\u4f3c\u4e4e\u4e5f\u5728\u7406\uff0c\u5e94\u8be5\u5982\u4f55\u5f71\u54cd\u5bf9\u65b9\u5462\uff1f\u60f3\u60f3\u6240\u5b66\u7684\u4e03\u5927\u7b56\u7565\u3001\u4e09\u79cd\u5305\u88c5\uff0c\u603b\u6709\u4e00\u6b3e\u9002\u5408\u4f60\u3002",
              "expression": "\u6297\u62d2",
              "description_length": 1
          }, {
              "id": 3407,
              "description": "\u54ea\u91cc\u54ea\u91cc\uff0c\u6709\u95ee\u9898\u968f\u65f6\u8054\u7cfb\u3002",
              "options": [],
              "directorComment": "\u3010\u4f60\u79bb\u5f00\u4e86\u529e\u516c\u5ba4\u3011\u770b\u4e0a\u53bb\uff0c\u4f60\u7684\u95ee\u9898\u90fd\u6709\u89e3\u51b3\u65b9\u6848\u4e86\u3002\u4e0d\u8fc7\u6ca1\u6709\u843d\u5b9e\u4e3a\u5177\u4f53\u884c\u52a8\uff0c\u518d\u597d\u7684\u65b9\u6848\u4e5f\u4e0d\u8fc7\u662f\u7a7a\u4e2d\u697c\u9601\u3002\u4e0b\u6b21\u8ba8\u8bba\uff0c\u522b\u518d\u8fd9\u6837\u529f\u4e8f\u4e00\u7bd1\u54af\u3002",
              "expression": "\u63a5\u53d7",
              "description_length": 1
          }, {
              "id": 3408,
              "description": "\u5bf9\u3002\u6211\u4eca\u5929\u5c31\u5e2e\u4f60\u627e\u4eba\uff0c\u4e0b\u73ed\u524d\u7ed9\u4f60\u56de\u590d\u3002",
              "options": [{
                  "id": 1,
                  "point": 1,
                  "description": "\u597d\uff0c\u8c22\u8c22\uff01\u53e6\u5916\u4e00\u4e2a\u5c31\u662f\u201c\u9650\u65f6\u9001\u5230\u5bb6\u201d\u7684\u670d\u52a1\u8bc4\u4f30\uff0c\u4e5f\u9700\u8981\u4e00\u4e2a\u65f6\u95f4\u70b9\u3002",
                  "short_description": null,
                  "addition": "",
                  "selected": false,
                  "ka": 6,
                  "nextQuestionId": 3409
              }, {
                  "id": 2,
                  "point": 4,
                  "description": "\u597d\u7684\u3002\u5230\u65f6\u5019\u6211\u4f1a\u8ba9\u5c0f\u8f76\u914d\u5408\u4f60\u4eec\u3002\u7b2c\u4e8c\u4e2a\u5c31\u662f\u201c\u9650\u65f6\u9001\u5230\u5bb6\u201d\u7684\u670d\u52a1\u8bc4\u4f30\uff0c\u4f60\u770b\u600e\u4e48\u5b89\u6392\uff1f",
                  "short_description": null,
                  "addition": "",
                  "selected": false,
                  "ka": 6,
                  "nextQuestionId": 3409
              }],
              "directorComment": "\u5546\u54c1\u8865\u7ed9\u6709\u8ba1\u5212\u4e86\uff0c\u63a5\u7740\u5462\uff1f",
              "expression": "\u6b63\u5e38",
              "description_length": 1
          }, {
              "id": 3409,
              "description": "\u6211\u4e0b\u5468\u4e00\u7ed9\u4f60\u56de\u590d\u3002",
              "options": [{
                  "id": 1,
                  "point": -1,
                  "description": "\u884c\uff0c\u6211\u7b49\u4f60\u7684\u6d88\u606f\uff01\u73b0\u5728\u771f\u7684\u662f\u4e0d\u65e9\u4e86\u3002\u8001\u79e6\uff0c\u4eca\u5929\u8c22\u8c22\u4e86\uff01",
                  "short_description": null,
                  "addition": "",
                  "selected": false,
                  "ka": -1,
                  "nextQuestionId": 3410
              }, {
                  "id": 2,
                  "point": 1,
                  "description": "\u7269\u6d41\u95ee\u9898\u7684\u89e3\u51b3\u4f1a\u8bae\uff0c\u6211\u6253\u7b97\u4e24\u3001\u4e09\u4e2a\u661f\u671f\u5185\u5f00\u3002\u4f60\u89c9\u5f97\u53ef\u4ee5\u5417\uff1f",
                  "short_description": null,
                  "addition": "",
                  "selected": false,
                  "ka": 6,
                  "nextQuestionId": 3411
              }, {
                  "id": 3,
                  "point": 1,
                  "description": "\u81f3\u4e8e\u7269\u6d41\u7684\u957f\u671f\u65b9\u6848\uff0c\u4e24\u3001\u4e09\u4e2a\u661f\u671f\u5185\u6211\u4f1a\u7ea6\u5927\u5bb6\u5f00\u4f1a\u3002\u5728\u90a3\u4e4b\u524d\uff0c\u4f60\u89c9\u5f97\u6211\u4eec\u8981\u505a\u70b9\u51c6\u5907\u5de5\u4f5c\u5417\uff1f",
                  "short_description": null,
                  "addition": "",
                  "selected": false,
                  "ka": 6,
                  "nextQuestionId": 3412
              }],
              "directorComment": "\u53c8\u843d\u5b9e\u4e00\u9879\u4efb\u52a1\uff0c\u8bf7\u7ee7\u7eed\u3002",
              "expression": "\u6b63\u5e38",
              "description_length": 1
          }, {
              "id": 3410,
              "description": "\u4e0d\u7528\u5ba2\u6c14\uff0c\u90fd\u662f\u540c\u4e8b\u561b\uff0c\u4e92\u76f8\u652f\u6301\u662f\u5e94\u8be5\u7684\u3002",
              "options": [],
              "directorComment": "\u3010\u8c08\u8bdd\u7ed3\u675f\u3011\u77ed\u671f\u65b9\u6848\u5c18\u57c3\u843d\u5b9a\uff01\u4f46\u5728\u8ba8\u8bba\u957f\u671f\u89c4\u5212\u65f6\uff0c\u5750\u7b49\u4e0d\u77e5\u4f55\u65f6\u53ec\u5f00\u7684\u4f1a\u8bae\u5e76\u4e0d\u662f\u5f88\u597d\u7684\u505a\u6cd5\u3002\u8fdb\u5165\u201c\u5173\u952e\u884c\u52a8\u89e3\u6790\u201d\uff0c\u770b\u770b\u6709\u6ca1\u6709\u65b0\u7684\u542f\u53d1\u3002",
              "expression": "\u63a5\u53d7",
              "description_length": 1
          }, {
              "id": 3411,
              "description": "\u5148\u8fd9\u4e48\u5b9a\u5427\uff0c\u4f60\u5230\u65f6\u5019\u628a\u4f1a\u8bae\u9080\u8bf7\u53d1\u7ed9\u6211\u3002",
              "options": [{
                  "id": 1,
                  "point": -1,
                  "description": "\u597d\u7684\u3002\u603b\u7b97\u628a\u95ee\u9898\u90fd\u8c08\u5b8c\u4e86\uff0c\u4eca\u5929\u8c22\u8c22\u4e86\uff01\u6539\u5929\u8bf7\u4f60\u5403\u996d\uff01",
                  "short_description": null,
                  "addition": "",
                  "selected": false,
                  "ka": -1,
                  "nextQuestionId": 3413
              }, {
                  "id": 2,
                  "point": 4,
                  "description": "\u597d\u7684\u3002\u4f60\u7684\u652f\u6301\u5bf9\u6211\u4eec\u6765\u8bf4\u592a\u91cd\u8981\u4e86\uff0c\u4eca\u5929\u771f\u662f\u8c22\u8c22\u4e86\u3002\u76f8\u4fe1\u6211\u4eec\u7684\u52aa\u529b\u5f88\u5feb\u5c31\u80fd\u8ba9\u987e\u5ba2\u770b\u5230\u53d8\u5316\u3002",
                  "short_description": null,
                  "addition": "",
                  "selected": false,
                  "ka": 4,
                  "nextQuestionId": 3414
              }],
              "directorComment": "\u95ee\u9898\u8c08\u5f97\u5dee\u4e0d\u591a\u4e86\uff0c\u5982\u4f55\u6536\u5c3e\u5462\uff1f",
              "expression": "\u6b63\u5e38",
              "description_length": 1
          }, {
              "id": 3412,
              "description": "\u4e0d\u7528\uff0c\u7269\u6d41\u7684\u95ee\u9898\u6211\u5fc3\u91cc\u6709\u6570\u3002\u8fd9\u6837\u5427\uff0c\u7b49\u65f6\u95f4\u5b9a\u4e86\uff0c\u4f60\u53d1\u4e2a\u4f1a\u8bae\u9080\u8bf7\u7ed9\u6211\u3002",
              "options": [{
                  "id": 1,
                  "point": -1,
                  "description": "\u597d\u7684\u3002\u603b\u7b97\u628a\u95ee\u9898\u90fd\u8c08\u5b8c\u4e86\uff0c\u4eca\u5929\u8c22\u8c22\u4e86\uff01\u6539\u5929\u8bf7\u4f60\u5403\u996d\uff01",
                  "short_description": null,
                  "addition": "",
                  "selected": false,
                  "ka": -1,
                  "nextQuestionId": 3413
              }, {
                  "id": 2,
                  "point": 4,
                  "description": "\u597d\u7684\u3002\u4f60\u7684\u652f\u6301\u5bf9\u6211\u4eec\u6765\u8bf4\u592a\u91cd\u8981\u4e86\uff0c\u4eca\u5929\u771f\u662f\u8c22\u8c22\u4e86\u3002\u76f8\u4fe1\u6211\u4eec\u7684\u52aa\u529b\u5f88\u5feb\u5c31\u80fd\u8ba9\u987e\u5ba2\u770b\u5230\u53d8\u5316\u3002",
                  "short_description": null,
                  "addition": "",
                  "selected": false,
                  "ka": 4,
                  "nextQuestionId": 3414
              }],
              "directorComment": "\u95ee\u9898\u8c08\u5f97\u5dee\u4e0d\u591a\u4e86\uff0c\u5982\u4f55\u6536\u5c3e\u5462\uff1f",
              "expression": "\u51b7\u6f20",
              "description_length": 1
          }, {
              "id": 3413,
              "description": "\u5e94\u8be5\u7684\u3001\u5e94\u8be5\u7684\u3002\u4eca\u5929\u6211\u4e5f\u6709\u4e86\u4e0d\u5c11\u6536\u83b7\u3002\u6211\u4eec\u4fdd\u6301\u8054\u7cfb\u3002",
              "options": [],
              "directorComment": "\u3010\u8c08\u8bdd\u7ed3\u675f\u3011\u77ed\u671f\u65b9\u6848\u5c18\u57c3\u843d\u5b9a\uff01\u4f46\u5728\u8ba8\u8bba\u957f\u671f\u89c4\u5212\u65f6\uff0c\u5750\u7b49\u4e24\u4e09\u5468\u540e\u624d\u5f00\u7684\u4f1a\u8bae\u5e76\u4e0d\u662f\u5f88\u597d\u7684\u505a\u6cd5\u3002\u8fdb\u5165\u201c\u5173\u952e\u884c\u52a8\u89e3\u6790\u201d\uff0c\u770b\u770b\u6709\u6ca1\u6709\u65b0\u7684\u542f\u53d1\u3002",
              "expression": "\u63a5\u53d7",
              "description_length": 1
          }, {
              "id": 3414,
              "description": "\u5e94\u8be5\u7684\u3002\u4eca\u5929\u6211\u4e5f\u6709\u4e86\u4e0d\u5c11\u6536\u83b7\u3002\u4ee5\u540e\u6211\u4eec\u4fdd\u6301\u6c9f\u901a\uff0c\u6709\u95ee\u9898\u591a\u591a\u4ea4\u6d41\u3002",
              "options": [],
              "directorComment": "\u3010\u8c08\u8bdd\u7ed3\u675f\u3011\u77ed\u671f\u65b9\u6848\u5c18\u57c3\u843d\u5b9a\uff01\u4f46\u5728\u8ba8\u8bba\u957f\u671f\u89c4\u5212\u65f6\uff0c\u5750\u7b49\u4e24\u4e09\u5468\u540e\u624d\u5f00\u7684\u4f1a\u8bae\u5e76\u4e0d\u662f\u5f88\u597d\u7684\u505a\u6cd5\u3002\u8fdb\u5165\u201c\u5173\u952e\u884c\u52a8\u89e3\u6790\u201d\uff0c\u770b\u770b\u6709\u6ca1\u6709\u65b0\u7684\u542f\u53d1\u3002",
              "expression": "\u63a5\u53d7",
              "description_length": 1
          }],
          "currentQuestionId": 0,
          "currentOptionId": 0,
          "finishedQuestions": 0,
          "import": "\u5feb\u8bf7\u8fdb\uff01\u54ce\u5440\u5b9e\u5728\u62b1\u6b49\uff0c\u65e9\u5c31\u6536\u5230\u4f60\u7684\u90ae\u4ef6\u4e86\uff0c\u4f46\u6700\u8fd1\u5b9e\u5728\u592a\u5fd9\uff0c\u9700\u6c42\u591a\u5f97\u4e0d\u5f97\u4e86\u3002\u7ed3\u679c\u4e00\u76f4\u62d6\u5230\u4eca\u5929\uff0c\u6020\u6162\u4e86\u3001\u6020\u6162\u4e86\u3002",
          "headimgurl": "http:\/\/thirdwx.qlogo.cn\/mmopen\/vi_32\/Q0j4TwGTfTKQwWe5Md80I1UUV3SicTic6DnY2NNtIugicKaQHs36WNLmodYicqXicOibIncSUDKHyBvm7dzx1V461ZQg\/132"
      }
  }*/

}



// WEBPACK FOOTER //
// ./src/app/case-practice-influence-main/case-practice-influence-main.component.ts